import React, { useState, useEffect } from "react";
import { confirm } from "react-confirm-box";
import { Link } from "react-router-dom";
//import { render } from "react-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import axios from 'axios';
import sadelem from "./elem/sadelem";
import ivnelem from "./elem/ivnelem";
import itmelem from "./elem/itmelem";

import saveAs from 'file-saver';
import { useNavigate } from 'react-router-dom'

import R_VAL_Stv from './../R_VAL_Stv';
import R_VAL_ComputeTotal from './../R_VAL_ComputeTotal';


import Waitcursor from "./Waitcursor";
const util = require('util');
//import "./waitcursor.js"
//import fetchNoCors from "fetch-no-cors";


/*
     const refTAR_HSC_NB1 = useRef();
 const refTAR_HSC_NB2 = useRef();
 const refTAR_PRC_EXT = useRef();
value={state.Fld_33a} 


location: {"pathname":"/sad","search":"","hash":"","state":{"instance_id":333333},"key":"g7n2uccd"}
https://adityatyagi.com/index.php/2022/02/04/a-guide-to-working-with-forms-and-input-fields-in-react/
*/


var waitmin=0;
var waitsec=0;
var currCity='Sad';


var intervalId ;

const RenderSad = (props) => {

const awcurl=sessionStorage.getItem("AWC_URL");
const awsurl=sessionStorage.getItem("AWS_URL");
const resturl=sessionStorage.getItem("REST_URL");
//const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const customspremurl="https://customsprem.gov.tc/";


//console.log('AW_USERNAME: '+(sessionStorage.getItem("AW_USERNAME")==null));

const navigate = useNavigate();


    
$(document).ready(function(){
  $(".btnshowsad").click(function(){
  $('.panel').toggleClass('expand');
    //$("p").slideToggle();
	return false;
  });
});



const [doctime, setDoctime] = useState('00:00');
const [txtphrase, setTxtphrase] = useState({phrase:''});
const [autoplay, setAutoplay] = useState({on:0});
const [dowait, setDowait] = useState({show:false});
const [dlwait, setDlwait] = useState({show:false});

const [transkey, setTranskey] = useState({
instid:0
,seqno:0
,LOCK_INFO:''
});


const [tblvehicles, setTblvehicles] = useState([]);
const [ctrycodes, setCtrycodes] = useState([]);
const [ctrynames, setCtrynames] = useState([]);
const [progress, setProgress] = useState({
perct:null
});


const [axiofl, setAxiofl] = useState({
selectedFile: null
});


const [tblchangeditems, setTblchangeditems] = useState([]);
const [tbldetails, setTbldetails] = useState([]);
const [verifyerrors, setVerifyerrors] = useState({htm:''});
const [sadpg, setSadpg] = useState({DEC_COD:'', DEC_NAM:'', RQS_TYP:'', RQS_DAT:'', USERNAME:''});


const [comboitemvalue, setComboitemvalue] = useState({
options: null
});



const [toolbaricon, setToolbaricon] = useState({
title: ""
});	


const [lsCpc, setLsCpc] = useState([]);
const [tariffexpert, setTariffexpert] = useState({
hs1:[]	
,hs2:[]	
,hs4:[]
,hs8:[]	
});






const [tblvoucherstopay, setTblvoucherstopay] = useState({
htm:null
});


const [arrdocno, setArrdocno] = useState([]);
const [taxamt, setTaxamt] = useState([]);
const [combobnf, setCombobnf] = useState([]);

const [userattdoc, setUserattdoc] = useState({
 KEY_ITM_NBR:0
, KEY_RNK:0
});
const [attachdocs, setAttachdocs] = useState({
htm:null
});


const [inspact, setInspact] = useState({
INSTANCE_ID: ''
,op_date:''
,SAD_SID:''
,SAD_REG_SER: ''
,SAD_REG_NBR: ''
,SAD_REG_DAT: ''
,SAD_AST_SER: ''
,SAD_AST_NBR: ''
,SAD_AST_DAT: ''
,SAD_DEC_REF_YEA: ''
,SAD_DEC_REF_NBR: ''
,SAD_DEC_COD: ''
,SAD_DEC_NAM: ''
,SAD_MOD: ''
,IDE_CUO_COD: ''
,IDE_CUO_NAM: ''
,INF: ''
,PTY_FRM_NBR: ''
,PTY_FRM_TOT: ''
,PTY_NBR_LDL: ''
,SAD_AMT_REV: ''
,SAD_AMT_RFD: ''

});

const [containers, setContainers] = useState({
KEY_RNK: null
, ITM_NBR: null
, IDT: null
, TYP: null
, FUL: null
, WTC: null
, GDS: null
, PKG_TYP: null
, PKG_NBR: null
, PKG_WGT: null
,htm:null
});



const [tblvouchers, setTblvouchers] = useState({
INSTANCEID:0
, htm:null
});

const [asmtnotice, setAsmtnotice] = useState({
FIN_MPN:null
,FIN_ACC:null
,REG_NBR:null
,DEC_NAM:null
,CMP_NAM:null
,WGT_NET:null
,TAR_PRI:null
,PCK_NBR:null
,htm:null
});



const [itemnumoptions, setItemnumoptions] = useState({
htm:null
});





const [bol, setBol] = useState({
INSTANCE_ID: ''
, IDE_CUO_COD: ''
, IDE_CUO_NAM: ''
, IDE_VOY: ''
, IDE_DAT: ''
, IDE_REF: ''
, IDE_BAR: ''
, GEN_ARR_DAT: ''
, GEN_ARR_TIM: ''
, GEN_REG_YEA: ''
, GEN_REG_NBR: ''
, GEN_REG_DAT: ''
, GEN_REG_TIM: ''
, GEN_CAR_COD: ''
, GEN_CAR_NAM: ''
, GEN_CAR_ADD: ''
, GEN_SHI_COD: ''
, GEN_SHI_NAM: ''
, GEN_TON_LDS: ''
, GEN_TPT_NAM: ''
, GEN_TPT_MOT_COD: ''
, GEN_TPT_MOT_NAM: ''
, GEN_TPT_NAT_COD: ''
, GEN_TPT_NAT_NAM: ''
, BOL_LIN: ''
, BOL_SLI: ''
, BOL_STA: ''
, BOL_PRV: ''
, BOL_NAT: ''
, BOL_UCR: ''
, BOL_CTN: ''
, BOL_GRS: ''
, BOL_CBM: ''
, BOL_SUB: ''
, BOL_TYP_COD: ''
, BOL_TYP_NAM: ''
, BOL_EXP_COD: ''
, BOL_EXP_NAM: ''
, BOL_CON_COD: ''
, BOL_CON_NAM: ''
, BOL_EXP_ADD: ''
, BOL_PCK_NBR: ''
, BOL_OPE_PKA: ''
, BOL_OPE_WGA: ''
, BOL_GDS_DSC: ''
});




const [item, setItem] = useState({
 INSTANCEID: ''
, KEY_ITM_NBR: ''
,HAS_CHANGED:0
,CPF:''
,TAR_VDT: ''
,TAR_ATT: ''
,TAR_SUP_COD: ''
,TAR_SUP_NAM: ''
,TAR_SUP_QTY: ''
,VIT_CIF: ''
, VIT_CST: ''
, PCK_NBR: ''
, PCK_TYP_COD: ''
, PCK_TYP_NAM: ''
, PCK_MRK1: ''
, PCK_MRK2: ''
, TAR_HSC_NB1: ''
, TAR_HSC_NB2: ''
, TAR_PRC_EXT: ''
, TAR_PRC_NAT: ''
, TAR_QUO: ''
, TAR_PRI: ''
, VIT_STV: ''
, GDS_ORG_CTY: ''
, GDS_DSC: ''
, GDS_DS3: ''
, LNK_TPT: ''
, LNK_PRV_DOC: ''
, LNK_PRV_WHS: ''
, TXT_FRE: ''
, TXT_RSV: ''
, TAX_AMT: ''
, TAX_MOP: ''
, VIT_WGT_GRS: ''
, VIT_WGT_NET: ''
, VIT_ADJ: ''


, VIT_INV_AMT_FCX: ''
, VIT_EFR_AMT_FCX: ''
, VIT_IFR_AMT_FCX: ''
, VIT_INS_AMT_FCX: ''
, VIT_OTC_AMT_FCX: ''
, VIT_DED_AMT_FCX: ''

, VIT_INV_AMT_NMU: ''
, VIT_EFR_AMT_NMU: ''
, VIT_IFR_AMT_NMU: ''
, VIT_INS_AMT_NMU: ''
, VIT_OTC_AMT_NMU: ''
, VIT_DED_AMT_NMU: ''

, VIT_INV_CUR_RAT: ''
, VIT_EFR_CUR_RAT: ''
, VIT_IFR_CUR_RAT: ''
, VIT_INS_CUR_RAT: ''
, VIT_OTC_CUR_RAT: ''
, VIT_DED_CUR_RAT: ''


, VIT_INV_CUR_COD: ''
, VIT_EFR_CUR_COD: ''
, VIT_IFR_CUR_COD: ''
, VIT_INS_CUR_COD: ''
, VIT_OTC_CUR_COD: ''
, VIT_DED_CUR_COD: ''


, VIT_INV_CUR_REF: ''
, VIT_EFR_CUR_REF: ''
, VIT_IFR_CUR_REF: ''
, VIT_INS_CUR_REF: ''
, VIT_OTC_CUR_REF: ''
, VIT_DED_CUR_REF: ''


});


const [lsitem, setLsitem] = useState([]);
const [lsitemtax, setLsitemtax] = useState([]);


const [itemtax, setItemtax] = useState({
htm:''	
,INSTANCEID: ''
,KEY_ITM_NBR: ''
,KEY_TAX_RNK: ''
,SUM_TAX_LIN_AMT: ''
,TAX_LIN_COD: ''
,TAX_LIN_BSE: ''
,TAX_LIN_RAT: ''
,TAX_LIN_AMT: ''
,TAX_LIN_MOP: ''
,TAX_LIN_TYP: ''

});


const [selItem, setSelItem] = useState({
nbr:1
});


const [itemstbl, setItemstbl] = useState({
htm:null
});

	
const [sad, setSad] = useState({
INSTANCEID: ''
,REG_NBR_KEY:''
,GEN_CTY_ORG: ''
,VGS_INV_AMT_FCX: ''
,VGS_INV_AMT_NMU: ''
,FIN_GTY_AMT: ''
,FIN_GTY_DAT: ''
,FIN_AMT_FEE: ''
,FIN_AMT_DTY: ''
,TPT_CTF: ''
,PTY_NBR_PCK: ''
,PTY_COL_DSC: ''
,CLR_DAT:''
,VGS_INV_CUR_RAT: ''
,TPT_TOD_COD: ''
,TPT_TOD_PLC: ''
,IDE_PST_NBR: ''
,TPT_MOT_BRD_COD: ''
,TPT_MOT_BRD_NAM: ''
,TPT_MOT_DPA_CTY: ''
,TPT_MOT_DPA_NAM: ''
,TPT_LOC: ''
,FIN_AMT_TBP: ''
,FIN_MPN: ''
,CMP_CON_COD: ''
,CMP_CON_NAM: ''
,DEC_REF_YER: ''
,DEC_REF_NBR: ''
,IDE_REG_SER: ''
,IDE_REG_NBR: ''
,IDE_REG_DAT: ''
,CMP_EXP_NAM: ''
,IDE_AST_SER: ''
,IDE_AST_NBR: ''
,IDE_AST_DAT: ''
,DEC_COD: ''
,DEC_NAM: ''
,PTY_NBR_ITM: ''
,IDE_CUO_COD: ''
,IDE_CUO_NAM: ''
,IDE_TYP_SAD: ''
,IDE_TYP_PRC: ''
,AST_RYR:''
,IDE_MAN: ''
,FIN_ACC: ''
,GEN_CTY_FLT: ''
,GEN_CTY_TRD: ''
,GEN_CTY_EPT_COD: ''
,GEN_CTY_EPT_NAM: ''
,GEN_CTY_DES_COD: ''
,IDE_RCP_DAT: ''
,IDE_RCP_SER: ''
,IDE_RCP_NBR: ''
,VCL_REF: ''
,DEC_REP: ''
,INSP_ACT_INSTANCE_ID:''
});


/*
14
,TXT_FRE: ''
,TXT_RSV: ''
,TAR_HSC_NB1: ''
,LNK_TPT: ''
, PCK_MRK1: ''
, PCK_MRK2: ''
, GDS_DSC: ''
, GDS_DS3: ''
, TAR_VDT: ''
, TAR_ATT: ''
, PCK_TYP_COD: ''
, PCK_TYP_NAM: ''
, PTY_NBR_PCK: ''
,TAR_SUP_COD: ''
,TAR_SUP_NAM: ''
,TAR_SUP_QTY: ''
,TAR_PRI: ''
,VIT_CIF: ''
,VIT_ADJ: ''
,VIT_STV: ''
,VIT_WGT_GRS: ''
,VIT_WGT_NET: ''
, VGS_INV_AMT_FCX: ''
, VGS_INV_CUR_RAT: ''

*/        
		
const location = useLocation();
//const [content, setContent] = useState(null);
/*
const [instanceid, setInstanceid] = useState(null);
const [tarcod, setTarcod] = useState(null);
const [cmpnam, setCmpnam] = useState(null);
const [expnam, setExpnam] = useState(null);
const [decref, setDecRef] = useState(null);
const [regnum, setRegnum] = useState(null);
const [dataRows, setDataRows] = useState(null);
const [allDataRows, setAllDataRows] = useState(null);

*/

  useEffect(() => {
	  document.title =   "Vouchers & SAD";	
	  
if (sessionStorage.getItem("AW_USERNAME")==null){
	navigate("../logout");
	return;
	}
	
	  
	  smallpopup('pe',0);
	  smallpopup('ts',0);
	  smallpopup('mss',0);
	  smallpopup('vfy',0);
  openCity(null,'wait');
  
  
  var sad_payment_groupid = !location.state.sad_payment_groupid?0:location.state.sad_payment_groupid;
  var instanceid = !location.state.instanceid?0:location.state.instanceid;
 // var from_sad_finder = !location.state.from_sad_finder?0:location.state.from_sad_finder;
  
  if (sad_payment_groupid>0)
	  getspgdecnam();
  else
	fetchsad(instanceid);
	
  
      },[]);





 useEffect(() => {

	 console.log("useEffect currCity: "+currCity);
	 
if (currCity!='itemValueNote'){
	/*be careful of the condition selItem.nbr==0 which is set in OpenCity(SadList)*/
	console.log("useEffect selItem.nbr: "+selItem.nbr);
	if (selItem.nbr==1)
		openCity(null, "Sad");
	else if (selItem.nbr>1)
		openCity(null, "Item");
	
	}//end if

/*
	 const itmNum=selItem.nbr;
if (currCity!='itemValueNote'){
	const cityName=(itmNum==1)?"Sad":"Item";
	openCity(null, cityName);
	}//end if

*/

 },[selItem.nbr]);

 useEffect(() => {

if (autoplay.on==1)
	startAutoPlay();	 
  },[JSON.stringify(itemtax)]);



 useEffect(() => {

if (sadpg.DEC_NAM=="*")
	getspgdecnam();
else if (sadpg.DEC_NAM!="")
	gettblvouchers();

  },[sadpg.DEC_NAM]);



 useEffect(() => {
	 //document.getElementsByName("selitemnbr")[0].style.backgroundColor=autoplay.on==1?"red":"green";
 },[autoplay.on]);

 useEffect(() => {
	 /*document.getElementById("cbautoplay").style.visibility=itemstbl.length==0?"hidden":"visible";*/
 },[JSON.stringify(itemstbl)]);



 useEffect(() => {
	 
	 if (lsitem.length>0)
		if (lsitem[0].KEY_ITM_NBR==0){
			//selectitem (sad.INSTANCEID, 1, sad.PTY_NBR_ITM);
			}
			//selectitem will call fetchitem(sad.INSTANCEID, 1);
	 mktblchangeditems();
 },[JSON.stringify(lsitem)]);


 useEffect(() => {
	console.log('afterSetTariffexpert');
	
	const sel = document.getElementsByName('tariffexpert_hs2')[0];
	
	if (document.getElementsByName('tariffexpert_hs1')[0].value==''){
		sel.setAttribute('size', 1);
		return;
		}

if (sel){
	var len = sel.options.length;
	console.log('sel.len: '+len);
	sel.setAttribute('size', len);	
	}
	
/*
	window.showState = function (str) {
		var dropdown = document.getElementById('tariffexpert_hs2');
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('mousedown', true, true, window);
		dropdown.dispatchEvent(event);
	}//end func

*/
	 
 },[tariffexpert]);


/*
 useEffect(() => {
	 
	 if (itemtax.htm!=''){
			let temp=lsitemtax;
			temp[itemtax.KEY_ITM_NBR-1]=itemtax;
			//01may2023 not sure how this was working but now I call setLsitemtax at end of frmitemtax
			//setLsitemtax(temp);
			}//end if
	 
 },[itemtax]);

*/
 




	  
  useEffect(() => {
//setInspact(getemptystate(inspact));
//if (transkey.instid>0) {getseqno(transkey.seqno)}; 
  //setTblinspacts({htm:null});
  if (!sad.INSTANCEID)
	  return;
  
  if  (sad.INSTANCEID>0){
	  const evt={currentTarget:document.getElementById('tablinksad')};
	//setLsitem([]);
	selectitem(sad.INSTANCEID,1, sad.PTY_NBR_ITM); 
	}//end if

      },[sad]);




  
  useEffect(() => {
  if (arrdocno.length>0)
	openmodal('modalVouchers',0);
      },[JSON.stringify(arrdocno)]);

  useEffect(() => {
	  console.log("tblvouchers.length: "+tblvouchers.length);
/*
		if (tblvouchers.INSTANCEID>0)
			fetchsad(tblvouchers.INSTANCEID);
		else{
			}//end else

*/

	if (tblvouchers.NUM_SAD>0){
		 console.log("location.state.fetchinstanceid: "+location.state.fetchinstanceid);
		if (location.state.fetchinstanceid)
			fetchsad(location.state.fetchinstanceid);
		else
			openCity(null, "SadList");
		}//end if
		

      },[JSON.stringify(tblvouchers)]);

  useEffect(() => {
  
  console.log("sadpg: "+JSON.stringify(sadpg));
  
      },[JSON.stringify(sadpg)]);
 



    function onFileChange(event) {
 
        // Update the state
        setAxiofl({ selectedFile: event.target.files[0] });
 
    }//end function
	
	
	   
 async function onFileUpload () {
 // On file upload (click the upload button)
 /*
        // Create an object of formData
        const formData = new FormData();
 
        // Update the formData object
		formData.append('REG_NBR', sad.IDE_REG_SER+' '+sad.IDE_REG_NBR);
		formData.append('file', axiofl.selectedFile, axiofl.selectedFile.name);
 
        // Details of the uploaded file
        console.log(axiofl.selectedFile);
 
        // Request made to the backend api
        // Send formData object
		try{
        await axios.post(resturl+'rarsad/uploadattdoc', formData);
		} catch (error) {
  console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
  'Authorization': `Bearer ${access_token}`,
 */
 const url=resturl+'rarsad/uploadattdoc';
 const FormData = require('form-data'); // npm install --save form-data

const form = new FormData();
form.append('REG_NBR', sad.IDE_REG_SER+' '+sad.IDE_REG_NBR);
form.append('file', axiofl.selectedFile, axiofl.selectedFile.name);
form.append('filename', axiofl.selectedFile.name);
form.append('INSTANCEID', sad.INSTANCEID);
form.append('KEY_ITM_NBR', item.KEY_ITM_NBR);
form.append('COD', '380');
form.append('NAM', 'Commercial Invoice');
form.append('REF', axiofl.selectedFile.name);
form.append('RUL', 1);


const request_config = {
    onUploadProgress: data => {
      //Set the progress value to show the progress bar
      setProgress({perct:Math.round((100 * data.loaded) / data.total)});
    },
};
axios.post(url, form, request_config);
  }//end function
	

function inspactPrompt(e){

	e.preventDefault();
	
	console.log('sad.INSP_ACT_INSTANCE_ID: '+sad.INSP_ACT_INSTANCE_ID);
	if (sad.INSP_ACT_INSTANCE_ID==undefined || sad.INSP_ACT_INSTANCE_ID==null || sad.INSP_ACT_INSTANCE_ID==0){
		window.alert('No Inspection Act has been created');
		}//end if
	else{
		fetchInspAct(sad.INSP_ACT_INSTANCE_ID);
		}//end else
		
	
	//onClick={(e) => { e.preventDefault(); navigate(`/inspact`,{state:{INSP_ACT_INSTANCE_ID:sad.INSP_ACT_INSTANCE_ID}}); }}
}//end func
	  
function fetchInspAct(instance_id){
console.log('fetchInspAct instance_id: '+instance_id);
//setInstanceid(instance_id);

if (instance_id=='' || instance_id==undefined){
	console.log('Inspection act was not created');
	return;
	}
	

const params={
INSTANCE_ID: instance_id
}//end function

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

  fetch(resturl+'rarinspact/getinspact',requestOptions)
      .then(res => res.json())
      .then(res => frminspact(res))
      .catch(err => console.log(err));
	  

}//end func  

function frminspact(res){

var datas={};

for(var attributename in inspact){
	const data=res[0][attributename];
	datas[attributename] = (data==null)?'':data;
	}//end for


setInspact(datas);
openCity(null, "InspectionAct");

return false;
}//end function	

function showModal(flag) {
	if(flag==1)
		document.querySelector(".modal").classList.add("show-modal");
	else if(flag==0)
		document.querySelector(".modal").classList.remove("show-modal");
}//end func

function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}//end func


function comboitemvalues(TAR_PRI, VIT_STV, VGS_INV_AMT_FCX){
	
//let arrOptions='1800.50,2000.50,2400.50,2800.50,3200.50,3600.50'.split(',');	
let arrOptions='1800,2000,2400,2800,3200,3600'.split(',');	
let htmoptions=[];
for (var i=0; i<arrOptions.length; i++){
	const currvalue=arrOptions[i];
	const key="key"+i;
	
	console.log("comboitemvalues "+TAR_PRI+", "+VIT_STV+", "+VGS_INV_AMT_FCX);
	
	if (1*currvalue!=1*TAR_PRI && 1*currvalue!=1*VIT_STV && 1*currvalue!=1*VGS_INV_AMT_FCX)
		htmoptions.push(<option key={key} value={currvalue}>{currvalue}</option>);
	}//end for

//console.log("htmoptions "+JSON.stringify(htmoptions));
setComboitemvalue({"options":htmoptions});
	
}//end func

function setGoodsValue(e){
	console.log("setGoodsValue to "+e.target.value);

const str_value=e.target.value;
if (str_value=='')
	return;
/*
let tempitem={"TAR_PRI":100, "VIT_STV":100};
tempitem={...tempitem, "TAR_PRI":str_value};
tempitem={...tempitem, "VIT_STV":str_value};
console.log('tempitem: '+JSON.stringify(tempitem));

	const event1={
		target:{name:"TAR_PRI",value:str_value}
		};
	handleItemChange(event1);

	const event2={
		target:{name:"VIT_STV",value:str_value}
		};
	handleItemChange(event2);

*/


setItem((prev) => {
return {...prev, "VIT_INV_AMT_FCX":str_value}
});


setItem((prev) => {
return {...prev, "VIT_INV_AMT_NMU":str_value}
});

let temp={...item, "VIT_INV_AMT_FCX":str_value, "VIT_INV_AMT_NMU":str_value};
setLsitem(prevState => [...prevState, temp]);


	
	

	const event3={
		target:{name:"VGS_INV_AMT_FCX",value:str_value}
		};
	handleSadChange(event3);

	


}//end func


async function fetchCtrycodes(){
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };

  fetch(resturl+'rarsad/fetchctrycodes',requestOptions)
      .then(res => res.json())
      .then(res => afterfetchctrycodes(res))
      .catch(err => console.log(err));	  
	
	
}//end func

async function cancelreqs(e){

e.preventDefault();
	
	const result=window.confirm("cancel this request for voucher?");
	
	if (!result)
		return;
	
	const params={
		SAD_PAYMENT_GROUPID:location.state.sad_payment_groupid
		, AW_USERNAME:sessionStorage.getItem("AW_USERNAME")
		};
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

  fetch(resturl+'rarsad/cancelreqs',requestOptions)
      .then(res => res.json())
      .then(res => aftercancelreqs(res))
      .catch(err => console.log(err));	  
	
	
}//end func

function aftercancelreqs(res){
	if (res.length==undefined)
		showsnackbar("The operation seemed to have failed");
	else if (res[0].CANCELLED_COUNT>0)
		showsnackbar("The voucher request was cancelled!");
	else 
		showsnackbar("The operation seemed to have failed");
	
}//end func

function afterfetchctrycodes(res){
let arrCodes=[];
let arrNames=[];
res.map((col, index) => {
	const key="ctrycodes_"+index;
	const cod=col['CTY_COD'];
	const nam=col['CTY_DSC'];
	//console.log('afterfetchctrycodes nam: '+nam);
	
	arrCodes.push(<option key={key+"_cod"} value={cod} >{cod}</option>);
	arrNames.push(<option key={key+"_nam"} value={nam} >{nam}</option>);
	});//end map

setCtrycodes(arrCodes);
setCtrynames(arrNames);
}//end func
	
async function senddatatodb(args, instanceid, seqno) {
	
if (seqno==null || seqno=='null'){
	alert('seqno is null, close SAD and open again');
	return;
	}//end if

let lschangeditems=[];
for (var i=0; i<lsitem.length; i++){
	if (lsitem[i].HAS_CHANGED>0 && lsitem[i].KEY_ITM_NBR)
		lschangeditems.push(lsitem[i]);
	}//end for

	
const params={
INSTANCEID:instanceid
, SAD_PAYMENT_GROUPID:0
, SEQNO:seqno
, OPER: args
, username: sessionStorage.getItem("AW_USERNAME")
, FIN_ACC: sad.FIN_ACC
, CMP_EXP_NAM: sad.CMP_EXP_NAM
, GEN_CTY_ORG: sad.GEN_CTY_ORG
, GEN_CTY_EPT_COD: sad.GEN_CTY_EPT_COD
, GEN_CTY_EPT_NAM: sad.GEN_CTY_EPT_NAM
, GEN_CTY_FLT: sad.GEN_CTY_FLT
, GEN_CTY_TRD: sad.GEN_CTY_TRD
, TPT_MOT_BRD_COD: sad.TPT_MOT_BRD_COD
, TPT_MOT_DPA_CTY: sad.TPT_MOT_DPA_CTY
, TPT_MOT_DPA_NAM: sad.TPT_MOT_DPA_NAM
, TPT_LOC: sad.TPT_LOC
, VGS_INV_AMT_NMU: sad.VGS_INV_AMT_NMU
, VGS_INV_AMT_FCX: sad.VGS_INV_AMT_FCX
, INSP_ACT_INSTANCE_ID: ''
, INF: ''
, lsitem: lschangeditems
};
  
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

  fetch(resturl+'rarsad/senddatatodb',requestOptions)
      .then(res => res.json())
      .then(res => sendtoawc(args, transkey.instid, transkey.seqno))
      .catch(err => console.log(err));	  
  
 //op=postentry 
}//end func

async function getprepinsertdoc() {

	
var result=false;

/*
previously checked here if vouchers already created.
Now this is returned by the server checking the database
if (taxamt[0].DOC_NO!='' || taxamt[1].DOC_NO!='' || taxamt[2].DOC_NO!='' || taxamt[3].DOC_NO!='' || taxamt[4].DOC_NO!=''){
	alert('vouchers were created already');
	console.log('taxamt[0].ICD: '+taxamt[0].AMT);
	return;
	}//end if
else 

*/

result=await confirm('payment vouchers will be created.  are you sure?');
	
if (result==false)
	return;
	
/*
K.R. LOGISTICS AND SERVICES LTD.
if (!sessionStorage.getItem("IRD_EMPLOYEE_NO"))	
	sessionStorage.setItem("IRD_EMPLOYEE_NO", "328");
else
if (sessionStorage.getItem("IRD_EMPLOYEE_NO")=="")	
	sessionStorage.setItem("IRD_EMPLOYEE_NO", "328");
*/
	
const params={
 SAD_PAYMENT_GROUPID: location.state.sad_payment_groupid
, IRD_EMPLOYEE_NO:sessionStorage.getItem("IRD_EMPLOYEE_NO")//328
};
//IRD_EMPLOYEE_NO: 328
//taxamt: taxamt
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

  fetch(resturl+'rarsad/getprepinsertdoc',requestOptions)
      .then(res => res.json())
      .then(res => insertprepdoc(res))
      .catch(err => console.log(err));	
	
//console.log('vouchers: '+JSON.stringify(vouchers));
}//end func


function insertprepdoc(res){
	
console.log('insertprepdoc res: '+JSON.stringify(res));
if (!res.length){
	showsnackbar("no records were found to send for voucher creation.<br/>please try again or contact admin.");
	return;
	}//end if

/*
here we check if the db returned docs that were previously generated but client did not update
*/
if (res.length==10){
	const docs=res[0];
	if (docs.length){
		console.log("insertprepdoc will call afterinsertprepdoc with docs.length: "+docs.length);
		afterinsertprepdoc(docs);//this will update the client with the doc nos
		}//end if
	return;
	}//end if
	

const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( res )
};		

fetch(customspremurl+'rarjobq/insertprepdoc',requestOptions)
  .then(res => res.json())
  .then(res => 	afterinsertprepdoc(res) )
  .catch(err => console.log(err));	
	
}//end func


function afterinsertprepdoc(res){	
	
	const params={
	docs:res
	, SAD_PAYMENT_GROUPID:location.state.sad_payment_groupid
	, USERNAME:sessionStorage.getItem("USERNAME")
	, DEC_COD:sad.DEC_COD
	, AW_USERNAME:sessionStorage.getItem("AW_USERNAME")
	}
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };	

  fetch(resturl+'rarsad/updatedocno',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatedocno(res) )
      .catch(err => console.log(err));		
	
}//end func

function afterupdatedocno(res){

	//console.log("afterupdatedocno: "+JSON.stringify(res));
	if (res.length==undefined)
		showsnackbar("afterupdatedocno res.length==undefined");
	else
		showsnackbar("vouchers numbers should display.  wait before download pdf.");
	aftergettblvouchers(res);
	{/*
	//reload the table
	call either  aftergettblvouchers(res) or gettblvouchers();
	aftergettblwptappudak(res);
	showsnackbar('document numbers should be displayed. an email will be sent to customer with the vouchers attached');
	*/}
}

function getemptystate(objName){
     let emptyState = {};
    for (const key in objName){
        emptyState = {...emptyState, [key] : null}
    }//end for
	
return emptyState;

}//end func

function fetchvoucherstopay(resx){


const params={
 SAD_PAYMENT_GROUPID: location.state.sad_payment_groupid
, AW_USERNAME: location.state.aw_username
, DEC_COD: location.state.dec_cod
}

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

  fetch(resturl+'rarsad/getvoucherstopay',requestOptions)
      .then(res => res.json())
      .then(res => jsxvoucherstopay(res))
      .catch(err => console.log(err));


//showsnackbar('number of vouchers created: '+res.numvouchers);
}//end func

function voucherfileexists(){

console.log('arrdocno: '+JSON.stringify(arrdocno));
//console.log('tblvoucherstopay: '+tblvoucherstopay.htm);


const params={
 DOC: arrdocno
}

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

  fetch(resturl+'rarsad/checkdiskfiles',requestOptions)
      .then(res => res.json())
      .then(res => {aftercheckdiskfiles(res);})
      .catch(err => console.log(err));


}//end if

function aftercheckdiskfiles(res){
res.map((col, index) => {
	//console.log(col.DOC);
	document.getElementById('DOC'+col.DOC).style.visibility='visible';
	});//end map

/*
console.log('arrdocno.length: '+arrdocno.length	);
console.log('res.length: '+res.length	);
console.log('res: '+JSON.stringify(res)	);

*/	
if (res.length>0 && res.length==arrdocno.length){
	clearInterval(intervalId);
	}//end if
	
}//end if

function jsxvoucherstopay(res){

let htmrows=[];
let arrdoc=[];
var rownum=1;
//<img src='images/pdficon_small.gif' border=0 title='click to download voucher' />
res.map((col, index) => {
		const url=col['URL'];
		const doc=col['DOC_NO'];
		const key='jsxvoucherstopay'+index;
		const linkid = "DOC"+col['DOC_NO'];
		arrdoc.push({
		DOC:doc
		,SIZE:0
		});
	htmrows.push(<tr key={key} >
		<td align="right" >{rownum}</td>
		<td align="center" >{col['DATED']}</td>
		<td align="center" >{doc}</td>
		<td align="right" >{col['TAX_AMT']}</td>
		<td align="right" ><a href={url} target="_none" style={{"visibility":"hidden"}} name='DOC_NO[]' id={linkid} value={doc} ><img src='img/pdf.gif' /></a></td>
		<td align="left" >{col['TAX_TYPE_DESC']}</td>
		<td align="left" >{col['LS_REGNUM']}</td>
		</tr>
	);
	rownum++;
	}//end for
	);

setArrdocno(arrdoc);

setTblvoucherstopay({htm:htmrows});
}//end func

function handleInterval(){
if (waitsec%5==0){
	voucherfileexists();
	//document.getElementById("button1").click();
	}
	

	
waitsec+=1;

if (waitsec==60){
	waitsec=0;
	waitmin+=1;
	}//end if

let strsec=(waitsec<10)?'0'+waitsec:waitsec;
let strmin=(waitmin<10)?'0'+waitmin:waitmin;

setDoctime(strmin+':'+strsec);


}//end func

const handleTransChange = (e) => {
}//end func

const handleItemNbrChange = (itmNum) => {
//document.getElementById('btnpostentry').style.visibility='visible';
//const itmNum=e.target.value;

console.log('handleItemNbrChange itmNum:'+itmNum);

selectitem(sad.INSTANCEID,itmNum, sad.PTY_NBR_ITM); 
//setSelItem({nbr:e.target.value});
}//end func



	  const handleSadChange = (e) => {

/*
	  document.getElementById('btnverify').style.visibility='visible';
	  document.getElementById('btnpostentry').style.visibility='visible';
*/
	  //setTranskey( {...transkey, "verified":0} );

//destructure an array of objects in JavaScript
const {name, value}=e.target;
console.log('handleSadChange name, value: '+name+', '+value);
	/*the post-entry does not have the updated values if I do not console.log below*/
	setSad((prev) => {
	return {...prev, [name]:value}
	},console.log('sad.DEC_REF_NBR: '+sad.DEC_REF_NBR) )};  
	  
	  
	  const handleFocus = (e) => {
	  //e.target.blur();
/*
	  if (e.target.readOnly)
		e.target.style.background='gainsboro';
	else 
		e.target.select();
*/
		e.target.select();

		}//end func
	  
	  
	  const handleCpcChange = (cpc) => {
		  if (cpc=='' ){
			  setCombobnf([]);	
			  return;
			}	
		//  const cpc=e.target.value;
		  console.log('handleCpcChange cpc'+cpc);
		  
	const jobqoptions = JSON.parse(sessionStorage.getItem("jobqoptions"));
	let bnfRows=[];
	let rowcount=1;
	bnfRows.push(<option key={"bnf_0"} value="" ></option>);
	jobqoptions.map((col, index) => {
		const key="bnf_"+rowcount;
		if (col.BAND=='BNF' && col.DATE_RANGE.trim()==cpc.trim())
			//console.log('col.BAND: '+col.BAND);
			//console.log('col.DATE_RANGE: '+col.DATE_RANGE);
			
			bnfRows.push(<option key={key} value={col.DATE_NAME} >{col.DATE_NAME}</option>);
	rowcount++;
	});//end map	
//console.log('handleCpcChange bnfRows'+JSON.stringify(bnfRows));	
		  setCombobnf(bnfRows);	
		  /* have to set TXT_FRE to blank on the item */
		  let tempitem=item;
		  tempitem.TXT_FRE='';
		  setItem(tempitem);
		  }//end func
	  
	  	  
	  
	  const  handleItemChange = (e) => {
		 
	//destructure an array of objects in JavaScript

const {name, value}=e.target;	  
 console.log('handleItemChange name, value: '+name+', '+value);
 
			let newitem=item;
			newitem={...newitem
				  , [name]:value 
				  , HAS_CHANGED:1
				  };
			
		  if (name=='VIT_INV_AMT_FCX' || name=='VIT_EFR_AMT_FCX'){
			  //below to apply rule R_VAL_Stv
			  let temp={
				  VIT_CST:null
				  ,VIT_CIF:null
				  ,VIT_STV:null
				  ,TAR_PRI:null
				  ,INV:null
				  ,EFR:null
				  ,IFR:null
				  ,INS:null
				  ,OTC:null
				  ,DED:null
				  };
				  

				  
			  R_VAL_Stv(newitem, temp);
			  R_VAL_ComputeTotal(newitem, temp);
			  
			//console.log('temp.INV '+temp.INV);
				newitem={...newitem
				  , VIT_INV_AMT_NMU:temp.INV
				  , VIT_CST:temp.VIT_CST
				  , VIT_CIF:temp.VIT_CIF
				  , VIT_STV:temp.VIT_STV
				  , TAR_PRI:temp.TAR_PRI
				  , VIT_EFR_AMT_NMU:temp.EFR
				  , VIT_IFR_AMT_NMU:temp.IFR
				  , VIT_INS_AMT_NMU:temp.INS
				  , VIT_OTC_AMT_NMU:temp.OTC
				  , VIT_DED_AMT_NMU:temp.DED
				  , HAS_CHANGED:1
				  }
				  
		     //console.log('temp '+JSON.stringify(temp));
			}
			else{
/*
				setItem((prev) => {
				return {...prev, [name]:value, HAS_CHANGED:1}
				}, afterSetitem() );
*/
				console.log('exiting else ');
				}//end else
		
	//setCombobnf(bnfRows);	
	//console.log('newitem '+JSON.stringify(newitem));
			  
			if (name=="TAR_HSC_NB1")
				fetchtardsc(newitem);
			else{
				  setItem(newitem);
				let templsitem=lsitem;
				templsitem[item.KEY_ITM_NBR-1]=newitem;
				setLsitem(templsitem);
				}
		  //setTranskey( {...transkey, "verified":0} );
			
			
			
/*
document.getElementById('btnpostentry').style.visibility='visible';	  
document.getElementById('btnverify').style.visibility='visible';	  

*/


	//e.target.value='';
	//e.target.defaultvalue='';//item["PCK_MRK1"]
	
	/*the post-entry does not have the updated values if I do not console.log below*/
	
}
	

function fetchtardsc(newitem){
	
	    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {TAR_HSC_NB1:newitem.TAR_HSC_NB1} )
  };

  fetch(resturl+'rarsad/fetchtardsc',requestOptions)
      .then(res => res.json())
      .then(res => afterfetchtardsc(res, newitem))
      .catch(err => console.log(err));
	  
	
}//end func

function afterfetchtardsc(res, newitem){
				newitem.GDS_DSC=res[0].TAR_DSC;
				  setItem(newitem);
			  
			let templsitem=lsitem;
			templsitem[item.KEY_ITM_NBR-1]=newitem;
			setLsitem(templsitem);
}//end func

	
	
const afterSetitem = () => {
	/*
console.log('afterSetitem newitem.VIT_INV_AMT_NMU:'+VIT_INV_AMT_NMU);
console.log('afterSetitem item.VIT_INV_AMT_NMU:'+item.VIT_INV_AMT_NMU);
console.log('afterSetitem item.VIT_INV_AMT_FCX:'+item.VIT_INV_AMT_FCX);


let templsitem=lsitem;
templsitem[item.KEY_ITM_NBR-1]=item;
setLsitem(templsitem
, console.log('afterSetitem lsitem.VIT_INV_AMT_FCX: '+lsitem[item.KEY_ITM_NBR-1].VIT_INV_AMT_FCX) );



	if the changed item is in lsitem then remove it; will be added again after
	30-APR-2023 remove setLsitem here.  
	setLsitem and setLsitemtax will be called every fetchitem and fetchitemtax
for (var i=0; i<lsitem.length; i++)	{
	if (lsitem[i].KEY_ITM_NBR == item.KEY_ITM_NBR){
		const temp=lsitem;
		lsitem.splice(i, 1);
		setLsitem(temp);
		//console.log('lsitem.length: '+lsitem.length);
		}//end if
	}//end for
const temp={...item, [name]:value};
setLsitem(prevState => [...prevState, temp]);
//console.log('afterSetitem '+JSON.stringify(temp));
	*/

	

}//end func	
	
	
  


function afterfetchsad(res, startFetchSad){

toggleshowtoolbar(1);
if (res.length==undefined){
	document.getElementsByName("FETCH_TIME")[0].value='';
	showsnackbar("failed to fetch Sad");
	return;
	}//end if
	
const timeTaken = (new Date()) - startFetchSad;
const timeTakenSec = (timeTaken / 1000).toFixed(2);	

document.getElementsByName("FETCH_TIME")[0].value=timeTakenSec+' seconds';
	
var datas={};

//console.log("res: "+JSON.stringify(res)); 
for(var attributename in sad){
	const data=res[0][attributename];
	if (attributename=='FIN_ACC')
		console.log("FIN_ACC data : "+data);
	
	datas[attributename] = (data==null)?'':data;
	
	if (attributename=='FIN_ACC')
		console.log("FIN_ACC datas[attributename]: "+datas[attributename]);
	
	
	}//end for

console.log("datas.FIN_ACC: "+datas.FIN_ACC);
console.log("datas.AST_RYR: "+datas.AST_RYR);
console.log("datas.IDE_TYP_PRC: "+datas.IDE_TYP_PRC);

/*
VCL_REF col was made obselete in 2024.  Always show the vehicles
if (datas.VCL_REF==null || datas.VCL_REF=='' || datas.VCL_REF=='null')
	document.getElementById('btnVehicles').style.display='none';

*/

if (datas.TPT_CTF==null || datas.TPT_CTF=='' || datas.TPT_CTF=='null')
	document.getElementById('btnContainers').style.display='none';
	
//var jsonData=JSON.stringify(datas);
//console.log("datas: "+JSON.stringify(datas)); 
console.log("datas.PTY_NBR_ITM: "+datas.PTY_NBR_ITM);

//let temp={...item, "VIT_INV_AMT_FCX":str_value, "VIT_INV_AMT_NMU":str_value};
//setLsitem([datas.PTY_NBR_ITM]);

for (var i=0; i<datas.PTY_NBR_ITM; i++){
	// initialize the lsitem array to size datas.PTY_NBR_ITM
	const temp1={...item, KEY_ITM_NBR:0};
	setLsitem(prevState => [...prevState, temp1]);

	const temp2={...itemtax, KEY_TAX_RNK:0};
	const temp3 = [temp2, temp2, temp2, temp2, temp2];
	setLsitemtax(prevState => [...prevState, temp3]);
		
	}//end for


setSad(datas);




let htm=[];
for (var i=1; i<=datas.PTY_NBR_ITM; i++){
	const val=i;
	const key="itmNbr_"+i;
	htm.push(<option key={key} value={val} >{val}</option>);
	}//end for
setItemnumoptions({htm:htm});



}//end function	  


function jsxitemstbl(currNbr, pINSTANCEID, pPTY_NBR_ITM){

const currNbrOriginal=1*currNbr;
if (currNbr==pPTY_NBR_ITM)
	currNbr=1;

const arrL='02,03,04,05,06,07,08,09,10,11,12,13,14,15,16,17,18,19,20,21'.split(',');
const arrR='01,00,-01,-02,-03,-04,-05,-06,-07,-08,-09,-10,-11,-12,-13,-14,-15,-16,-17,-18'.split(',');
var i=0, k=0;
let htmrows=[];
currNbr=1*currNbr;
let strLnum='', strRnum='', colorL='', colorR='';

for (i=0; i<arrL.length; i++){
	const lnum=(1*arrL[i])+currNbr;
	const rnum=(1*arrR[i])+currNbr;
	const key="jsxitemstbl_tr"+i;
	const lvisib=(lnum<1 || lnum>pPTY_NBR_ITM)? "hidden":"visible";
	const rvisib=(rnum<1 || rnum>pPTY_NBR_ITM)? "hidden":"visible";

	if (lvisib=="hidden")
		strLnum="00";
	else{
		strLnum=(lnum<10)?'0'+lnum:lnum;
		colorL=(lsitem[lnum-1].KEY_ITM_NBR>0)?' colorbrown ':'';
		}//end else

	if (rvisib=="hidden")
		strRnum="00";
	else{
		strRnum=(rnum<10)?'0'+rnum:rnum;
		colorR=(lsitem[rnum-1].KEY_ITM_NBR>0)?' colorbrown ':'';
		}//end else
	
	
	const bgorangeL=(lnum==currNbrOriginal)?"bgorange":"";
	const bgorangeR=(rnum==currNbrOriginal)?"bgorange":"";
	
	htmrows.push(
		<tr key={key} >
			<td style={{"visibility":lvisib}} className={"hand "+bgorangeL+colorL} onClick={ (e) => { handleItemNbrChange(lnum); }} >{strLnum}</td>
			<td style={{"visibility":rvisib}} className={"hand "+bgorangeR+colorR} onClick={ (e) => { handleItemNbrChange(rnum); }} >{strRnum}</td>
		</tr>
		);
	}//end for

//cellSpacing="1"
const htm = <table align="center" id="tblitempicker"  cellSpacing="2" ><tbody>{htmrows}</tbody></table>;
//console.log('jsxitemstbl htm '+JSON.stringify(htm));

setItemstbl({htm:htm});
document.getElementById("cbautoplay").style.visibility="visible";

}//end func

function frmbol(res){
//console.log('item'+JSON.stringify(res));
var datas={};
for(var attributename in bol){
	const data=res[0][attributename];
	datas[attributename] = (data==null)?'':data;
	}//end for
	
setBol(datas);	
openCity(null, "Bol");
toggleshowtoolbar(1);
}//end function	  


function afterfetchitem(res){
//console.log('item'+JSON.stringify(res));
//document.getElementById("tblitempicker").style.visibility="visible";
const itemres=res[0].item;
const taxres=res[0].taxes;
var datas={};
for(var attributename in item){
	const data=itemres[0][attributename];
	datas[attributename] = (data==null)?'':data;
	}//end for
	
datas["HAS_CHANGED"]=0;
handleCpcChange(datas.TAR_PRC_NAT);
setItem(datas);	

//console.log('frmitem lsitem.length: '+lsitem.length);
//const temp={...item, [name]:value};
//setLsitem(prevState => [...prevState, datas]);

//jsxitemstbl(1, datas.INSTANCEID, datas.PTY_NBR_ITM);

let temp=lsitem;
const KEY_ITM_NBR=itemres[0].KEY_ITM_NBR;
temp[KEY_ITM_NBR-1]=datas;
setLsitem(temp);


//setItem({...item,HAS_CHANGED:0});	
//setItem(...datas, {"HAS_CHANGED":0});


/*
const TAR_PRI=datas.TAR_PRI.replace(',','');
const VIT_STV=datas.VIT_STV.replace(',','');
const VGS_INV_AMT_FCX=sad.VGS_INV_AMT_FCX.replace(',','');
comboitemvalues(TAR_PRI, VIT_STV, VGS_INV_AMT_FCX);

console.log(
  util.inspect(lsitemtax, {
    depth: 5,
    colors: true,
  }));

*/

//console.log('frmitem lsitemtax.leng: '+lsitemtax.length);
let KEY_TAX_RNK=0;
if (datas.KEY_ITM_NBR)
	if (lsitemtax.length>0){
		const tempitemtax=lsitemtax[datas.KEY_ITM_NBR-1][0];
		//console.log("tempitemtax: "+JSON.stringify(tempitemtax));
		KEY_TAX_RNK=!tempitemtax?0:lsitemtax[datas.KEY_ITM_NBR-1][0].KEY_TAX_RNK;
		
		}
		//

if (KEY_TAX_RNK==0)
	afterfetchitemtax(taxres, datas.KEY_ITM_NBR);
else{
	console.log('use fetchitemtax instead of fetchitemtax');
	setItemtax(lsitemtax[datas.KEY_ITM_NBR-1]);	
	}




}//end function	  


async function fetchTariffexpert(flag){

if (flag=='hs1'){
	document.getElementsByName('tariffexpert_hs2')[0].value='';
	document.getElementsByName('tariffexpert_hs4')[0].value='';
	}//end if
if (flag=='hs2'){
	document.getElementsByName('tariffexpert_hs4')[0].value='';
	}



/*
if (!document.getElementsByName('tariffexpert_hs1')[0] || !document.getElementsByName('tariffexpert_hs2')[0] || !document.getElementsByName('tariffexpert_hs4')[0])
	return;

var tariffexpert_hs2=document.getElementsByName('tariffexpert_hs2')[0].value;
var tariffexpert_hs4=document.getElementsByName('tariffexpert_hs4')[0].value;
	
if (flag=='hs1'){
	tariffexpert_hs2='';
	tariffexpert_hs4='';
	}
if (flag=='hs2'){
	tariffexpert_hs4='';
	}

document.getElementById('tariffexpert_hs8').style.visibility='hidden';
if (!document.getElementsByName('tariffexpert_hs1')[0] || !document.getElementsByName('tariffexpert_hs2')[0] || !document.getElementsByName('tariffexpert_hs4')[0]){
	return;
}
var tariffexpert_hs1='', tariffexpert_hs2='', tariffexpert_hs4='';
if (document.getElementsByName('tariffexpert_hs1')[0] && document.getElementsByName('tariffexpert_hs2')[0] && document.getElementsByName('tariffexpert_hs4')[0]){
	tariffexpert_hs1=document.getElementsByName('tariffexpert_hs1')[0].value;
	tariffexpert_hs2=document.getElementsByName('tariffexpert_hs2')[0].value;
	tariffexpert_hs4=document.getElementsByName('tariffexpert_hs4')[0].value;
	}
	
*/



	
	const params={
HS1_COD:document.getElementsByName('tariffexpert_hs1')[0].value
, HS2_COD:document.getElementsByName('tariffexpert_hs2')[0].value
, HS4_COD:document.getElementsByName('tariffexpert_hs4')[0].value
};

const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( params )
};

console.log('will call gettariffexpert: '+JSON.stringify(params));

await fetch(resturl+'rarsad/gettariffexpert',requestOptions)
  .then(res => res.json())
  .then(res => frmtariffexpert(res))
  .catch(err => console.log(err));
	
}//end func

function frmtariffexpert(res){
	
	
let hs1=[];
let hs2=[];
let hs4=[];
let hs8=[];
var rownum=1;

res.map((col, index) => {
		const COD_NAM=col['COD_NAM'];
		const HS_COD=col['HS_COD'];
		const HS_DSC=col['HS_DSC'];
		
		const key="frmtariffexpert_"+index;
		
		if (COD_NAM=='HS1_COD')
			hs1.push(<option key={key+"_HS1_COD"} value={HS_COD} >{HS_DSC}</option>);

		if (COD_NAM=='HS2_COD')
			hs2.push(<option key={key+"_HS2_COD"} value={HS_COD} >{HS_DSC}</option>);

		if (COD_NAM=='HS4_COD')
			hs4.push(<option key={key+"_HS4_COD"} value={HS_COD} >{HS_DSC}</option>);
		
		if (COD_NAM=='HS8_COD'){
			
			
			hs8.push(<tr key={key+"_HS8_COD"} >
				<td align="right" >{rownum}</td>
				<td align="left" >{HS_COD}</td>
				<td align="left" >{HS_DSC}</td>
				</tr>
			);
			rownum++;
			}//end if
			
	}//end for
	);

setTariffexpert({
hs1:hs1	
,hs2:hs2
,hs4:hs4
,hs8:hs8
});	


/*
document.getElementById('tariffexpert_hs8').style.visibility='visible';
*/
	
}//end func




//{ { AWUNADM.SP_SAD_HARD_COPY(474836, ?) } }
async function mkhardcopy(e){
	e.preventDefault();
//sessionStorage.getItem("USERNAME")
const params={
	 USERNAME: sessionStorage.getItem("AW_USERNAME")
	, INSTANCEID: sad.INSTANCEID
	, PNAM: "INSTANCEID"
	, PVAL: sad.INSTANCEID
	, JASPER_FILE_NAME: "sad_hard_copy.jasper"
	, EXECUTEQUERY: ""
	, CALLABLESTATEMENT: " CALL AWUNADM.SP_SAD_HARD_COPY("+sad.INSTANCEID+", ~) "
};

console.log("mkhardcopy: "+JSON.stringify(params));

const filename="sad_hard_copy_"+sad.INSTANCEID+".pdf";

//setDowait({show:true});
e.target.style.visibility='hidden';
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

  await fetch(resturl+'rarsad/preprunireportext',requestOptions)
      .then(res => aftermkhardcopy(res, e, filename))
      .catch(err => console.log(err));	
	
}//end func

async function aftermkhardcopy(res, e, filename){
//setDowait({show:false});
e.target.style.visibility='visible';

const blob = await res.blob();
saveAs(blob, filename);	
	
}//end func


function fetchdetails(){

const params={
INSTANCEID:sad.INSTANCEID
, SEQNO:transkey.seqno
};

const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( params )
};

console.log('will call getdetails: '+JSON.stringify(params));

fetch(resturl+'rarsad/getdetails',requestOptions)
  .then(res => res.json())
  .then(res => afterfetchdetails(res))
  .catch(err => console.log(err));		
	
}//end func





function fetchvcl(){

const params={
REF_NO:sad.VCL_REF
};

const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( params )
};

console.log('will call getvcl: '+JSON.stringify(params));

fetch(resturl+'rarsad/getvcl',requestOptions)
  .then(res => res.json())
  .then(res => mktblvehicles(res))
  .catch(err => console.log(err));		
	
}//end func








function afterfetchitemtax(res, item_nbr){
//console.log('frmitemtax: '+JSON.stringify(res));
var datas={};
for(var attributename in itemtax){
	if (attributename!='htm'){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
		}//end if
	}//end for
	
setItemtax(datas);	//here only TAX_LIN_AMT is written to setItemtax
//console.log('frmitemtax res: '+JSON.stringify(res));
//console.log('lsitemtax : '+JSON.stringify(lsitemtax[item_nbr-1]));








let htmrows=[];
let top=(item_nbr==1)?827:352;
let rownum=1;
let SUM_TAX_LIN_AMT=0;

res.map((col, index) => {
		const key='itmtax'+index;
		const ctop=top;
		const strtop=ctop+"px";
		
		//console.log('item_nbr:'+item_nbr);
		//console.log('strtop:'+strtop);
		/* 
		result was awful when I was using defaultValue
		improved 100% after change to value
		KEY_TAX_RNK
		*/
		if (col['KEY_ITM_NBR']==item_nbr){
			if (col['KEY_TAX_RNK']==0){
				SUM_TAX_LIN_AMT = col['TAX_LIN_AMT'];
				setItemtax((prev) => {
				return {...prev, SUM_TAX_LIN_AMT:col['TAX_LIN_AMT']}
				});
				//console.log('SUM_TAX_LIN_AMT '+col['TAX_LIN_AMT']);
				}//end if
			else{
				
			if (col['TAX_LIN_COD']=='CPF'){
				let templsitem=lsitem;
				templsitem[item_nbr-1].CPF=col['TAX_LIN_AMT'];
				templsitem[item_nbr-1].CPF_BSE=col['TAX_LIN_BSE'];
				setLsitem(templsitem); 
				}//end if

			if (col['TAX_LIN_COD']=='ICD'){
				let templsitem=lsitem;
				templsitem[item_nbr-1].ICD=col['TAX_LIN_AMT'];
				templsitem[item_nbr-1].ICD_BSE=col['TAX_LIN_BSE'];
				templsitem[item_nbr-1].ICD_RAT=col['TAX_LIN_RAT'];
				setLsitem(templsitem); 
				}//end if
	
			htmrows.push(<>
				<input type="text" name="Fld_47a2[]" value={col['TAX_LIN_COD']} readOnly  onFocus={handleFocus} title='Duty - Tax code         (tax  2)' style={{"position":"absolute", "zIndex":"79", "left":"81px", "top":strtop, "width":"36px", "height":"18px"}}  />
				<input type="text" name="Fld_47b2[]" value={col['TAX_LIN_BSE']} readOnly  onFocus={handleFocus} title='Duty - Tax base amount  (tax  2)' style={{"position":"absolute", "zIndex":"80", "left":"129px", "top":strtop, "width":"105px", "height":"18px", "textAlign":"right"}}  />
				<input type="text" name="Fld_47c2[]" value={col['TAX_LIN_RAT']} readOnly  onFocus={handleFocus} title='Duty - Tax rate         (tax  2)' style={{"position":"absolute", "zIndex":"81", "left":"249px", "top":strtop, "width":"104px", "height":"18px", "textAlign":"right"}}  />
				<input type="text" name="Fld_47d2[]" value={col['TAX_LIN_AMT']} readOnly  onFocus={handleFocus} title='Duty - Tax amount       (tax  2)' style={{"position":"absolute", "zIndex":"82", "left":"366px", "top":strtop, "width":"108px", "height":"18px", "textAlign":"right"}}  />
				<input type="text" name="Fld_47e2[]" value={col['TAX_LIN_MOP']} readOnly  onFocus={handleFocus} title='MP - Method of payment  (tax  2)' style={{"position":"absolute", "zIndex":"83", "left":"483px", "top":strtop, "width":"15px", "height":"18px"}}  />
				</>
				);
				top+=20;
				rownum++;
			}
		}//end if
		}//end if
		
		);//end map
//console.log("datas: "+JSON.stringify(datas)); 

//htmrows.push({autoplay<textarea name="txtphrase" value={txtphrase.phrase} style={{"position":"absolute","top":top+55, "left":"81px"}} cols="35" rows="3" readOnly  ></textarea>)

	setItemtax((prev) => {
	return {...prev, htm:htmrows}
	});  	
	


	let temp=lsitemtax;
	datas['htm'] = htmrows;
	datas['SUM_TAX_LIN_AMT'] = SUM_TAX_LIN_AMT;
	temp[item_nbr-1]=datas;
	setLsitemtax(temp);


/*
let temp=lsitemtax;
//[sad.PTY_NBR_ITM][5];
for (var i=1; i<res.length; i++){
	//const item
	temp[item_nbr-1][i-1]=res[i];
	}
//console.log('frmitemtax temp : '+JSON.stringify(temp[item_nbr-1]));
setLsitemtax(temp);
*/	
	
	

}//end function	 







function openCity(evt, cityName) {
	
	if (sad.INSTANCEID=='' && cityName!="SadList"){
		//showsnackbar("select an entry first");
		return;
		}
	
/*
	if (cityName=='Sad' && item.KEY_ITM_NBR>1)
		cityName='Item';
*/
	
	currCity=cityName;

	if (cityName=="SadList"){
		setSelItem((prev)=>{
		return {...prev, nbr:0}
		});
		if (document.getElementById("btnsadlist"))
			document.getElementById("btnsadlist").style.visibility="hidden";
		document.getElementById("tbltablinks").style.visibility="hidden";
		}//end if
	else{
		if (document.getElementById("btnsadlist"))
			document.getElementById("btnsadlist").style.visibility="visible";
		document.getElementById("tbltablinks").style.visibility="visible";
		}
	
	


if (cityName!='Sad' && cityName!='Item')
	document.getElementById("cbautoplay").checked=false;

console.log('openCity cityName: '+cityName);

  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  //console.log('tabcontent.length: '+tabcontent.length);
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
	tablinks[i].className = tablinks[i].className.replace(" active", "");
	
	if (cityName=='InspectionAct' || cityName=='Bol'){//"Vouchers"
		document.getElementById('sadhiddenleft').style.display='none';
		document.getElementById('tbltablinks').style.display='none';
		document.getElementById('tbltoolbar').style.display='none';
/*
		document.getElementById('btnvouchers').style.display='none';
*/		
		//tablinks[i].className = tablinks[i].className+(" nodisplay");
		}
	else{
		document.getElementById('sadhiddenleft').style.display='block';
		document.getElementById('tbltablinks').style.display='block';
		document.getElementById('tbltoolbar').style.display='block';
/*
		document.getElementById('btnvouchers').style.display='block';
*/
		//tablinks[i].className = tablinks[i].className.replace(" nodisplay", "");
		}
  }//end for
  document.getElementById(cityName).style.display = "block";
  
  if (cityName=='asmtNotice'){
	fetchAsmtnotice(sad.INSTANCEID);
	}
 else if (cityName=='Containers'){
	fetchContainers(sad.INSTANCEID);
	}
  else if (cityName=='Attached_Documents'){
	fetchAttdocs(sad.INSTANCEID);
	}
  else if (cityName=='Vehicles'){
	fetchvcl();
	}
  else if (cityName=='Details'){
	fetchdetails();
	}
  else if (cityName=='TariffExpert'){
	fetchTariffexpert('');
	}

if (evt!=null)
	evt.currentTarget.className += " active";

const displayTbltoolbar=(cityName=='Sad' || cityName=='itemValueNote' || cityName=='Item')?'block':'none';
document.getElementById('tbltoolbar').style.display=displayTbltoolbar;
window.scrollTo(0, 0);
 
  
}//end function

 
function sendtoawc(args, instanceid, seqno){
/*
valid operations are 
	gettransid
	verify
	cancel
*/	
  
console.log('sendtoawc instanceid, seqno, args: '+instanceid+', '+seqno+', '+args);
toggleshowtoolbar(0);
//setTranskey( {...transkey, "verified":0} );
const url= awcurl + "instanceid="+instanceid+"&seqno="+seqno+"&"+args;


fetch(url,{method: 'GET'})
.then(res => res.json() )
.then(res => aftersendtoawc(res, args, instanceid, seqno) )
.catch(err => console.log(err));       
}	

function clickimgmap(e){
	
	console.log('clickimgmap '+e.target.id);
	
	smallpopup('pe',0);
	smallpopup('ts',0);
	smallpopup('mss',0);
	smallpopup('vfy',0);
	
	if (e.target.id=="btnpepromptyes"){
		
		sendtoaws("op=postentry");
		//senddatatodb("op=postentry", transkey.instid, transkey.seqno);
		}//end if

	if (e.target.id=="btntspromptyes"){
		//openCity(null, "wait");
		  var sad_payment_groupid = !location.state.sad_payment_groupid?0:location.state.sad_payment_groupid;
		  var instanceid = !location.state.instanceid?0:location.state.instanceid;
		  
		  if (sad_payment_groupid>0 && 1<0){
			 /*
			 problem - useEffect for sadpg.DEC_NAM is not triggered bc sadpg.DEC_NAM remains the same
			 hence gettblvouchers(); is not called
			 solution - set sadpg.DEC_NAM to * to flag call getspgdecnam(); anew
			 i.e. replace call to getspgdecnam(); with setSadpg(DEC_NAM,*)
			 changed my mind after all.  Not to reload the vouchers, just call fetchsad(sad.INSTANCEID); instead
			 */
			setSadpg((prev)=>{
				return {...prev, DEC_NAM:"*"}
			});
			}//end if
		  else
			fetchsad(sad.INSTANCEID);

		
		}//end if		
	//evt.target.id
}//end func

function aftersendtoawc(res, args, instid, seqno){
toggleshowtoolbar(1);
console.log('aftersendtoawc args: '+args);
console.log('aftersendtoawc res: '+JSON.stringify(res));


/*
if (args=="op=gettransid"){
	setTranskey( {...transkey
	, "transid":res.transid
	, "instid":instid
	, "seqno":seqno
	} );
	}//end if
else 
*/

if (args=="op=viewmass"){
	toggleshowtoolbar(1);
		//{  ,"viewmass":"{"grossmass":"295", "netmass":"295"}"  }
		
		//console.log("gross mass:"+res.viewmass.grossmass+"\r\n net mass:"+res.viewmass.netmass);
		smallpopup('mss',1);
		document.getElementById('totalmass').innerHTML="gross mass:&nbsp;"+res.viewmass.grossmass
											+"<br/>net mass:&nbsp;"+res.viewmass.netmass;
		//alert("gross mass:"+res.viewmass.grossmass+"\r\nnet mass:"+res.viewmass.netmass);
		}
else if (args=="op=verify" || args=="op=postentry" || args=="op=viewmass"){
	let tempsad=sad;
	
	tempsad.FIN_GTY_DAT=res.sadtotals[0].FIN_GTY_DAT;
	tempsad.FIN_AMT_DTY=parseFloat(res.sadtotals[0].FIN_AMT_DTY).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');;
	tempsad.FIN_GTY_AMT=parseFloat(res.sadtotals[0].FIN_GTY_AMT).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');;
	tempsad.FIN_AMT_FEE=parseFloat(res.sadtotals[0].FIN_AMT_FEE).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');;
	setSad(tempsad);

	//console.log('afterverify res.sadtotals:'+JSON.stringify(res.sadtotals));
	//console.log('afterverify res.sadtotals.FIN_AMT_DTY:'+res.sadtotals[0].FIN_AMT_DTY);
	//console.log('afterverify res:'+res.itemtax);
	afterfetchitemtax(res.itemtax, selItem.nbr);
	frmasmtnotice(res.sadtax);
	////need a way to cancel trans & set arrTrans[trani] to null after postentry on server
	if (args=="op=verify"){
		if (res.errors.length==0)
			smallpopup('vfy',1);
		else{
			tblverifyerrors(res.errors);
			}//end else
			
		//showsnackbar('verify complete');
		//setTranskey( {...transkey, "verified":1} );
		}
	else if (args=="op=postentry"){
		smallpopup('pe',1);
		//setTranskey( {...transkey, "verified":1} );
		//sendtoaws(args);
		/*wanted to set , "transid":0 here but the useeffect 
		sends gettransid to client and doc gets locked
	so maybe just after postentry on server exit SAD and show vouchers
		*/
		}//end if


	/*
	window.location='#afterverify';
	document.getElementById('Sad').classList.add("height600");
	document.getElementById('Sad').scrollTop=300;

	*/
	toggleshowtoolbar(1);
	/*
	document.body.scrollTop = 550;
	document.documentElement.scrollTop = 550;
	document.getElementById('tbltoolbar').classList.add("tbltoolbarlo");
	*/
	showModal(1);

	}//end if
	

}//end func
 
function smallpopup(elem, show){
const elemId=elem+'popup' ;
//pepopup
//console.log('smallpopup elemId: '+elemId);
if (show==1){
	document.getElementById(elemId).classList.remove('smallpopupoff');	
	document.getElementById(elemId).classList.add('smallpopupon');
	}//end if
else{
	document.getElementById(elemId).classList.remove('smallpopupon');	
	document.getElementById(elemId).classList.add('smallpopupoff');	
	}//end if


}//end func
 
function sendtoaws(args){


toggleshowtoolbar(0);
/*
	const requestOptions = {
	  method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {"seqno":transkey.seqno} )
	  };
*/

	const url= awsurl + "instanceid="+transkey.instid+"&seqno="+transkey.seqno+"&"+args;

	console.log('url: '+url);
	fetch(url,{method: 'GET'})
	.then(res => res.json() )
	.then(res => aftersendtoaws(res, args) )
	.catch(err => console.log(err));       
	
	  
}//end func



function aftersendtoaws(res, args){

console.log('aftersendtoaws args, res:'+args+', '+JSON.stringify(res));
toggleshowtoolbar(1);
//console.log();
    
if (res.INSTANCEID!=transkey.instid){
	//shownsnackbar(' warning res.INSTANCEID '+res.INSTANCEID+' does not match instid: '+instid);
	}

//else if (args=="op=fetchattdoc" && res.ATDURL!='')
	//window.open(res.ATDURL);

if (res.ERR==''){
	
	if (args=='op=basic-docum-check' && res.COL_DSC!='' && res.COL_DSC!='null'){
		const filepath="img/triggersel"+res.COL_DSC.toLowerCase().substring(0,3)+".png";
		document.getElementById('tspopupimg').src=filepath;
		smallpopup('ts', 1);
		}//end if
	else if (args=="op=unlock"){
		document.getElementById('btnverify').style.display='block';
		document.getElementById('btnunlock').style.display='none';
		}//end if
	else if (args=='op=cleardeclaration'){
		//setSad((prev)=>{return {...prev, cleared:1}}); a new field CLR_DAT is now updated in SR_HttpServer
		sendtoaws("op=new-inspection-act");
		}//end if
	else if (args.startsWith("op=rerouteto")){
		//fetchsad(sad.INSTANCEID);
		const colDsc=args.replace("op=rerouteto", "");
		const filepath="img/triggersel"+colDsc.toLowerCase().substring(0,3)+".png";
		console.log("filepath: "+filepath);
		document.getElementById('tspopupimg').src=filepath;
		smallpopup('ts', 1);	
		setSad((prev)=>{
			return {...prev, PTY_COL_DSC:colDsc}
		});
		}//end if
	else if (res.INSP_ACT_INSTANCE_ID!=''){
		const state={
				INSP_ACT_INSTANCE_ID:res.INSP_ACT_INSTANCE_ID
				, sad_payment_groupid:location.state.sad_payment_groupid
				, instanceid:sad.INSTANCEID
				};

		navigate(`/inspact`,{state:state});

		//openCity(null, "InspectionAct");
		}//end if

	}//end if
else
	showsnackbar(res.ERR);		

	
}//end func




 







 


function fetchAttdocs(instance_id){
console.log('fetchContainers instance_id: '+instance_id);
//setInstanceid(instance_id);

const params={
INSTANCEID: instance_id
}//end function

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };
setAttachdocs({htm:[]});
setUserattdoc({KEY_ITM_NBR:0, KEY_RNK:0});
  fetch(resturl+'rarsad/getattdocs',requestOptions)
      .then(res => res.json())
      .then(res => frmattachdocs(res))
      .catch(err => console.log(err));
	  

}//end func  


function afterfetchAttdocssOld(res){


let htmrows=[];


var rownum=1;
//<img src='images/pdficon_small.gif' border=0 title='click to download voucher' />
res.map((col, index) => {
		const url=col['URL'];
		const key='attdocs'+index;
		const linkid = "DOC"+col['KEY_RNK'];
		const ref=col['REF'];
		htmrows.push(<tr key={key} >
		<td align="right" >{rownum}</td>
		<td align="right" ><a href={url} target="_none" id={linkid}  ><img src='img/pdf.gif' /> {ref}</a></td>
		<td align="center" >{col['COD']}</td>
		<td align="right" >{col['NAM']}</td>
		</tr>
	);
	rownum++;
	}//end map
	);
{/*
	   <th align="center" >Reference</th>
	   <th align="center" >Code</th>
	   <th align="center" >File Name</th>

		<td align="center" >{col['KEY_RNK']}</td>
		<td align="left" >{col['DAT']}</td>
		<td align="left" >{col['RUL']}</td>
*/}
setAttachdocs({htm:htmrows});

}//end func



function loadpdffile(e){
	e.preventDefault();
	alert('load pdf file will soon be available');
}//end func

function viewpdffile(e){
	e.preventDefault();//E 20473
	//KEY_ITM_NBR, KEY_RNK, filename
//console.log('viewpdffile : '+KEY_ITM_NBR+', '+KEY_RNK);
//setInstanceid(instance_id);
const filename=sad.REG_NBR_KEY+".pdf";
const params={
 INSTANCEID: sad.INSTANCEID
, REG_NBR_KEY:sad.REG_NBR_KEY
, KEY_ITM_NBR:userattdoc.KEY_ITM_NBR
, KEY_RNK:userattdoc.KEY_RNK
}//end function

  
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

setDlwait({show:true});

  fetch(resturl+'rarsad/viewpdffile',requestOptions)
      .then(res => afterviewpdffile(res, filename))
      .catch(err => console.log(err));
	  

}//end func  

async function afterviewpdffile(res, filename){
	//20473
const downloadFilename = filename;
const blob = await res.blob();
//const blob = new Blob([res], { type: 'application/pdf' })
console.log('blob.length: '+blob.length);

const data = window.URL.createObjectURL(new Blob([blob]));

const link = document.createElement("a");
link.href = data;
link.setAttribute("download", downloadFilename);
document.body.appendChild(link);
link.click();
//link.parentNode!.removeChild(link);	
link.parentNode?.removeChild(link);	



setDlwait({show:false});


}//end func

function fetchContainers(instance_id){
console.log('fetchContainers instance_id: '+instance_id);
//setInstanceid(instance_id);

const params={
INSTANCEID: instance_id
}//end function

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

  fetch(resturl+'rarsad/getcontainers',requestOptions)
      .then(res => res.json())
      .then(res => frmcontainers(res))
      .catch(err => console.log(err));
	  

}//end func  

function copyTransToClipboard(evt){
  
  // Select the text field
  evt.target.select();
  evt.target.setSelectionRange(0, 99999); // For mobile devices

   // Copy the text inside the text field
  //navigator.clipboard.writeText(evt.target.value);
  navigator.clipboard.writeText(JSON.stringify(transkey));
	
}//end func  


function frmcontainers(res){

var datas={};
//console.log("res[0].length: "+res[0].length); 
for(var attributename in containers){
	if (attributename!='htm'){
		let data=res[0][attributename]?res[0][attributename]:"";
		datas[attributename] = (data==null)?'':data;
		}//end if
	}//end for

setContainers(datas);

let htmrows=[];
let top=440;


res.map((col, index) => {
		const key='containers'+index;
		const ctop=top;
		const strtop=ctop+"px";
		//console.log('strtop:'+strtop);
	htmrows.push(<>        
		<input type="text" name="fld_ItmNbr" defaultValue={col['ITM_NBR']} readOnly title="Item Number" style={{"position":"absolute", "zIndex":"20", "left":"30px", "top":strtop, "width":"50px", "height":"20px"}} className="input_field" />
        <input type="text" name="fld_CtnIdt" defaultValue={col['IDT']} readOnly title="Container - Identity Code" style={{"position":"absolute", "zIndex":"21", "left":"110px", "top":strtop, "width":"120px", "height":"20px"}} className="input_field" />
        <input type="text" name="fld_CtnNbrPack" defaultValue={col['PKG_NBR']} readOnly title="Numbers of Packages" style={{"position":"absolute", "zIndex":"22", "left":"250px", "top":strtop, "width":"60px", "height":"20px"}} className="input_field" />
		
		<input type="text" name="fld_Typ" defaultValue={col['TYP']} readOnly title="Type" style={{"position":"absolute", "zIndex":"20", "left":"350px", "top":strtop, "width":"60px", "height":"20px"}} className="input_field" />
		<input type="text" name="fld_Ful" defaultValue={col['FUL']} readOnly title="E/F" style={{"position":"absolute", "zIndex":"20", "left":"450px", "top":strtop, "width":"50px", "height":"20px"}} className="input_field" />		
		
        <input type="text" name="fld_CtnGoods" defaultValue={col['GDS']} readOnly title="Goods" style={{"position":"absolute", "zIndex":"23", "left":"510px", "top":strtop, "width":"120px", "height":"20px"}} className="input_field" />

        <input type="text" name="fld_PKG_TYP" defaultValue={col['PKG_TYP']} readOnly title="Pkg Type" style={{"position":"absolute", "zIndex":"23", "left":"640px", "top":strtop, "width":"35px", "height":"20px"}} className="input_field" />
		
        <input type="text" name="fld_CtnGrossWeightCtn" defaultValue={col['WTC']} readOnly title="Empty weight" style={{"position":"absolute", "zIndex":"24", "left":"715px", "top":strtop, "width":"70px", "height":"20px"}} className="input_field" />
        <input type="text" name="fld_CtnGrossWeight" defaultValue={col['PKG_WGT']} readOnly title="Gross Weight" style={{"position":"absolute", "zIndex":"25", "left":"807px", "top":strtop, "width":"70px", "height":"20px"}} className="input_field" />

		</>
	);
	top+=20;
	}//end for
	);
//console.log("datas: "+JSON.stringify(datas)); 

	setContainers((prev) => {
	return {...prev, htm:htmrows}
	});  


}//end function	


function fetchAsmtnotice(instance_id){
console.log('fetchAsmtnotice instance_id: '+instance_id);
const params={
INSTANCEID: instance_id
}//end function

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

  fetch(resturl+'rarsad/getasmtnotice',requestOptions)
      .then(res => res.json())
      .then(res => frmasmtnotice(res))
      .catch(err => console.log(err));
	  

}//end func  


function frmasmtnotice(res){

var datas={htm:""};
//console.log("res[0].length: "+res[0].length); 
//console.log("frmasmtnotice res "+JSON.stringify(res)); 
for(var attributename in asmtnotice){
	if (attributename!='htm'){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
		}//end if
	}//end for

setAsmtnotice(datas);

let htmrows=[];
let top=420;
res.map((col, index) => {
		const key='asmtnotice'+index;
		const ctop=top;
		const strtop=ctop+"px";
		//console.log('strtop:'+strtop);


	htmrows.push(<><input type="text" name="Fld_ItmTx1" title="Items Tax 1" defaultValue={col['TAX_COD']} style={{"position":"absolute", "zIndex":"29", "left":"50px", "top":strtop, "width":"25px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ItmDe1" title="Items Tax Description 1" defaultValue={col['TAX_DSC']} style={{"position":"absolute", "zIndex":"30", "left":"90px", "top":strtop, "width":"240px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ItmAm1" title="Items Tax Amount 1" defaultValue={col['TAX_AMT']} style={{"position":"absolute", "zIndex":"31", "left":"350px", "top":strtop, "width":"120px", "height":"20px"}} className="input_fieldr" />
        <input type="text" name="Fld_GloTx1" title="Global Tax Code 1" style={{"textAlign":"center", "position":"absolute", "zIndex":"32", "left":"490px", "top":strtop, "width":"25px", "height":"20px"}} className="input_field" />
		</>
	);

/*
<input type="text" name="Fld_GloDe1" title="Global Tax Description 1"  defaultValue={col['DOC_NO']}  style={{"textAlign":"center", "position":"absolute", "zIndex":"33", "left":"530px", "top":strtop, "width":"240px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_GloAm1" title="Global Tax Amount 1" style={{"position":"absolute", "zIndex":"34", "left":"790px", "top":strtop, "width":"120px", "height":"20px"}} className="input_field" />
*/

	top+=20;
	}//end for
	);
console.log("htmrows: "+JSON.stringify(htmrows)); 

	setAsmtnotice((prev) => {
	return {...prev, htm:htmrows}
	});  


}//end function	

 

function frmattachdocs(res){

if (res.length==undefined){
	console.log("exiting frmattachdocs");
	return;
	}

var datas={};

console.log("res.length: "+res.length); 
//console.log("frmattachdocs res "+JSON.stringify(res)); 
for(var attributename in res){
	if (attributename!='htm')
		datas[attributename] = res[0][attributename];
	}//end for

setAttachdocs(datas);

let htmrows=[];
let top=370;
res.map((col, index) => {
		const key='attacheddoc'+index;
		const ctop=top;
		const strtop=ctop+"px";
		const ref=col['REF'];
		
		const url=col['URL'];
		const linkid = "SAD_ATD_"+col['KEY_RNK'];
		//const link = (col['SIZ']>0)?<a href="#" id={linkid} onClick={(e)=>{e.preventDefault(); fetchattdoc(col['KEY_ITM_NBR'],col['KEY_RNK']);}} style={{"position":"absolute", "xIndex":"19", "left":"385px", "top":strtop, "width":"80px", "height":"18px", "textDecoration":"none"}}  ><img src='img/pdf.gif' /> {ref}</a>:<></>;
		let Fld_Att1_Ref='';
		if (col['SIZ']>0)
			Fld_Att1_Ref = <><input type="radio" name="rdattdoc" id={linkid} onClick={(e)=>{callSetUserattdoc(e, col['KEY_ITM_NBR'], col['KEY_RNK']);}} style={{"position":"absolute", "xIndex":"19", "left":"495px", "top":strtop}}  /><label htmlFor={linkid} className="hand" style={{"position":"absolute", "left":"520px", "top":strtop}} >{ref}</label></>;
		else
			Fld_Att1_Ref = <input type="text" name="Fld_Att1_Ref" defaultValue={col['REF']} readOnly title="Attached document 1 - reference" style={{"position":"absolute", "xIndex":"19", "left":"495px", "zIndex":"300", "top":strtop, "width":"300px", "height":"18px"}} className="input_field" />;

		
		console.log('strtop:'+strtop);
	htmrows.push(<>
        <input type="text" name="Fld_Att1_Cod" defaultValue={col['COD']} readOnly title="Attached document 1 - code" style={{"position":"absolute", "xIndex":"19", "left":"15px", "top":strtop, "width":"60px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Att1_Nam" defaultValue={col['NAM']} readOnly title="Attached document 1 - description" style={{"position":"absolute", "xIndex":"19", "left":"85px", "top":strtop, "width":"280px", "height":"18px"}} className="input_field" />
		{Fld_Att1_Ref}
        <input type="text" name="Fdt_Att1_Dat" defaultValue={col['DAT']} readOnly title="Attached document 1 - date" style={{"position":"absolute", "xIndex":"20", "left":"805px", "top":strtop, "width":"80px", "height":"18px"}} className="input_field" />
		</>
	);
	top+=20;
	}//end for
	);
//console.log("frmattachdocs datas: "+JSON.stringify(htmrows)); 

{/*
		const ref=col['REF'];
		htmrows.push(<tr key={key} >
		<td align="right" >{rownum}</td>
		<td align="right" ><a href={url} target="_none" id={linkid}  ><img src='img/pdf.gif' /> {ref}</a></td>

*/}

	setAttachdocs((prev) => {
	return {...prev, htm:htmrows}
	});  


}//end function	

function callSetUserattdoc(e, KEY_ITM_NBR, KEY_RNK){
	//e.preventDefault();
setUserattdoc((prev)=>{
	return {...prev
	, KEY_ITM_NBR:KEY_ITM_NBR
	, KEY_RNK:KEY_RNK
	}
});	
}//end function	

function closemodal(elemId, doMaintable){
document.getElementById(elemId).style.display = "none";
if (doMaintable==1)
	document.getElementById("maintable").style.display = "block";
	
if (elemId=='modalVouchers'){
	setDoctime('00:00');
	clearInterval(intervalId);
	//console.log('arrdocno: '+JSON.stringify(arrdocno));
	}//end if
	
	
}//end func

function openmodal(elemId, doMaintable){
document.getElementById(elemId).style.display = "block";
if (doMaintable==1)
	document.getElementById("maintable").style.display = "none";

if (elemId=='modalVouchers'){
	waitmin=0;
	waitsec=0;
	setDoctime('00:00');
	voucherfileexists();
	//document.getElementById("button1").click();
	intervalId = setInterval(handleInterval, 1000); // Will alert every second.
	}//end if
	
}//end function	 

 
function toggleshowtoolbar(showtoolbar){
if (document.getElementById('waiticon') && document.getElementById('tbltoolbar')){
	if (showtoolbar==1){
		document.getElementById('waiticon').style.display='none';
		document.getElementById('tbltoolbar').style.display='block';
		}//end if
	else{
		console.log('toggleshowtoolbar flag: '+showtoolbar);
		document.getElementById('waiticon').style.display='block';
		document.getElementById('tbltoolbar').style.display='none';
		}//end else
	}//end if
}//end func
 
async function fetchsad(instance_id){
console.log('fetchsad instance_id: '+instance_id);
//setInstanceid(instance_id);
if (1*instance_id>0)
	await getseqno(instance_id);


/*
getcpcs result can add to session instead of repeat fetch
*/

if (ctrycodes.length==0)
	await fetchCtrycodes();

const params={INSTANCEID: instance_id,KEY_ITM_NBR: 1};

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

if (lsCpc.length==0)
	await fetchcpcs(requestOptions);

	setLsitem([]);
	const startFetchSad = new Date();
	
  fetch(resturl+'rarsad/getsad',requestOptions)
      .then(res => res.json())
      .then(res => afterfetchsad(res, startFetchSad))
      .catch(err => console.log(err));

/*
if (ctrycodes.length==0)
	fetchCtrycodes();
*/
	

	  setContainers({});
	  setAsmtnotice({});
	  //setTblinspacts({});
	  setAttachdocs({});
	  
	  // fields such as TAR_VDT and TAR_PRI from getitem must go on afterfetchsad
/*
instead of getitem here, lets do this in afterfetchsad with Setselitem.nbr
  fetch(resturl+'rarsad/getitem',requestOptions)
      .then(res => res.json())
      .then(res => afterfetchitem(res))
      .catch(err => console.log(err));
*/

	  

	  
}//end func 


function fetchcpcs(requestOptions){
  
	fetch(resturl+'rarsad/getcpcs',requestOptions)
      .then(res => res.json())
      .then(res => afterfetchcpcs(res))
      .catch(err => console.log(err));
	
}//end func

function afterfetchcpcs(res){

let htmrows=[];
res.map((col, index) => {
	const key='lscpc'+index;
/*
	const selected = (item.TAR_PRC_NAT==col['RUL_COD'])?" selected ":"";
	selected={selected}

*/
		htmrows.push(
		<option key={key}  value={col['RUL_COD']}  >{col['RUL_COD']+' '+col['RUL_DSC']}</option>
		
		);
		
	});//end map

setLsCpc(htmrows);
}

function selectitem(instance_id, item_nbr, PTY_NBR_ITM){

console.log('inside selectitem item_nbr:'+item_nbr);	

/*
console.log(
  util.inspect(lsitem, {
    depth: 5,
    colors: true,
  }),
);	
*/
	

setSelItem({nbr:item_nbr});
/* 
for whatever reason the useEffect is not triggered when from Sad Finder
must call openCity explicitly
 */
if (!location.state.sad_payment_groupid)
	openCity(null, "Sad");
else if (location.state.sad_payment_groupid==0)
	openCity(null, "Sad");
else if (location.state.fetchinstanceid)
	openCity(null, "Sad");

/*
setSelItem({nbr:item_nbr});
setSelItem((prev)=>{
	return {...prev, nbr:item_nbr}
	});
*/

//document.getElementsByName('selitemnbr')[0].value=item_nbr;
jsxitemstbl(item_nbr, instance_id, PTY_NBR_ITM);


/*
27-Apr-2023
need a criteria to flag if to fetch from db when user select item
(i)  	see if we can call setItemtax in the callback from setItem bacause they must go together
(ii) 	after item is fetched from db and added to lsitem, do not fetch same item again from db
(iii)	previously only when user changed item was it added to lsitem to be sent to the db for verify/postentry.
		now we will add all fetched items to lsitem, and a new field 'item.haschanged' will flag if to send to db
also note that /getitem will initially (in fetchsad) call afterfetchsad instead of frmitem on page load because its the first page	
(iv)	getitemtax should not be called anywhere other than frmitem and afterfetchsad
*/

const tempitem = lsitem[item_nbr-1];
if (tempitem.KEY_ITM_NBR==0){
	fetchitem(instance_id, item_nbr);
	//fetchitemtax({INSTANCEID:instance_id, KEY_ITM_NBR:item_nbr});
	}//end if
else{
	handleCpcChange(tempitem.TAR_PRC_NAT);
	//console.log('use lsitem instead of fetchitem');
	setItem(tempitem);
	const tempitemtax = lsitemtax[item_nbr-1];
	//console.log('tempitemtax : '+JSON.stringify(tempitemtax));
	setItemtax(tempitemtax);
	//console.log('lsitemtax : '+JSON.stringify(lsitemtax[item_nbr-1]));
	}
	

}//end func 

function fetchitem(instance_id, item_nbr){

//console.log('inside fetchitem item_nbr:'+item_nbr);

if (item_nbr==0)
	item_nbr = selItem.nbr;
const params={
INSTANCEID: instance_id
, KEY_ITM_NBR: item_nbr
}//end function

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };
 
 //if (document.getElementById("itemstblcell"))
//	document.getElementById("itemstblcell").style.visibility="hidden";
 
  fetch(resturl+'rarsad/getitem',requestOptions)
      .then(res => res.json())
      .then(res => afterfetchitem(res))
      .catch(err => console.log(err));
	
	  
}//end function





async function startAutoPlay(){
	//e.preventDefault();
	
	
	const checked=document.getElementById('cbautoplay').checked?1:0;
	setAutoplay((prev)=>{
		return {...prev, on:checked}
	});
	
	if (checked==0){
		//synth.cancel();
		return;
		}//end func
	
	console.log("currCity: "+currCity);
/*
	if (currCity=="Sad")
		document.getElementsByName("KEY_ITM_NBR")[0].focus();
	else

 */
		
		
	var synth = window.speechSynthesis;
	let phrase="Item number "+selItem.nbr+" tariff heading ";
	
	//console.log("lsitem: "+JSON.stringify(lsitem[selItem.nbr-1]));
	const curritem=lsitem[selItem.nbr-1];
	const arrCod=curritem.TAR_HSC_NB1.split('');
	const head=arrCod.length>3?arrCod[0]+" "+arrCod[1]+" "+arrCod[2]+" "+arrCod[3]:"";
	const dutyRate=curritem.ICD?" with duty rate "+curritem.ICD_RAT+" percent":" no Import Duty calculated";
	const CPC=curritem.TAR_PRC_NAT=="000"?"":" using CPC "+curritem.TAR_PRC_NAT+" ";
	phrase+=head+dutyRate+CPC;

const TAR_HSC_NB1=document.getElementsByName("TAR_HSC_NB1");
let scrollTop=null, focusElem=null;
if (currCity=="Sad"){
	scrollTop=543;
	focusElem=document.getElementsByName("Fld_47f")[0];
	}//end if
else if (currCity=="Item"){
	scrollTop=65;
	focusElem=document.getElementsByName("Fld_47f")[1];
	}//end if
	

scrollTop+=35;
console.log("scrollTop: "+scrollTop);
if (scrollTop!=null){
	document.body.scrollTop = scrollTop;
	document.documentElement.scrollTop = scrollTop;
	if (focusElem)
		focusElem.focus();
	}

		setTxtphrase((prev)=>{
			return {...prev, phrase:phrase}
		});//place the textbox on the item only

//console.log("startAutoPlay: "+phrase);

    
        var voices = [];

        PopulateVoices();
        if(speechSynthesis !== undefined){
            speechSynthesis.onvoiceschanged = PopulateVoices;
        }

       
            var toSpeak = new SpeechSynthesisUtterance(phrase);
            //toSpeak.voice = voices[7]; // Spanish
			toSpeak.voice = voices[1]; // Spanish
            synth.speak(toSpeak);


        function PopulateVoices(){
            voices = synth.getVoices();
            //voices.forEach((item, index) => console.log(item.name, index));
        }

await speechEnd(toSpeak);

//setSelItem({nbr:item_nbr});
console.log("selItem.item_nbr: "+selItem.nbr);
console.log("sad.PTY_NBR_ITM: "+sad.PTY_NBR_ITM);

if (selItem.nbr<sad.PTY_NBR_ITM){
	const nextNbr=selItem.nbr+1;
	console.log("nextNbr: "+nextNbr);
	
	await selectitem (sad.INSTANCEID, nextNbr, sad.PTY_NBR_ITM);
	
/*
			setSelItem((prev)=>{
			return {...prev, nbr:nextNbr}
		});
*/


	}//end if

}//end function

function speechEnd(toSpeak){
	
	   return new Promise(resolve => {
        toSpeak.onend = resolve;
      });

	
}//end func


function fetchbol(){
toggleshowtoolbar(0);
console.log('inside fetchbol');

const params={
INSTANCE_ID: 0
, SAD_IDE_MAN:sad.IDE_MAN
, SAD_BOL_REF:item.LNK_TPT
};


    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };
 //console.log('fetchbol requestOptions: '+JSON.stringify( requestOptions ));


  fetch(resturl+'rarbol/getbol',requestOptions)
      .then(res => res.json())
      .then(res => frmbol(res))
      .catch(err => console.log(err));
	  

/*
  fetch(resturl+'rarsad/getbol',requestOptions)
      .then(res => { console.log('res:'+JSON.stringify( res )); res.json(); } )
      .then(res => frmbol(res))
      .catch(err => console.log(err));

*/
	
	  
}//end function

 
function gettblvouchers(){
//console.log('location.state.aw_username: '+location.state.aw_username);
const params={
SAD_PAYMENT_GROUPID: location.state.sad_payment_groupid
, DEC_COD: location.state.dec_cod
, IDE_CUO_COD: location.state.cuo_cod
, AW_USERNAME: sessionStorage.getItem("AW_USERNAME")
}
//setTblvouchers
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

  fetch(resturl+'rarsad/gettblvouchers',requestOptions)
      .then(res => res.json())
      .then(res => aftergettblvouchers(res))
      .catch(err => console.log(err));
}//end func 


function fetchpdfvoucher(e, DOC_NO){
e.preventDefault();
const params={
SAD_PAYMENT_GROUPID: location.state.sad_payment_groupid
, DOC_NO: DOC_NO
, AW_USERNAME: sessionStorage.getItem("AW_USERNAME")
}
//setTblvouchers
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
	  , responseType: "blob"
  };
e.target.style.visibility='hidden';
  fetch(resturl+'rarsad/fetchpdfvoucher',requestOptions)
      .then(res => afterfetchpdfvoucher(res, e, DOC_NO+".pdf"))
      .catch(err => {console.log(err); e.target.style.visibility='visible';});
}//end func  

async function afterfetchpdfvoucher(res, e, filename){
	//const file = new Blob([blob], { type: 'application/pdf' });
	const blob = await res.blob();
	saveAs(blob, filename);
	e.target.style.visibility='visible';
}//end func  	
 
function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}//end func
 
function aftergettblvouchers(res){
 
 
 /*for(var attributename in sad){
	datas[attributename] = res[0][attributename];
	}//end for
*/
var rowstax=[];

 	var sadRows=[];
	var docRows=[];
	var totalsRow=[];
  var num=1;
	var instanceId=0; 
  res.map((col, index) => {
  if (instanceId==0)
	instanceId=col['INSTANCEID'];
	
	const band=col['BAND'];
	const color=col['COLOR'];
	const alertvisib=(color=="" || color==null)?"visible":"hidden";
	const key="_tblvchrs_"+index;
  //var icd=0, cpf=0, ftx=0, dfr=0, afr=0, tbp=0;
  //console.log('bgcolor: '+bgcolor);
	if (band.startsWith('01')){
		sadRows.push(<tr key={"voucher01"+key} >
		<td align='right' >{num}&nbsp;&nbsp;</td>
		<td align='center'  >{col['REGIME']}</td>
		<td align='left'  >&nbsp;&nbsp;{col['DEC_REF_NBR']}</td>
		<td align='center'  >{col['COLOR']}</td>
		<td align='left'  >
		&nbsp;&nbsp;<img src='img/exclmarkorange.png' border='0' className='hand' style={{visibility:[alertvisib]}} />
		&nbsp;<a href="#" onClick={(e) => { e.preventDefault(); fetchsad(col['INSTANCEID']); } } >{col['REG_NUM']}</a>
		</td>
		
		<td align='right'  >{col['PTY_NBR_ITM']}&nbsp;&nbsp;</td>
		<td align='right'  >{(col['FIN_AMT_TBP']==null)?'':col['FIN_AMT_TBP'].toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}&nbsp;&nbsp;</td>
		<td align='right'  >{(col['ICD']==null)?'':col['ICD'].toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}&nbsp;&nbsp;</td>
		<td align='right'  >{(col['CPF']==null)?'':col['CPF'].toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}&nbsp;&nbsp;</td>
		<td align='right'  >{(col['FTX']==null)?'':col['FTX'].toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}&nbsp;&nbsp;</td>
		<td align='right'  >{(col['DFR']==null)?'':col['DFR'].toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}&nbsp;&nbsp;</td>
		<td align='right'  >{(col['AFR']==null)?'':col['AFR'].toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}&nbsp;&nbsp;</td>
		</tr>);
		num++;
		}//end if
else if (band.startsWith('02')){
		const icd=(col['ICD']==null)?'':col['ICD'].toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
		const cpf=(col['CPF']==null)?'':col['CPF'].toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
		const ftx=(col['FTX']==null)?'':col['FTX'].toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
		const dfr=(col['DFR']==null)?'':col['DFR'].toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
		const afr=(col['AFR']==null)?'':col['AFR'].toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
		const tbp=(col['FIN_AMT_TBP']==null)?'':col['FIN_AMT_TBP'].toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
		
		totalsRow.push(<tr key={"voucher02"+key} >
		<td align='center' colSpan="5" >{sadpg.DEC_COD+" "+sadpg.DEC_NAM}</td>
		<td align='right' >Totals:&nbsp;&nbsp;</td>
		<td align='right' ><input type="text" size="7" readOnly className='ralign' onFocus={handleFocus} defaultValue={tbp} /></td>
		<td align='right' ><input type="text" size="7" readOnly className='ralign' onFocus={handleFocus} defaultValue={icd} /></td>
		<td align='right' ><input type="text" size="7" readOnly className='ralign' onFocus={handleFocus} defaultValue={cpf} /></td>
		<td align='right' ><input type="text" size="7" readOnly className='ralign' onFocus={handleFocus} defaultValue={ftx} /></td>
		<td align='right' ><input type="text" size="7" readOnly className='ralign' onFocus={handleFocus} defaultValue={dfr} /></td>
		<td align='right' ><input type="text" size="7" readOnly className='ralign' onFocus={handleFocus} defaultValue={afr} /></td>
		</tr>);
		
		totalsRow.push(<tr key={"voucher02b"+key} >		
	<th >#</th>
	<th >Regime</th>
	<th >Declarant<br/>Ref.</th>
	<th >Color</th>
	<th >Registr. #</th>
	<th align='right'  >Items</th>
	<th align='right'  >Total Line<br/>Amount</th>
	<th align='right'  >Import<br/>Duty</th>
	<th align='right'  >Processing<br/>Fee</th>
	<th align='right'  >Fuel<br/>Tax</th>
	<th align='right'  >Duty Free<br/>Royalty</th>
	<th align='right'  >Aviation<br/>Royalty</th>	
	</tr>);

{
/*
		</tbody>
		<thead>
		</thead>
		<tbody>

*/			
}

	rowstax.push({
	COD:'ICD'
	,AMT:icd.replace(/,/g, '')
	,DOC_NO:''
	,TRANS_NO:''
	,SUB_TRANS_NO:''
	});

	rowstax.push({
	COD:'CPF'
	,AMT:cpf.replace(/,/g, '')
	,DOC_NO:''
	,TRANS_NO:''
	,SUB_TRANS_NO:''
	});
			
	rowstax.push({
	COD:'FTX'
	,AMT:ftx.replace(/,/g, '')
	,DOC_NO:''
	,TRANS_NO:''
	,SUB_TRANS_NO:''
	});		

	rowstax.push({
	COD:'DFR'
	,AMT:dfr.replace(/,/g, '')
	,DOC_NO:''
	,TRANS_NO:''
	,SUB_TRANS_NO:''
	});

	rowstax.push({
	COD:'AFR'
	,AMT:afr.replace(/,/g, '')
	,DOC_NO:''
	,TRANS_NO:''
	,SUB_TRANS_NO:''
	});


		/*
		taxcod[0]['COD']='ICD';
		taxcod[1]['COD']='CPF';
		taxcod[2]['COD']='FTX';
		taxcod[3]['COD']='DFR';
		taxcod[4]['COD']='AFR';
		taxcod[0]['AMT']=icd.replace(/,/g, '');
		taxcod[1]['AMT']=cpf.replace(/,/g, '');
		taxcod[2]['AMT']=ftx.replace(/,/g, '');
		taxcod[3]['AMT']=dfr.replace(/,/g, '');
		taxcod[4]['AMT']=afr.replace(/,/g, '');
*/
		}//end if
else if (band.startsWith('03')){
		docRows.push(<tr key={"voucher03"+key} >
		<td align='center' colSpan="5" >{sadpg.RQS_TYP}</td>
		<td align='right' colSpan="2" > Vouchers Doc. No.s:&nbsp;&nbsp;</td>
		{/*
		<a href="#" s onClick={(e)=>{e.preventDefault();  fetchvoucherstopay(); }} ><img src='img/pdf.gif' border="0" /></a>
		<td align='right'  >{(col['FIN_AMT_TBP']==null)?'':col['FIN_AMT_TBP']}</td>
		*/}
		<td align='right'  >{col['ICD']!=null && <a href="#" className="nodecor" onClick={(e)=>{fetchpdfvoucher(e, col['ICD']); }} >{col['ICD']}&nbsp;<img src='img/pdf.gif' border="0" /></a>}</td>
		<td align='right'  >{col['CPF']!=null && <a href="#" className="nodecor" onClick={(e)=>{fetchpdfvoucher(e, col['CPF']); }} >{col['CPF']}&nbsp;<img src='img/pdf.gif' border="0" /></a>}</td>
		<td align='right'  >{col['FTX']!=null && <a href="#" className="nodecor" onClick={(e)=>{fetchpdfvoucher(e, col['FTX']); }} >{col['FTX']}&nbsp;<img src='img/pdf.gif' border="0" /></a>}</td>
		<td align='right'  >{col['DFR']!=null && <a href="#" className="nodecor" onClick={(e)=>{fetchpdfvoucher(e, col['DFR']); }} >{col['DFR']}&nbsp;<img src='img/pdf.gif' border="0" /></a>}</td>
		<td align='right'  >{col['AFR']!=null && <a href="#" className="nodecor" onClick={(e)=>{fetchpdfvoucher(e, col['AFR']); }} >{col['AFR']}&nbsp;<img src='img/pdf.gif' border="0" /></a>}</td>

		</tr>);
		rowstax[0]['DOC_NO']=(col['ICD']==null)?'':col['ICD'];
		rowstax[1]['DOC_NO']=(col['CPF']==null)?'':col['CPF'];
		rowstax[2]['DOC_NO']=(col['FTX']==null)?'':col['FTX'];
		rowstax[3]['DOC_NO']=(col['DFR']==null)?'':col['DFR'];
		rowstax[4]['DOC_NO']=(col['AFR']==null)?'':col['AFR'];
		//console.log('rowstax: '+JSON.stringify(rowstax));
		
		}//end if
else if (band.startsWith('04')){
		docRows.push(<tr key={"voucher04"+key} >
		<td align='center' colSpan="5" >{sadpg.USERNAME+" "+sadpg.RQS_DAT}</td>
		<td align='right' colSpan="2" >Transaction No.s:&nbsp;&nbsp;</td>
		{/*<td align='right'  >{(col['FIN_AMT_TBP']==null)?'':col['FIN_AMT_TBP']}</td>*/}
		<td align='right'  >{(col['ICD']==null)?'':col['ICD']}</td>
		<td align='right'  >{(col['CPF']==null)?'':col['CPF']}</td>
		<td align='right'  >{(col['FTX']==null)?'':col['FTX']}</td>
		<td align='right'  >{(col['DFR']==null)?'':col['DFR']}</td>
		<td align='right'  >{(col['AFR']==null)?'':col['AFR']}</td>
		</tr>);

		rowstax[0]['TRANS_NO']=(col['ICD']==null)?'':col['ICD'];
		rowstax[1]['TRANS_NO']=(col['CPF']==null)?'':col['CPF'];
		rowstax[2]['TRANS_NO']=(col['FTX']==null)?'':col['FTX'];
		rowstax[3]['TRANS_NO']=(col['DFR']==null)?'':col['DFR'];
		rowstax[4]['TRANS_NO']=(col['AFR']==null)?'':col['AFR'];

		}//end if
else if (band.startsWith('05'))
		docRows.push(<tr key={"voucher05"+key} >
		<td align='center' colSpan="5" >{}</td>
		<td align='right' colSpan="2" >Sub-Transaction No.s:&nbsp;&nbsp;</td>
		{/*<td align='right'  >{(col['FIN_AMT_TBP']==null)?'':col['FIN_AMT_TBP']}</td>*/}
		<td align='right'  >{(col['ICD']==null)?'':col['ICD']}</td>
		<td align='right'  >{(col['CPF']==null)?'':col['CPF']}</td>
		<td align='right'  >{(col['FTX']==null)?'':col['FTX']}</td>
		<td align='right'  >{(col['DFR']==null)?'':col['DFR']}</td>
		<td align='right'  >{(col['AFR']==null)?'':col['AFR']}</td>
		</tr>);  
  
  
  });	
  
  setTaxamt(rowstax);
  //console.log('vouchers: '+JSON.stringify(vouchers));
  let tempRows=[];
  tempRows.push(docRows);
  tempRows.push(totalsRow);
  tempRows.push(sadRows);
  //INSTANCEID:res[0].INSTANCEID
 setTblvouchers({
	 INSTANCEID:0
	 , NUM_SAD:num-1
	 , htm:tempRows
	 });
 
 
 }//end func
 
 
function getspgdecnam(){
	console.log("location.state.sad_payment_groupid: "+location.state.sad_payment_groupid);
			const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( {SAD_PAYMENT_GROUPID:location.state.sad_payment_groupid} )
	  };	
	  fetch(resturl+'rarsad/getspgdecnam',requestOptions)
		  .then(res => res.json())
		  .then(res => aftergetspgdecnam(res))
		  .catch(err => console.log(err));	
	
 }//end func	
  
function aftergetspgdecnam(res){
setSadpg((prev)=>{
	return {...prev
	, RQS_DAT:res[0].RQS_DAT
	, DEC_COD:res[0].DEC_COD
	, DEC_NAM:res[0].DEC_NAM
	, RQS_TYP:res[0].RQS_TYP
	, USERNAME:res[0].USERNAME
	}
});
	
/*

	let temp=sadpg;
	temp.DEC_NAM=res[0].DEC_NAM;
	//setSadpg(temp);
setSadpg((prev)=>{
	return {...prev, temp}
});
*/

}//end func	
  

function getseqno(instanceid){

console.log('getseqno instanceid: '+instanceid);

/*const VIEW_OR_RETRIEVE=(location.state.sad_payment_groupid==0)?'V':'R';*/

const VIEW_OR_RETRIEVE='R';

const params={
username: sessionStorage.getItem("AW_USERNAME")
, SAD_PAYMENT_GROUPID: location.state.sad_payment_groupid
, INSTANCEID: instanceid
, VIEW_OR_RETRIEVE: VIEW_OR_RETRIEVE
}//end function

//console.log(JSON.stringify( params ));

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

console.log('next: call rarsad/getseqno');
toggleshowtoolbar(0);

  fetch(resturl+'rarsad/getseqno',requestOptions)
      .then(res => res.json())
      .then(res => aftergetseqno(res, instanceid))
      .catch(err => console.log(err));
	  
return false;
}//end function


function aftergetseqno(res, instanceid){
console.log('aftergetseqno res: '+JSON.stringify(res[0]));
//toggleshowtoolbar(1);
setTranskey( {...transkey
, "instid":instanceid
, "seqno":res[0].SEQNO
, "LOCK_INFO":res[0].LOCK_INFO
} );


if (res[0].LOCK_INFO==null || res[0].LOCK_INFO=='' || res[0].LOCK_INFO=='null'){
	document.getElementById('btnpostentry').style.display='block';
	document.getElementById('btnverify').style.display='block';
	}//end if
else{
	document.getElementById('btnunlock').style.display='block';
	}

//sendtoawc("op=gettransid", instanceid, res[0].SEQNO);

//
}//end function
  
function mktblchangeditems(){
let htmrows=[];
//console.log('mktblchangeditems item: '+JSON.stringify(lsitem[2]));
lsitem.map((col, index) => {
	const key="mktblchangeditems_tr"+index;
	const sup=(col['TAR_SUP_QTY']=='null' || col['TAR_SUP_QTY']==null || col['TAR_SUP_QTY']=='')?'':col['TAR_SUP_QTY']+' '+col['TAR_SUP_COD'];
	//#	Chg	Tariff	Value(US $)	Suppl.	CPC	ICD	CPF
	if (1*col['HAS_CHANGED']>0 && 1*col['KEY_ITM_NBR']>0)
		htmrows.push(
		<tr key={key} >
		<td>{col['KEY_ITM_NBR']}</td>
		<td>{col['TAR_HSC_NB1']}</td>
		<td>{col['VIT_INV_AMT_NMU']}</td>
		<td>{col['VIT_EFR_AMT_NMU']}</td>
		<td>{col['VIT_WGT_GRS']}</td>
		<td>{col['VIT_WGT_NET']}</td>
		<td>{sup}</td>
		<td>{col['TAR_PRC_NAT']}</td>
		<td>{col['ICD']}</td>
		<td>{col['CPF']}</td>
		</tr>
		
		);
		
	});//end map

//console.log('mktblchangeditems htmrows: '+JSON.stringify(htmrows));
setTblchangeditems(htmrows);

}//end function
	
	
function afterfetchdetails(res){
let htmrows=[];
//console.log('afterfetchdetails item: '+JSON.stringify(lsitem[2]));
res.map((col, index) => {
		const key="afterfetchdetails_tr"+index;
		htmrows.push(
		<tr key={key} >
		<td>{col['DOC_VER']}</td>
		<td>{col['OP_NAME']}</td>
		<td>{col['STATUS']}</td>
		<td>{col['FULLNAME']}</td>
		<td>{col['OP_DATE_TIME']}</td>
		<td>{col['OWNER']}</td>
		</tr>
		
		);
		
	});//end map

//console.log('afterfetchdetails htmrows: '+JSON.stringify(htmrows));
setTbldetails(htmrows);

}//end function

function tblverifyerrors(errors){
	
let htmrows=[];
let rownum=1;
errors.map((col, index) => {
		console.log('tblverifyerrors msg:'+col['msg']);
		const key="tblverifyerrors_tr"+index;
		htmrows.push(
		<tr key={key} >
		<td align="right" width="4%" >{rownum}</td>
		<td width="96%" >{col['msg']}</td>
		</tr>
		
		);
	rownum++;
	});//end map

//console.log('mktblvehicles htmrows: '+JSON.stringify(htmrows));
setVerifyerrors({htm:htmrows});
document.getElementById('tblverifyerrors').style.display='block';
	
}//end func

function closetblverifyerrors(e){
	e.preventDefault();
	document.getElementById('tblverifyerrors').style.display='none';
}
	
	
function clearSad(e){
e.preventDefault();

if (sad.PTY_COL_DSC!='Red' && sad.PTY_COL_DSC!='Yellow')
	showsnackbar("You are not allowed to perform this operation!<br/>Only Red and Yellow require Clear Operation");
else
	sendtoaws("op=cleardeclaration");

}//end func


function reRoute(e, color){

e.preventDefault();

if (sad.PTY_COL_DSC=="")
	showsnackbar("You are not allowed to perform this operation!<br/>Declaration is not yet selected!");
else if (color.toLowerCase()==sad.PTY_COL_DSC.toLowerCase())
	showsnackbar("Declaration is already selected "+sad.PTY_COL_DSC+"!");
else if (color=='blue' && sad.PTY_COL_DSC=='Green')
	showsnackbar("Declaration cannot be re-route from green lane to blue lane!");
else if (color=='green' && sad.PTY_COL_DSC!='Blue' && sad.CLR_DAT=="")
	showsnackbar("You must do the operation 'Clear declaration' first!");
else
	sendtoaws("op=rerouteto"+color);
}//end func

	
function mktblvehicles(res){
let htmrows=[];
res.map((col, index) => {
		const key="mktblvehicles_tr"+index;
		htmrows.push(
		<tr key={key} >
		<td>{col['KEY_RNK']}</td>
		<td>{col['DOR']}</td>
		<td>{col['YEA']}</td>
		<td>{col['MAK']}</td>
		<td>{col['MOD']}</td>
		<td>{col['COL']}</td>
		<td>{col['VIN']}</td>
		<td>{col['MIL']}</td>

		<td>{col['FUL']}</td>
		<td>{col['DRV']}</td>
		<td>{col['LTR']}</td>
		<td>{col['VAL']}</td>
		<td>{col['FRT']}</td>
		</tr>
		
		);
	/*ECC, LTR*/
	});//end map

//console.log('mktblvehicles htmrows: '+JSON.stringify(htmrows));
setTblvehicles(htmrows);

}//end function	

let ivnelems=[];	
ivnelem.map((elem, index) => {
	//console.log(elem.name);
	let elemValue=null;
	const key="ivnelems_"+index;
	
	if (elem.name.trim()=="")
		elemValue="";
	else{
		if (elem.src=="itm"){
			elemValue=item[elem.name];
			}
		
		}//end else
	
	
		if (elem.readonly==1){
			ivnelems.push(
			<input type="text" name={elem.name} 	
			key={key}
			defaultValue={elemValue}
			title={elem.title}
			readOnly
			onFocus={handleFocus}
			style={{"textAlign":elem.textAlign, "position":elem.position, "zIndex":elem.zIndex, "left":elem.left, "top":elem.top, "width":elem.width, "height":elem.height}} 
			className="input_field" />
			);
			}//end if
		else{//defaultValue {/*onChange={changeEvent}*/}
			ivnelems.push(
			<input type="text" name={elem.name} 	
			key={key}
			value={elemValue}
			title={elem.title}
			onChange={(e)=>{elem.src=="itm" && handleItemChange(e);}}
			onFocus={handleFocus}
			style={{"textAlign":elem.textAlign, "position":elem.position, "zIndex":elem.zIndex, "left":elem.left, "top":elem.top, "width":elem.width, "height":elem.height}} 
			className="input_field" />
			);
			}//end else
		
	});//end map  
  
  
let itmelems=[];	
itmelem.map((elem, index) => {
	//console.log(elem.name);
	let elemValue=null;
	const key="itmelems_"+index;
	
	if (elem.name.trim()=="")
		elemValue="";
	else{
		if (elem.src=="itm"){
			elemValue=item[elem.name];
			}
		
		}//end else
	
	
		if (elem.readonly==1){
			itmelems.push(
			<input type="text" name={elem.name} 	
			key={key}
			defaultValue={elemValue}
			title={elem.title}
			readOnly
			onFocus={handleFocus}
			style={{"textAlign":elem.textAlign, "position":elem.position, "zIndex":elem.zIndex, "left":elem.left, "top":elem.top, "width":elem.width, "height":elem.height}} 
			className="input_field" />
			);
			}//end if
		else{//defaultValue {/*onChange={changeEvent}*/}
			itmelems.push(
			<input type="text" name={elem.name} 	
			key={key}
			value={elemValue}
			title={elem.title}
			onChange={(e)=>{elem.src=="itm" && handleItemChange(e);}}
			onFocus={handleFocus}
			style={{"textAlign":elem.textAlign, "position":elem.position, "zIndex":elem.zIndex, "left":elem.left, "top":elem.top, "width":elem.width, "height":elem.height}} 
			className="input_field" />
			);
			}//end else
		
	});//end map    

  
let sadelems=[];  
sadelem.map((elem, index) => {
	//console.log(elem.name);
	const key="sadelems_"+index;
	let elemValue=null;
	//let changeEvent=null;
	
	if (elem.name.trim()=="")
		elemValue="";
	else{
		if (elem.src=="itm"){
			elemValue=item[elem.name];
			}
		else if (elem.src=="sad"){
			elemValue=sad[elem.name];
			}
		else if (elem.src=="itx"){
			elemValue=itemtax[elem.name]
			}
		
		}//end else
		
	//console.log("elem.name: "+elem.name);
	//console.log("elemValue: "+elemValue);
	//console.log("elem.readonly: "+elem.readonly);
	
	
		if (elem.readonly==1){
			sadelems.push(
			<input type="text" name={elem.name} 	
			key={key}
			defaultValue={elemValue}
			title={elem.title}
			readOnly
			onFocus={handleFocus}
			style={{"position":elem.position, "zIndex":elem.zIndex, "left":elem.left, "top":elem.top, "width":elem.width, "height":elem.height}} 
			className="input_field" />
			);
			}//end if
		else{//defaultValue onChange={changeEvent}
			sadelems.push(
			<input type="text" name={elem.name} 	
			key={key}
			value={elemValue}
			title={elem.title}
			
			onChange={(e)=>{
				elem.src=="sad" && handleSadChange(e); 
				elem.src=="itm" && handleItemChange(e); 
				elem.src=="itx" && handleItemChange(e); 
				}}

			onFocus={handleFocus}
			style={{"position":elem.position, "zIndex":elem.zIndex, "left":elem.left, "top":elem.top, "width":elem.width, "height":elem.height}} 
			className="input_field" />
			);
			}//end else
		
	});//end map  

	{/*
	value={(elem.src=="item")?item[elem.name]:sad[elem.name]};
	style={{"position":"absolute", "top":"0px", "left":"180px", "display":"none"}}
	!sad.PTY_COL_DSC?
	*/}
	
let postentrycell=<td align='center' className="tooltip" ><a href="#"  title='post entry' id='btnpostentry'  onMouseEnter={(e) => { setToolbaricon({"title":"post-entry"}); }} onMouseLeave={(e) => { setToolbaricon({"title":""}); }} onClick={(e) => { e.preventDefault(); senddatatodb("op=postentry", transkey.instid, transkey.seqno); }} ><img src='img/Btn_OK_Normal.gif' border="0"  /></a><span className="tooltiptext">Post-Entry</span></td>;	
if (location.state.sad_payment_groupid==0 && 1<0)
	postentrycell=<td  ><a id='btnpostentry'></a></td>;
/*<td id='btnpostentry' ></td>*/
let btnBasicDocumCheck=<td align='center' className="tooltip" >
	<a href="#" title='Basic Documentary Check' onMouseEnter={(e) => { setToolbaricon({"title":"Basic Documentary Check"}); }} onMouseLeave={(e) => { setToolbaricon({"title":""}); }}  onClick={(e) => { e.preventDefault(); sendtoaws('op=basic-docum-check'); }}  ><img src='img/BasicDocumentaryCheck.gif' border="0" /></a>
	<span className="tooltiptext">Basic Documentary Check</span>
	</td>;
if (sad.PTY_COL_DSC!=""){
	//remove the button if a color is assigned
	btnBasicDocumCheck=<></>;
	//replace with clear declaration if Red or Yellow color assigned
	if (sad.PTY_COL_DSC=="Red" || sad.PTY_COL_DSC=="Yellow"){
		
		if (sad.CLR_DAT=="")
			btnBasicDocumCheck=<td align='center' className="tooltip" >
			<a href="#" title='Clear Declaration' onMouseEnter={(e) => { setToolbaricon({"title":"Clear Declaration"}); }} onMouseLeave={(e) => { setToolbaricon({"title":""}); }}  onClick={(e) => { clearSad(e); }}  ><img src='img/Btn_Clear.gif' border="0" /></a>
			<span className="tooltiptext">Clear Declaration</span>
			</td>;
		else
			btnBasicDocumCheck=<td align='center' >
			<table align="center" style={{top:"0px"}} >
			<tbody>
			<tr><td align="center" className="tooltip" >
				<a href="#" title='Re-route to red' onMouseEnter={(e) => { setToolbaricon({"title":"Re-route to red"}); }} onMouseLeave={(e) => { setToolbaricon({"title":""}); }}  onClick={(e) => { reRoute(e, 'red'); }}  ><img src='img/Btn_Reroute_XRed_Normal.gif' border="0" /></a>
				<span className="tooltiptext">Re-route to red</span>
			</td></tr>
			<tr><td align="center" className="tooltip" >
				<a href="#" title='Re-route to yellow' onMouseEnter={(e) => { setToolbaricon({"title":"Re-route to yellow"}); }} onMouseLeave={(e) => { setToolbaricon({"title":""}); }}  onClick={(e) => { reRoute(e, 'yellow'); }}  ><img src='img/Btn_Reroute_XYellow_Normal.gif' border="0" /></a>
				<span className="tooltiptext">Re-route to yellow</span>
			</td></tr>
			<tr><td align="center" className="tooltip" >
				<a href="#" title='Re-route to green' onMouseEnter={(e) => { setToolbaricon({"title":"Re-route to green"}); }} onMouseLeave={(e) => { setToolbaricon({"title":""}); }}  onClick={(e) => { reRoute(e, 'green'); }}  ><img src='img/Btn_Reroute_XGreen_Normal.gif' border="0" /></a>
				<span className="tooltiptext">Re-route to green</span>
			</td></tr>
			</tbody>
			</table>
			</td>;
		}//end if
	}//end if


	
let tbltoolbar = <>	
	<div align='center' id='waiticon' className="waiticon"   ><img src="img/Loading_2.gif" border="0" height="36" /> . . . please wait</div>
	<table align='center' id='tbltoolbar' border="0" cellSpacing="0" cellPadding="0" className="tbltoolbar"  >
	<tbody>
	<tr>
	<td align='center' className="tooltip" ><a href="#"  title='unlock' id='btnunlock'  onMouseEnter={(e) => { setToolbaricon({"title":"unlock the document"}); }} onMouseLeave={(e) => { setToolbaricon({"title":""}); }} onClick={(e) => { e.preventDefault(); sendtoaws('op=unlock', transkey.instid, transkey.seqno);}} ><img src='img/Btn_Unlock_Normal.gif' border="0"  /></a><span className="tooltiptext">unlock the document</span></td>
	<td align='center' className="tooltip" ><a href="#"  title='verify' id='btnverify'  onMouseEnter={(e) => { setToolbaricon({"title":"verify the document"}); }} onMouseLeave={(e) => { setToolbaricon({"title":""}); }} onClick={(e) => { e.preventDefault(); senddatatodb("op=verify", transkey.instid, transkey.seqno);}} ><img src='img/Check_Operation.gif' border="0"  /></a><span className="tooltiptext">verify the document</span></td>
	{postentrycell}
	{btnBasicDocumCheck}
	<td align='center' className="tooltip" ><a href="#" title='view total mass' onMouseEnter={(e) => { setToolbaricon({"title":"view total mass"}); }} onMouseLeave={(e) => { setToolbaricon({"title":""}); }} onClick={(e) => { e.preventDefault(); sendtoawc('op=viewmass', transkey.instid, transkey.seqno);}} ><img src='img/Btn_View_Normal.gif' border="0" /></a><span className="tooltiptext">view total mass</span></td>
	<td align='center' className="tooltip" ><a href="#" title='view waybill' onMouseEnter={(e) => { setToolbaricon({"title":"view waybill"}); }} onMouseLeave={(e) => { setToolbaricon({"title":""}); }}  onClick={(e) => { e.preventDefault(); fetchbol();}}  ><img src='img/Btn_ViewAlt_Normal.gif' border="0" /></a><span className="tooltiptext">view waybill</span></td>
	<td align='center' className="tooltip" ><a href="#" title='view inspection act' onMouseEnter={(e) => { setToolbaricon({"title":"view inspection acts"}); }} onMouseLeave={(e) => { setToolbaricon({"title":""}); }}  onClick={(e) => { inspactPrompt(e);  }}    ><img src='img/Btn_ViewAlt_Normal.gif' border="0" /></a><span className="tooltiptext">view inspection acts</span></td>
	<td align='center' className="tooltip" ><a href="#" title='print hard copy' onMouseEnter={(e) => { setToolbaricon({"title":"print hard copy"}); }} onMouseLeave={(e) => { setToolbaricon({"title":""}); }}  onClick={(e) => { mkhardcopy(e);  }}    ><img src='img/pdf.gif' border="0" /></a><span className="tooltiptext">print hard copy</span></td>
		<td align='right' style={{"display":"none"}}  >&nbsp;&nbsp;{toolbaricon.title}</td>
{/*

	<td align='center' style={{"visibility":"hidden"}}  ><a href="#" title='view attached' onMouseEnter={(e) => { setToolbaricon({"title":"view attached"}); }} onMouseLeave={(e) => { setToolbaricon({"title":""}); }} ><img src='img/Btn_View_Normal.gif' border="0" /></a></td>
	<td align='center'   ><a href="#" title='clear declaration' ><img src='img/Btn_Clear.gif' border="0" /></a></td>
	<td align='center'   ><a href="#" title='Re-route to green' ><img src='img/Btn_Reroute_XGreen_Normal.gif' border="0" /></a></td>
	<td align='center'   style={{"visibility":"hidden"}}  ><a href="#" title='Export to Pdf' ><img src='img/Btn_Print_Normal.gif' border="0" /></a></td>
	<td align='center'  style={{"visibility":"hidden"}}   ><a href="#" title='Export to XML' ><img src='img/Icon_XML_Export.gif' border="0" /></a></td>

*/}	
	</tr>
	{/*
	<tr>
	<td align='center' colSpan="5" >
	<select onChange={(e) => { setGoodsValue(e); }} >
	<option value='' ></option>
	{comboitemvalue.options}
	</select>
	</td>
	</tr>	
	*/}
	</tbody>
	</table>
	</>;



let returnlink=<></>;

const sad_payment_groupid = !location.state.sad_payment_groupid?0:location.state.sad_payment_groupid;
const from_sad_finder = !location.state.from_sad_finder?0:location.state.from_sad_finder;

if (from_sad_finder==1)
	returnlink=<div className="tooltip">
				<a href="#" id='btnsadfinder' className="nodecor" onClick={(e) => { e.preventDefault(); navigate(`/sadfinder`); }} ><img src="img/Btn_Search_Normal.png" height="28" border="0" /></a>
				<span className="tooltiptext">Sad Finder</span>
				</div>;
else if (sad_payment_groupid==0)
	returnlink=<div className="tooltip">
				<a href="#" className="nodecor" onClick={(e) => { e.preventDefault(); navigate(`/jobqadm`); }} ><img src="img/jobqueue.png" height="28" border="0" /></a>
				<span className="tooltiptext">Job Queue</span>
				</div>;
else
	returnlink=<div className="tooltip">
				<a href="#"  title='Vouchers & Declarations' id='btnsadlist'  onClick={(e) => { e.preventDefault(); openCity(null, "SadList"); }} ><img src='img/pdffiles.png' height="32" border="0"  /></a>
				<span className="tooltiptext">Vouchers &<br/>Declarations</span>
				</div>;
  
return <div>


<table align='center' border="0" id="maintable" className='maintable' cellPadding="0" cellSpacing="0"  >
<tbody>
<tr valign='top' key="maintable_tr1" >
<td id="sadhiddenleft"  >
{returnlink}

{/*
<div className="tooltip">
<img src="img/govcrest.png" height="36" id="btnvouchers" border="0"  style={{"display":"none"}} className="pointer"  onClick={(e) => openCity(e, 'Vouchers')  } />
 <span className="tooltiptext">return to payment vouchers</span>
</div>

*/}
<table align='center' border="0"  id='tblitemnum' cellPadding="0" cellSpacing="0" >
<tbody>
<tr valign="top" key="tblitemnum_tr1" >
<td colSpan="2" align="center"  >
<span style={{"fontSize":"14px","background":"powderblue"}} >{sad.IDE_REG_SER+' '+sad.IDE_REG_NBR}</span>
<br/>
	<table align='center' cellPadding="0" cellSpacing="0" > 
	<tbody>
	<tr>
	<td align='center' ><input type="checkbox" id="cbautoplay" style={{visibility:"hidden"}} onClick={(e) => { startAutoPlay();  }}   /></td>
	<td align='center' ><label htmlFor="cbautoplay" className="hand"  >play</label></td>
	</tr>
	</tbody>
	</table>	
</td>
</tr>
<tr valign="top" key="tblitemnum_tr2"  ><td id="itemstblcell" >{itemstbl.htm}</td></tr>
<tr valign="top" key="tblitemnum_tr3"  >
	<td>
	<br/>
	<select name="selitemnbr" value={selItem.nbr} onChange={(e)=>{handleItemNbrChange(e.target.value);}} >
	{itemnumoptions.htm}
	</select>
	</td>
</tr>
</tbody>
</table>
</td>
<td>
{/*
style={{"position":"absolute", "left":"94px", "top":"493px"}}
style={{"position":"absolute", "left":"114px", "top":"493px"}}
	document.getElementById("btnpepromptyes").addEventListener ("click", (e)=>{e.preventDefault();   clickimgmap(e)}, false);
	document.getElementById("btnpepromptno").addEventListener ("click", (e)=>{e.preventDefault();   clickimgmap(e)}, false);
*/}
<div id='pepopup' className='smallpopup' >
<img src='img/postentryprompt.png' border="0" useMap='#image-map-pe' />
 <map name='image-map-pe'>
 	<area target='' alt='' title='' href='#' id='btnpepromptyes' className='imgmapbtn' coords='198,104,162,73' shape='rect' onClick={(e)=>{e.preventDefault();   clickimgmap(e)}} />
 	<area target='' alt='' title='' href='#' id='btnpepromptno' className='imgmapbtn' coords='204,73,236,103' shape='rect' onClick={(e)=>{e.preventDefault();   clickimgmap(e)}} />
 </map>
</div>

<div id='tspopup' className='smallpopup' >
<img src='img/triggerselred.png' id='tspopupimg' border="0" useMap='#image-map-ts' />
 <map name='image-map-ts'>
 	<area target='' alt='' title='' href='#' id='btntspromptyes' className='imgmapbtn' coords='640,169,500,120' shape='rect' onClick={(e)=>{e.preventDefault();   clickimgmap(e)}} />
 </map>
</div>

<div id='msspopup' className='smallpopup' >
<img src='img/transparent.png' id='msspopupimg' border="0" useMap='#image-map-mss' />
 <map name='image-map-mss'>
 	<area target='' alt='' title='' href='#' id='btnmsspromptyes' className='imgmapbtn' coords='112,77,156,114' shape='rect' onClick={(e)=>{e.preventDefault();   clickimgmap(e)}} />
 </map>
 <div id='totalmass' >totalmass goes here</div>
</div>


<div id='vfypopup' className='smallpopup' >
<img src='img/documverified.png' id='vfypopupimg' border="0" useMap='#image-map-vfy' />
<p id='vfysadtotals' >{"Declaration Total Duties & Taxes: US $"+sad.FIN_AMT_DTY.replace(/,/g, "").replace(/(\d)(?=(\d{3})+\b)/g, '$1,')}  </p>
 <map name='image-map-vfy'>
 	<area target='' alt='' title='' href='#' id='btnvfypromptyes' className='imgmapbtn' coords='184,73,230,113' shape='rect' onClick={(e)=>{e.preventDefault();   clickimgmap(e)}} />
 </map>
</div>



	  
	<div className="tab" >
	<table id="tbltablinks" border="0"  >
	<tbody>
	<tr>
	<td>
  <button className="tablinks" id='tablinksad' onClick={(e) => openCity(e, 'Sad')} >Sad</button>
  <button className="tablinks" onClick={(e) => openCity(e, 'itemValueNote')} >Item Value Note</button>
  <button className="tablinks" onClick={(e) => openCity(e, 'asmtNotice')} >Asmt. Notice</button>
  {/*<button className="tablinks" onClick={(e) => openCity(e, 'valuationNote')} >Value Note</button>*/}
  <button className="tablinks" onClick={(e) => openCity(e, 'Containers')} id='btnContainers' >Containers</button>
  {/*<button className="tablinks" onClick={(e) => openCity(e, 'PreviousDocument')} >Previous Document</button>*/}
  <button className="tablinks" onClick={(e) => openCity(e, 'Attached_Documents')} >Attached Docs</button>
  <button className="tablinks" onClick={(e) => openCity(e, 'Vehicles')} id='btnVehicles' >Vehicles</button>
  <button className="tablinks" onClick={(e) => openCity(e, 'Modified')} >Changes Log</button>
  <button className="tablinks" onClick={(e) => openCity(e, 'Details')} >Details</button>
  {/*<button className="tablinks" onClick="openCity(event, 'Vehicles')">Vehicles</button>*/}
</td>
	</tr>
	</tbody>
	</table>
	
  </div>

  {tbltoolbar}


  {/*
  <div id='waiticon'> waiticon </div>
<div id='tbltoolbar'> tbltoolbar  </div>

  tbltoolbar
  Waitcursor
  <button onClick="topFunction()" id="pgtopbutton" title="Go to top">Top</button>
 
  */}
	  
 <Waitcursor />


  <div id="Sad" className="tabcontent"  >
  
	<img src="img/un.broker.asysad.client.VP_Gsg.png" alt="VP_Gsg" />
	
	{/*{tbltoolbar}*/}
	
	
	
	<input type="text" name="FETCH_TIME" title="time to fetch Entry" readOnly style={{"position":"absolute", "left":"335px", "top":"3px", "width":"90px", "height":"18px", "textAlign":"center"}} />
	<input type="text" onChange={handleTransChange} value={"seq no: "+transkey.seqno} readOnly onFocus={(e) => { copyTransToClipboard(e);handleFocus(); }} title={JSON.stringify(transkey)} style={{"position":"absolute", "zIndex":"2", "left":"400px", "top":"48px", "width":"90px", "height":"18px"}} className="input_field" />
	{sadelems}	
	
	<a href="#" onClick={(e)=>{e.preventDefault(); openCity(null,'TariffExpert');}} style={{"position":"absolute", "zIndex":"38", "left":"724px", "top":"529px"}} title="open Tariff Expert" ><img src="img/Btn_View_Normal.png" border="0"  /></a>
	
	
	
	<select name="GEN_CTY_FLT" value={sad.GEN_CTY_FLT} onChange={handleSadChange} style={{"position":"absolute", "zIndex":"23", "left":"510px", "top":"262px", "width":"45px", "height":"18px"}} title="Country of first destination / last provenance" >
	{ctrycodes}
	</select>

	<select name="GEN_CTY_TRD" value={sad.GEN_CTY_TRD} onChange={handleSadChange} style={{"position":"absolute", "zIndex":"23", "left":"592px", "top":"262px", "width":"45px", "height":"18px"}} title="Trading country" >
	{ctrycodes}
	</select>	
	
	<select name="GEN_CTY_EPT_COD" value={sad.GEN_CTY_EPT_COD} onChange={handleSadChange} style={{"position":"absolute", "zIndex":"23", "left":"729px", "top":"303px", "width":"45px", "height":"18px"}} title="Country of export - region code" >
	{ctrycodes}
	</select>
	
	<select name="GEN_CTY_EPT_NAM" value={sad.GEN_CTY_EPT_NAM} onChange={handleSadChange} style={{"position":"absolute", "zIndex":"26", "left":"510px", "top":"303px", "width":"198px", "height":"18px"}}  title="Country of export - name" >
	{ctrynames}
	</select>
	
	
	
	
	<textarea name="CMP_EXP_NAM" defaultValue={sad.CMP_EXP_NAM} onChange={handleSadChange} title="Exporter - name & address" style={{"position":"absolute", "zIndex":"4", "left":"100px", "top":"72px", "width":"396px", "height":"80px"}} className="input_field"  ></textarea>



		<textarea name="CMP_FIS_NAM" title="Person resp. for financial settlement - name & address" style={{"position":"absolute", "zIndex":"19", "left":"510px", "top":"189px", "width":"420px", "height":"45px"}} className="input_field"  ></textarea>
		
	
	<textarea name="Ftx_8b" defaultValue={sad.CMP_CON_NAM} title="Consignee - name & address" style={{"position":"absolute", "zIndex":"20", "left":"100px", "top":"192px", "width":"396px", "height":"80px"}} className="input_field"  ></textarea>
	<textarea name="Ftx_14b" defaultValue={sad.DEC_NAM} title="Declarant - name & address" style={{"position":"absolute", "zIndex":"25", "left":"100px", "top":"308px", "width":"396px", "height":"54px"}} className="input_field"  ></textarea>
	
	<input type="checkbox" name="Fld_19" defaultValue={sad.TPT_CTF}    title="Container flag" style={{"position":"absolute", "zIndex":"28", "left":"468px", "top":"383px", "width":"15px", "height":"15px"}} className="input_field" />
	
	
	
	<input type="text" name="Fld_34b" defaultValue={item.GDS_ORG_CTY}  title="Country of origin - region code" style={{"position":"absolute", "zIndex":"45", "left":"684px", "top":"581px", "width":"30px", "height":"18px"}} className="input_field" />
	<input type="text" name="Ftx_31c1" title="Container Number 1" style={{"visibility":"hidden", "position":"absolute", "zIndex":"47", "left":"183px", "top":"618px", "width":"190px", "height":"18px"}} className="input_field" />
	<input type="text" name="Ftx_31c2" title="Container Number 2" style={{"visibility":"hidden", "position":"absolute", "zIndex":"48", "left":"375px", "top":"618px", "width":"190px", "height":"18px"}} className="input_field" />

        <input type="text" name="TAR_PRC_EXT" defaultValue={item.TAR_PRC_EXT}  readOnly  onFocus={handleFocus} title="Extended Procedure Code" style={{"position":"absolute", "zIndex":"14", "left":"624px", "top":"621px", "width":"35px", "height":"18px"}} className="input_field" />
		
		<select name="TAR_PRC_NAT" value={item.TAR_PRC_NAT} onChange={(e) => { handleCpcChange(e.target.value); handleItemChange(e); }} title="National Procedure Code" style={{"position":"absolute", "zIndex":"14", "left":"670px", "top":"621px", "width":"45px", "height":"18px"}}  >
		{lsCpc}
		</select>
		

	<input type="text" name="Fld_39" title="Quota reference" style={{"position":"absolute", "zIndex":"50", "left":"862px", "top":"621px", "width":"70px", "height":"18px"}} className="input_field" />
	
	<input type="text" name="Ftx_31c3" title="Container Number 3" style={{"visibility":"hidden", "position":"absolute", "zIndex":"52", "left":"375px", "top":"637px", "width":"90px", "height":"18px"}} className="input_field" />
	<input type="text" name="Ftx_31c4" title="Container Number 4" style={{"visibility":"hidden", "position":"absolute", "zIndex":"53", "left":"460px", "top":"637px", "width":"90px", "height":"18px"}} className="input_field" />
	<textarea name="GDS_DSC" defaultValue={item.GDS_DSC}   readOnly  onFocus={handleFocus} title="Description of goods" style={{"position":"absolute", "zIndex":"54", "left":"81px", "top":"656px", "width":"522px", "height":"29px"}} className="input_field"  ></textarea>
	<input type="text" name="Fld_40" defaultValue={item.LNK_TPT}  onFocus={handleFocus}  title="Summary declaration (Transport document number)" style={{"position":"absolute", "zIndex":"55", "left":"618px", "top":"662px", "width":"265px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_40s" title="S/L" style={{"position":"absolute", "zIndex":"56", "left":"880px", "top":"662px", "width":"41px", "height":"18px"}} className="input_field" />
	<input type="text" name="GDS_DS3" value={item.GDS_DS3} onChange={handleItemChange} title="Commercial Description of goods" style={{"position":"absolute", "zIndex":"57", "left":"81px", "top":"686px", "width":"522px", "height":"17px"}} className="input_field" />
	

	{/*
	<input type="text" name="Fld_19v" defaultValue={sad.VCL_REF} title="Vehicles Ref. No." style={{"position":"absolute", "zIndex":"51", "left":"210px", "top":"637px", "width":"163px", "height":"18px"}} className="input_field" />
	<input type="text" name="TAR_SUP_COD" defaultValue={item.TAR_SUP_COD} title="Supplementary units, code" style={{"position":"absolute", "zIndex":"58", "left":"608px", "top":"702px", "width":"90px", "height":"18px"}} className="input_field" />
	<input type="text" name="TAR_SUP_QTY" value={item.TAR_SUP_QTY} onChange={handleItemChange} onFocus={handleFocus} title="Supplementary units, quantity" style={{"position":"absolute", "zIndex":"58", "left":"658px", "top":"702px", "width":"90px", "height":"18px"}} className="input_field" />
	<div className='inputlabel' style={{"position":"absolute", "zIndex":"23", "left":"760px", "top":"685px", "width":"124px", "height":"18px"}}  >42 Item Price</div>
	<div className='inputlabel' style={{"position":"absolute", "zIndex":"23", "left":"802px", "top":"726px", "width":"124px", "height":"18px"}}  >45 Adjustment</div>
	
	*/}
	
	<input type="text" name="TAR_PRI" defaultValue={item.TAR_PRI} readOnly onFocus={handleFocus}  title="Item price" style={{"position":"absolute", "zIndex":"59", "left":"759px", "top":"702px", "width":"117px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_44b" title="Licence reference number" style={{"position":"absolute", "zIndex":"60", "left":"162px", "top":"706px", "width":"138px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_44d" title="Value amount deducted from licence" style={{"position":"absolute", "zIndex":"61", "left":"345px", "top":"706px", "width":"105px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_44f" title="Quantity deducted from licence" style={{"position":"absolute", "zIndex":"62", "left":"498px", "top":"706px", "width":"105px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_44g" defaultValue={item.TAR_VDT}  readOnly  onFocus={handleFocus} title="Value details - item" style={{"position":"absolute", "zIndex":"63", "left":"111px", "top":"725px", "width":"492px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_44j" title="A.I. code" style={{"position":"absolute", "zIndex":"64", "left":"759px", "top":"741px", "width":"36px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_45" defaultValue={item.VIT_ADJ} readOnly  onFocus={handleFocus}  title="Rate of adjustment" style={{"position":"absolute", "zIndex":"65", "left":"807px", "top":"741px", "width":"124px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_44i" defaultValue={item.TAR_ATT} readOnly onFocus={handleFocus} title="Attached documents codes - item" style={{"position":"absolute", "zIndex":"66", "left":"111px", "top":"744px", "width":"492px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_44k" title="Previous document reference" style={{"visibility":"hidden", "position":"absolute", "zIndex":"67", "left":"81px", "top":"764px", "width":"342px", "height":"18px"}} className="input_field" />
	
	<select name="TXT_FRE" onChange={handleItemChange} defaultValue={item.TXT_FRE} title="Beneficiary Lookup" style={{"position":"absolute", "zIndex":"68", "left":"165px", "top":"783px", "width":"218px", "height":"18px"}} >
	{combobnf}
	</select>
	
	{/*
	<input type="text" name="TXT_FRE" onChange={handleItemChange} defaultValue={item.TXT_FRE} title="Free text" style={{"position":"absolute", "zIndex":"68", "left":"185px", "top":"783px", "width":"218px", "height":"18px"}} className="input_field" />
	*/}
	
	<input type="text" name="TXT_RSV" onChange={handleItemChange} defaultValue={item.TXT_RSV} title="Beneficiary Lookup Free text" style={{"position":"absolute", "zIndex":"68", "left":"385px", "top":"783px", "width":"218px", "height":"18px"}} className="input_field" />
	
	<input type="text" name="Fld_vin" title="Vin Number" style={{ "visibility":"hidden", "position":"absolute", "zIndex":"69", "left":"625px", "top":"783px", "width":"100px", "height":"18px"}} className="input_field" />
	
	<input type="text" name="VIT_STV" value={item.VIT_STV} readOnly onFocus={handleFocus}  title="Statistical value" style={{"position":"absolute", "zIndex":"70", "left":"759px", "top":"783px", "width":"117px", "height":"18px"}} className="input_field" />
	<input type="text" name="FIN_ACC" defaultValue={sad.FIN_ACC} onChange={handleSadChange}  title="Deferred payment reference" style={{"position":"absolute", "zIndex":"71", "left":"513px", "top":"822px", "width":"195px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_49b" title="Warehouse time delay" style={{"position":"absolute", "zIndex":"72", "left":"867px", "top":"822px", "width":"63px", "height":"18px"}} className="input_field" />

	<input type="text" name="Fld_Ba" title="Total taxes amount by manual input" style={{"position":"absolute", "zIndex":"78", "left":"660px", "top":"846px", "width":"270px", "height":"18px"}}  />
	<input type="text" name="Fcx_Bc"  defaultValue={sad.FIN_MPN}  title="Mode of payment name" style={{"position":"absolute", "zIndex":"89", "left":"660px", "top":"873px", "width":"270px", "height":"18px"}}  />
	{itemtax.htm}
		{/*let top=(item_nbr==1)?827:352; add 55*/}
	{
		/*
		autoplay.on && <textarea name="txtphrase" value={txtphrase.phrase} style={{"position":"absolute","top":"855px", "left":"81px"}} cols="35" rows="3" readOnly  ></textarea>
		*/
		
	}
	
	<input type="text" name="Fld_Be" defaultValue={sad.IDE_AST_SER} title="Assessment - serial number" style={{"position":"absolute", "zIndex":"95", "left":"660px", "top":"897px", "width":"15px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_Be2" defaultValue={sad.IDE_AST_NBR} title="Assessment - number" style={{"position":"absolute", "zIndex":"96", "left":"681px", "top":"897px", "width":"80px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_PstNum" defaultValue={sad.IDE_PST_NBR}  title="Post-entry nb." style={{"position":"absolute", "zIndex":"97", "left":"768px", "top":"897px", "width":"15px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_Bg" defaultValue={sad.IDE_AST_DAT} title="Assessment - date" style={{"position":"absolute", "zIndex":"98", "left":"822px", "top":"897px", "width":"108px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_Bi" title="Receipt - serial number" defaultValue={sad.IDE_RCP_SER} style={{"position":"absolute", "zIndex":"104", "left":"660px", "top":"918px", "width":"15px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_Bj" title="Receipt - number" defaultValue={sad.IDE_RCP_NBR} style={{"position":"absolute", "zIndex":"105", "left":"681px", "top":"918px", "width":"102px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_Bl" title="Receipt - date" defaultValue={sad.IDE_RCP_DAT} style={{"position":"absolute", "zIndex":"106", "left":"822px", "top":"918px", "width":"108px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_Bn" defaultValue={sad.FIN_GTY_AMT}  readOnly  onFocus={handleFocus}title="Guarantee - amount" style={{"position":"absolute", "zIndex":"112", "left":"660px", "top":"939px", "width":"123px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_Bp" defaultValue={sad.FIN_GTY_DAT} readOnly  onFocus={handleFocus} title="Guarantee - date" style={{"position":"absolute", "zIndex":"113", "left":"822px", "top":"939px", "width":"108px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_Br"  defaultValue={sad.FIN_AMT_FEE} readOnly  onFocus={handleFocus}  title="Amount of global taxes for the declaration" style={{"position":"absolute", "zIndex":"119", "left":"660px", "top":"960px", "width":"123px", "height":"18px"}} className="input_field" />
	<input type="text" name="FIN_AMT_DTY" defaultValue={sad.FIN_AMT_DTY}  readOnly  onFocus={handleFocus} title="Total amount of duties & taxes for declaration" style={{"position":"absolute", "zIndex":"125", "left":"660px", "top":"981px", "width":"123px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_47f" defaultValue={itemtax.SUM_TAX_LIN_AMT} readOnly  onFocus={handleFocus}  title="Item amount of Duties and taxes" style={{"position":"absolute", "zIndex":"126", "left":"367px", "top":"985px", "width":"108px", "height":"18px", "textAlign":"right"}} className="input_field" />
	<input type="text" name="Fld_47g" title="Mode of payment for item amount" style={{"position":"absolute", "zIndex":"127", "left":"483px", "top":"985px", "width":"15px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_50a" title="Principal responsible for transit - code" style={{"position":"absolute", "zIndex":"128", "left":"292px", "top":"1007px", "width":"140px", "height":"18px"}} className="input_field" />
	<textarea name="Fld_50b" title="Principal responsible for transit - name" style={{"position":"absolute", "zIndex":"129", "left":"82px", "top":"1028px", "width":"280px", "height":"50px"}} className="input_field"  ></textarea>
	<input type="text" name="Fld_50c" title="Representative of Principal responsible for transit" style={{"position":"absolute", "zIndex":"130", "left":"212px", "top":"1085px", "width":"280px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_50d" title="Place of signature of transit" style={{"position":"absolute", "zIndex":"131", "left":"212px", "top":"1105px", "width":"280px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_50e" title="Date of signature of transit" style={{"position":"absolute", "zIndex":"132", "left":"502px", "top":"1105px", "width":"99px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_52a" title="Guarantee reference code" style={{"position":"absolute", "zIndex":"133", "left":"131px", "top":"1167px", "width":"220px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_54b" title="Date of declaration" style={{"position":"absolute", "zIndex":"134", "left":"816px", "top":"1221px", "width":"105px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_Da" title="Results of control" style={{"position":"absolute", "zIndex":"135", "left":"147px", "top":"1224px", "width":"303px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_Db" title="Seals affixed - Number" style={{"position":"absolute", "zIndex":"136", "left":"147px", "top":"1243px", "width":"42px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_Dc" title="Seals affixed - Identity" style={{"position":"absolute", "zIndex":"137", "left":"192px", "top":"1243px", "width":"153px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_Dd" title="Transit time limit (date)" style={{"position":"absolute", "zIndex":"138", "left":"351px", "top":"1243px", "width":"99px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_De" title="Customs officer name" style={{"position":"absolute", "zIndex":"139", "left":"147px", "top":"1263px", "width":"198px", "height":"18px"}} className="input_field" />
	<input type="text" name="Fld_54c" defaultValue={sad.DEC_REP} readOnly  onFocus={handleFocus} title="Name of representative of declarant" style={{"position":"absolute", "zIndex":"140", "left":"615px", "top":"1263px", "width":"192px", "height":"18px"}} className="input_field" />
  </div>	  
	  
	      <div id="Item" className="tabcontent"  >
        <img src="img/un.broker.asysad.client.VP_Itm.png" />
		

		{itmelems}
		
		<a href="#" onClick={(e)=>{e.preventDefault(); openCity(null,'TariffExpert');}} style={{"position":"absolute", "zIndex":"38", "left":"724px", "top":"49px"}} title="open Tariff Expert" ><img src="img/Btn_View_Normal.png" border="0"  /></a>
		
        <input type="text" name="Fld_34b" onChange={handleItemChange} defaultValue={item.GDS_ORG_CTY} title="Country of origin - region code" style={{"position":"absolute", "zIndex":"10", "left":"685px", "top":"106px", "width":"30px", "height":"18px"}} className="input_field" />
        <input type="text" name="VIT_WGT_GRS" onChange={handleItemChange} value={item.VIT_WGT_GRS} onFocus={handleFocus} title="Gross mass" style={{"position":"absolute", "zIndex":"11", "left":"724px", "top":"106px", "width":"129px", "height":"18px"}} className="input_field" />
        <input type="text" name="Ftx_31c1" title="Container Number 1" style={{"display":"none", "position":"absolute", "zIndex":"12", "left":"184px", "top":"143px", "width":"190px", "height":"18px"}} className="input_field" />
        <input type="text" name="Ftx_31c2" title="Container Number 2" style={{"display":"none", "position":"absolute", "zIndex":"13", "left":"376px", "top":"143px", "width":"190px", "height":"18px"}} className="input_field" />
		
		<select name="TAR_PRC_NAT" value={item.TAR_PRC_NAT} onChange={(e) => { handleCpcChange(e.target.value); handleItemChange(e); }} title="National Procedure Code" style={{"position":"absolute", "zIndex":"14", "left":"670px", "top":"146px", "width":"45px", "height":"18px"}}  >
		{lsCpc}
		</select>
        <textarea name="GDS_DSC" defaultValue={item.GDS_DSC}  readOnly  onFocus={handleFocus} title="Description of goods" style={{"position":"absolute", "zIndex":"18", "left":"82px", "top":"181px", "width":"522px", "height":"29px"}} className="input_field" ></textarea>

		<input type="text" name="Fld_47f" defaultValue={itemtax.SUM_TAX_LIN_AMT} readOnly  onFocus={handleFocus} title="Item amount of Duties and taxes" style={{"position":"absolute", "zIndex":"75", "left":"367px", "top":"510px", "width":"108px", "height":"18px", "textAlign":"right"}}  />

			{/*

        <input type="text" name="VIT_WGT_NET" onChange={handleItemChange} value={item.VIT_WGT_NET} onFocus={handleFocus} title="Net mass" style={{"position":"absolute", "zIndex":"14", "left":"724px", "top":"146px", "width":"129px", "height":"18px"}} className="input_field" />
        <input type="text" name="TAR_PRC_EXT" defaultValue={item.TAR_PRC_EXT} title="Extended Procedure Code"  readOnly  onFocus={handleFocus} style={{"position":"absolute", "zIndex":"14", "left":"624px", "top":"146px", "width":"35px", "height":"18px"}} className="input_field" />
        <input type="text" name="LNK_TPT" onChange={handleItemChange}  value={item.LNK_TPT} onFocus={handleFocus}  title="Summary declaration (Transport document number)" style={{"position":"absolute", "zIndex":"19", "left":"619px", "top":"185px", "width":"265px", "height":"18px"}} className="input_field" />
        <input type="text" name="GDS_DS3" onChange={handleItemChange} value={item.GDS_DS3}  title="Commercial description  of goods" style={{"position":"absolute", "zIndex":"21", "left":"82px", "top":"210px", "width":"522px", "height":"17px"}} className="input_field" />
		<input type="text" name="TAR_SUP_COD" onChange={handleItemChange} value={item.TAR_SUP_COD} title="Supplementary units, code" style={{"position":"absolute", "zIndex":"22", "left":"621px", "top":"226px", "width":"40px", "height":"18px"}} className="input_field" />
		<input type="text" name="TAR_SUP_QTY" onChange={handleItemChange} value={item.TAR_SUP_QTY} onFocus={handleFocus} title="Supplementary units, quantity" style={{"position":"absolute", "zIndex":"58", "left":"675px", "top":"226px", "width":"40px", "height":"18px"}} className="input_field" />
        <input type="text" name="VIT_STV" readOnly defaultValue={item.VIT_STV} onFocus={handleFocus} title="Statistical value" style={{"position":"absolute", "zIndex":"34", "left":"760px", "top":"308px", "width":"172px", "height":"18px"}}  />
        <input type="text" name="Fld_47f" defaultValue={itemtax.SUM_TAX_LIN_AMT} readOnly  onFocus={handleFocus} title="Item amount of Duties and taxes" style={{"position":"absolute", "zIndex":"75", "left":"367px", "top":"510px", "width":"108px", "height":"18px", "textAlign":"right"}}  />
		<input type="text" name="TXT_RSV" onChange={handleItemChange} value={item.TXT_RSV} onFocus={handleFocus} title="Beneficiary Lookup Free text" style={{"position":"absolute", "zIndex":"32", "left":"385px", "top":"308px", "width":"195px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_44g" defaultValue={item.TAR_VDT} title="Value details - item" style={{"position":"absolute", "zIndex":"27", "left":"112px", "top":"250px", "width":"492px", "height":"18px"}} className="input_field" />
        <input type="text" name="VIT_ADJ"  onChange={handleItemChange} defaultValue={item.VIT_ADJ} title="Rate of adjustment" style={{"position":"absolute", "zIndex":"29", "left":"808px", "top":"266px", "width":"124px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_44i" defaultValue={item.TAR_ATT} title="Attached documents codes - item" style={{"position":"absolute", "zIndex":"30", "left":"112px", "top":"269px", "width":"492px", "height":"18px"}} className="input_field" />
		<input type="text" name="TAR_PRI"  defaultValue={item.TAR_PRI} readOnly onFocus={handleFocus} title="Item price" style={{"position":"absolute", "zIndex":"23", "left":"760px", "top":"227px", "width":"117px", "height":"18px"}} className="input_field" />


		<div className='inputlabel' style={{"position":"absolute", "zIndex":"23", "left":"760px", "top":"210px", "width":"124px", "height":"18px"}}  >42 Item Price</div>
		<div className='inputlabel' style={{"position":"absolute", "zIndex":"23", "left":"802px", "top":"250px", "width":"124px", "height":"18px"}}  >45 Adjustment</div>
			
			*/}
		
        <input type="text" readOnly name="Fld_39" title="Quota reference" style={{"position":"absolute", "zIndex":"15", "left":"863px", "top":"146px", "width":"70px", "height":"18px"}} className="input_field" />
        <input type="text" readOnly name="Ftx_31c3" title="Container Number 3" style={{"display":"none", "position":"absolute", "zIndex":"16", "left":"184px", "top":"162px", "width":"190px", "height":"18px"}} className="input_field" />
        <input type="text" readOnly name="Ftx_31c4" title="Container Number 4" style={{"display":"none", "position":"absolute", "zIndex":"17", "left":"376px", "top":"162px", "width":"190px", "height":"18px"}} className="input_field" />
        <input type="text" readOnly name="Fld_40s" title="S/L" style={{"position":"absolute", "zIndex":"20", "left":"880px", "top":"185px", "width":"41px", "height":"18px"}} className="input_field" />


        <input type="text" readOnly name="Fld_44b" title="Licence reference number" style={{"position":"absolute", "zIndex":"24", "left":"163px", "top":"231px", "width":"138px", "height":"18px"}} className="input_field" />
        <input type="text" readOnly name="Fld_44d" title="Value amount deducted from licence" style={{"position":"absolute", "zIndex":"25", "left":"346px", "top":"231px", "width":"105px", "height":"18px"}} className="input_field" />
        <input type="text" readOnly name="Fld_44f" title="Quantity deducted from licence" style={{"position":"absolute", "zIndex":"26", "left":"499px", "top":"231px", "width":"105px", "height":"18px"}} className="input_field" />
        <input type="text" readOnly name="Fld_44j" title="A.I. code" style={{"position":"absolute", "zIndex":"28", "left":"760px", "top":"266px", "width":"36px", "height":"18px"}} className="input_field" />
        <input type="text" readOnly name="Fld_44k" title="Previous document reference" style={{"position":"absolute", "zIndex":"31", "left":"82px", "top":"289px", "width":"342px", "height":"18px"}} className="input_field" />
        
	<select name="TXT_FRE" onChange={handleItemChange} value={item.TXT_FRE} title="Beneficiary Lookup" style={{"position":"absolute", "zIndex":"68", "left":"160px", "top":"308px", "width":"218px", "height":"18px"}} >
	{combobnf}
	</select>
		
        <input type="text" name="Fld_vin" title="Vin Number" style={{ "visibility":"hidden", "position":"absolute", "zIndex":"33", "left":"625px", "top":"308px", "width":"100px", "height":"18px"}}  />
		{itemtax.htm}
        <input type="text" name="Fld_47g" title="Mode of payment for item amount" style={{"position":"absolute", "zIndex":"76", "left":"484px", "top":"510px", "width":"15px", "height":"18px"}}  />
      </div>

	  
	<div id="itemValueNote" className="tabcontent" >
        <img src="img/un.broker.asysad.client.VP_ValItm.png" />
		
		
		{ivnelems}
		

		
        <input type="text" name="Fld_Srp_Vin" title="Suggested retail price" style={{"position":"absolute", "zIndex":"20", "left":"680px", "top":"315px", "width":"177px", "height":"18px"}} className="input_fieldr" />
        <input type="text" name="Fld_Vit_Cst" defaultValue={item.VIT_CST} readOnly  title="Amount of added costs in national monetary units" style={{"position":"absolute", "zIndex":"21", "left":"680px", "top":"345px", "width":"177px", "height":"18px"}} className="input_fieldr" />
        <input type="text" name="Fld_Vit_Tod_Cod" defaultValue={sad.TPT_TOD_COD} readOnly title="Incoterm, code" style={{"position":"absolute", "zIndex":"22", "left":"160px", "top":"375px", "width":"45px", "height":"18px"}} className="input_fieldr" />
        <input type="text" name="Fld_TPT_TOD_PLC" defaultValue={sad.TPT_TOD_PLC} readOnly title="Incoterm, place" style={{"position":"absolute", "zIndex":"23", "left":"220px", "top":"375px", "width":"252px", "height":"18px"}} className="input_fieldr" />
        <input type="text" name="Fld_Vit_Cif" defaultValue={item.VIT_CIF} readOnly title="CIF amount in national monetary units" style={{"position":"absolute", "zIndex":"24", "left":"680px", "top":"375px", "width":"177px", "height":"18px"}} className="input_fieldr" />
        <input type="text" name="Fld_Vit_Stv" defaultValue={item.VIT_STV} readOnly title="Statistical value" style={{"position":"absolute", "zIndex":"25", "left":"680px", "top":"405px", "width":"177px", "height":"18px"}} className="input_fieldr" />
        <input type="text" name="Fld_Vit_Su1_Qty" title="Supplementary value 1 amount" style={{"position":"absolute", "zIndex":"26", "left":"740px", "top":"510px", "width":"153px", "height":"18px"}} className="input_fieldr" />
        <input type="text" name="Fld_Vit_Su2_Qty" title="Supplementary value 2 amount" style={{"position":"absolute", "zIndex":"27", "left":"740px", "top":"540px", "width":"153px", "height":"18px"}} className="input_fieldr" />
        <input type="text" name="Fld_Vit_Mkt_Rat" title="Market value rate" style={{"position":"absolute", "zIndex":"28", "left":"250px", "top":"590px", "width":"126px", "height":"18px"}} className="input_fieldr" />
        <input type="text" name="Fld_Vit_Mkt_Cur_Cod" title="National currency code" style={{"position":"absolute", "zIndex":"29", "left":"390px", "top":"590px", "width":"45px", "height":"18px"}} className="input_fieldr" />
        <input type="text" name="Fld_Vit_Mkt_Bas_Dsc" title="Market value basis description" style={{"position":"absolute", "zIndex":"30", "left":"540px", "top":"590px", "width":"261px", "height":"18px"}} className="input_fieldr" />
        <input type="text" name="Fld_Vit_Mkt_Bas_Amt" title="Market value basis amount" style={{"position":"absolute", "zIndex":"31", "left":"250px", "top":"620px", "width":"126px", "height":"18px"}} className="input_fieldr" />
        <input type="text" name="Fld_Vit_Mkt_Amt_Nmu" title="Market value amount" style={{"position":"absolute", "zIndex":"32", "left":"540px", "top":"620px", "width":"153px", "height":"18px"}} className="input_fieldr" />
      </div>	  

      <div id="valuationNote" className="tabcontent" >
        <img src="img/un.broker.asysad.client.VP_Val.png" />
        {/*<select name="Fcx_Vgs_Wrk" title="Calculation working mode" style={{"position":"absolute", "zIndex":"1", "left":"145px", "top":"50px", "width":"230px", "height":"18px"}} className="list_field" ></select>*/}
        <input type="text" name="Fld_Vgs_Inv_Amt_Fcx" title="Amount of the invoice in foreign currency" style={{"position":"absolute", "zIndex":"2", "left":"270px", "top":"135px", "width":"135px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Inv_Cur_Rat" title="Currrency rate for the invoice" style={{"position":"absolute", "zIndex":"3", "left":"540px", "top":"135px", "width":"141px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Inv_Amt_Nmu" title="Amount of the invoice in national monetary units" style={{"position":"absolute", "zIndex":"4", "left":"710px", "top":"135px", "width":"177px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Efr_Amt_Fcx" title="Amount of the external freight in foreign currency" style={{"position":"absolute", "zIndex":"5", "left":"270px", "top":"165px", "width":"135px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Efr_Cur_Rat" title="Exchange rate for the external freight" style={{"position":"absolute", "zIndex":"6", "left":"540px", "top":"165px", "width":"141px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Efr_Amt_Nmu" title="Amount of the external freight in national monetary units" style={{"position":"absolute", "zIndex":"7", "left":"710px", "top":"165px", "width":"177px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Ifr_Amt_Fcx" title="Amount of the internal freight in foreign currency" style={{"position":"absolute", "zIndex":"8", "left":"270px", "top":"195px", "width":"135px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Ifr_Cur_Rat" title="Exchange rate for the internal freight" style={{"position":"absolute", "zIndex":"9", "left":"540px", "top":"195px", "width":"141px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Ifr_Amt_Nmu" title="Amount of the internal freight in national monetary units" style={{"position":"absolute", "zIndex":"10", "left":"710px", "top":"195px", "width":"177px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Ins_Amt_Fcx" title="Amount of the insurance in foreign currency" style={{"position":"absolute", "zIndex":"11", "left":"270px", "top":"225px", "width":"135px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Ins_Cur_Rat" title="Exchange rate for the insurance" style={{"position":"absolute", "zIndex":"12", "left":"540px", "top":"225px", "width":"141px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Ins_Amt_Nmu" title="Amount of the insurance in national monetary units" style={{"position":"absolute", "zIndex":"13", "left":"710px", "top":"225px", "width":"177px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Otc_Amt_Fcx" title="Amount of the other costs in foreign currency" style={{"position":"absolute", "zIndex":"14", "left":"270px", "top":"255px", "width":"135px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Otc_Cur_Rat" title="Exchange rate for the other costs" style={{"position":"absolute", "zIndex":"15", "left":"540px", "top":"255px", "width":"141px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Otc_Amt_Nmu" title="Amount of the other costs in national monetary units" style={{"position":"absolute", "zIndex":"16", "left":"710px", "top":"255px", "width":"177px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Ded_Amt_Fcx" title="Amount of the deductions in foreign currency" style={{"position":"absolute", "zIndex":"17", "left":"270px", "top":"285px", "width":"135px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Ded_Cur_Rat" title="Exchange rate for the deductions" style={{"position":"absolute", "zIndex":"18", "left":"540px", "top":"285px", "width":"141px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Ded_Amt_Nmu" title="Amount of the deductions in national monetary units" style={{"position":"absolute", "zIndex":"19", "left":"710px", "top":"285px", "width":"177px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Wgt_Grs" title="Gross mass" style={{"position":"absolute", "zIndex":"20", "left":"190px", "top":"345px", "width":"174px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Cst" title="Total amount of added costs in national monetary units" style={{"position":"absolute", "zIndex":"21", "left":"710px", "top":"345px", "width":"177px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Tod_Cod" title="Incoterm, code" style={{"position":"absolute", "zIndex":"22", "left":"190px", "top":"375px", "width":"45px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Tod_Plc" title="Incoterm, place" style={{"position":"absolute", "zIndex":"23", "left":"250px", "top":"375px", "width":"252px", "height":"18px"}} className="input_field" />
        <input type="text" name="Fld_Vgs_Cif" title="Total CIF amount in national monetary units" style={{"position":"absolute", "zIndex":"24", "left":"710px", "top":"375px", "width":"177px", "height":"18px"}} className="input_field" />
      </div>	  
	  
      <div id="asmtNotice"  className="tabcontent"  >
        <img src="img/un.broker.asysad.client.VP_Asn.png" />
        <input type="text" name="Fcx_OffCod" title="Office Code" style={{"position":"absolute", "zIndex":"1", "left":"50px", "top":"80px", "width":"41px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fcx_OffNam" title="Office Name" style={{"position":"absolute", "zIndex":"2", "left":"100px", "top":"80px", "width":"150px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Model" title="Model of Declaration" style={{"position":"absolute", "zIndex":"3", "left":"50px", "top":"140px", "width":"15px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Regime" title="General Regime" style={{"position":"absolute", "zIndex":"4", "left":"75px", "top":"140px", "width":"10px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegYear" title="Registration Year" style={{"position":"absolute", "zIndex":"5", "left":"130px", "top":"140px", "width":"30px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegSer" title="Registration serial" style={{"position":"absolute", "zIndex":"6", "left":"170px", "top":"140px", "width":"15px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegNbr" title="Registration number" style={{"position":"absolute", "zIndex":"7", "left":"190px", "top":"140px", "width":"100px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegDat" title="Registration Date" style={{"position":"absolute", "zIndex":"8", "left":"300px", "top":"140px", "width":"80px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DecYea" title="Declarant reference Year" style={{"position":"absolute", "zIndex":"9", "left":"410px", "top":"140px", "width":"30px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DecRef" title="Declarant reference number" style={{"position":"absolute", "zIndex":"10", "left":"450px", "top":"140px", "width":"100px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AssYea" title="Assessment Year" style={{"position":"absolute", "zIndex":"11", "left":"580px", "top":"140px", "width":"30px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AssSer" title="Assessment Serial" style={{"position":"absolute", "zIndex":"12", "left":"620px", "top":"140px", "width":"15px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AssNbr" title="Assessment Number" style={{"position":"absolute", "zIndex":"13", "left":"640px", "top":"140px", "width":"100px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_PstNum" title="Post-entry nb." style={{"position":"absolute", "zIndex":"14", "left":"747px", "top":"140px", "width":"18px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AssDat" title="Assessment Date" style={{"position":"absolute", "zIndex":"15", "left":"769px", "top":"140px", "width":"80px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_NbrItm" title="Number of items" style={{"position":"absolute", "zIndex":"16", "left":"870px", "top":"140px", "width":"30px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fcx_DecCod" title="Declarant Code" style={{"position":"absolute", "zIndex":"17", "left":"50px", "top":"200px", "width":"140px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fcx_CmpCod" title="Company Code" style={{"position":"absolute", "zIndex":"18", "left":"490px", "top":"200px", "width":"140px", "height":"20px"}} className="input_field" />
        <textarea name="Fcx_DecNam" title="Declarant Name" style={{"position":"absolute", "zIndex":"19", "left":"50px", "top":"240px", "width":"300px", "height":"80px"}} className="input_field" ></textarea>
        <textarea name="Fcx_CmpNam" title="Company Name" style={{"position":"absolute", "zIndex":"20", "left":"490px", "top":"240px", "width":"300px", "height":"80px"}} className="input_field" ></textarea>
        <input type="text" name="Fld_ModPay" title="Mode of Payment" style={{"position":"absolute", "zIndex":"21", "left":"50px", "top":"360px", "width":"140px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AccCod" title="Accounting Code" style={{"position":"absolute", "zIndex":"22", "left":"240px", "top":"360px", "width":"140px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RcpSer" title="Receipt Serial" style={{"position":"absolute", "zIndex":"23", "left":"430px", "top":"360px", "width":"15px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RcpNbr" title="Receipt Number" style={{"position":"absolute", "zIndex":"24", "left":"450px", "top":"360px", "width":"100px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RcpDat" title="Receipt Date" style={{"position":"absolute", "zIndex":"25", "left":"560px", "top":"360px", "width":"80px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_StaSer" title="Statement Serial" style={{"position":"absolute", "zIndex":"26", "left":"700px", "top":"360px", "width":"15px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_StaNbr" title="Statement Number" style={{"position":"absolute", "zIndex":"27", "left":"720px", "top":"360px", "width":"100px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_StaDat" title="Statement Date" style={{"position":"absolute", "zIndex":"28", "left":"830px", "top":"360px", "width":"80px", "height":"20px"}} className="input_field" />

		{asmtnotice.htm}
        <input type="text" name="TAR_PRI" defaultValue={asmtnotice.TAR_PRI} title="Total Item Value (US $)" style={{"position":"absolute", "zIndex":"2", "left":"800px", "top":"80px", "width":"80px", "height":"20px"}} className="input_field" />
        <input type="text" name="WGT_NET" defaultValue={asmtnotice.WGT_NET} title="Total Item Mass" style={{"position":"absolute", "zIndex":"2", "left":"600px", "top":"80px", "width":"80px", "height":"20px"}} className="input_field" />
        <input type="text" name="PCK_NBRx" defaultValue={asmtnotice.PCK_NBR} title="Total Item Packages" style={{"position":"absolute", "zIndex":"2", "left":"700px", "top":"80px", "width":"80px", "height":"20px"}} className="input_field" />


        <input type="text" name="Fld_GloTot"  title="Total Global Taxes" style={{"position":"absolute", "zIndex":"53", "left":"790px", "top":"500px", "width":"120px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ItmTx6" title="Items Tax 6" style={{"position":"absolute", "zIndex":"54", "left":"50px", "top":"520px", "width":"25px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ItmDe6" title="Items Tax Description 6" style={{"position":"absolute", "zIndex":"55", "left":"90px", "top":"520px", "width":"240px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ItmAm6" title="Items Tax Amount 6" style={{"position":"absolute", "zIndex":"56", "left":"350px", "top":"520px", "width":"120px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ItmTx7" title="Items Tax 7" style={{"position":"absolute", "zIndex":"57", "left":"50px", "top":"540px", "width":"25px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ItmDe7" title="Items Tax Description 7" style={{"position":"absolute", "zIndex":"58", "left":"90px", "top":"540px", "width":"240px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ItmAm7" title="Items Tax Amount 7" style={{"position":"absolute", "zIndex":"59", "left":"350px", "top":"540px", "width":"120px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ItmTx8" title="Items Tax 8" style={{"position":"absolute", "zIndex":"60", "left":"50px", "top":"560px", "width":"25px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ItmDe8" title="Items Tax Description 8" style={{"position":"absolute", "zIndex":"61", "left":"90px", "top":"560px", "width":"240px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ItmAm8" title="Items Tax Amount 8" style={{"position":"absolute", "zIndex":"62", "left":"350px", "top":"560px", "width":"120px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ItnTot" title="Total Items Taxes" style={{"position":"absolute", "zIndex":"63", "left":"350px", "top":"600px", "width":"120px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_TotGen" title="Total General" style={{"position":"absolute", "zIndex":"64", "left":"790px", "top":"600px", "width":"120px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_SitPay" title="Situation of Payment" style={{"position":"absolute", "zIndex":"65", "left":"630px", "top":"640px", "width":"140px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_SitAmt" title="Amount for the Situation of payment" style={{"position":"absolute", "zIndex":"66", "left":"790px", "top":"640px", "width":"120px", "height":"20px"}} className="input_field" />
      </div>
	
       


       <div id="Attached_Documents"  className="tabcontent"  >
        <img src="img/un.broker.asysad.client.VP_AttDoc.png" />
        <input type="text" name="Fcx_OffCod" title="Office Code" defaultValue={sad.IDE_CUO_COD} readOnly style={{"position":"absolute", "xIndex":"1", "left":"20px", "top":"80px", "width":"41px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fcx_OffNam" title="Office Name" defaultValue={sad.IDE_CUO_NAM} readOnly style={{"position":"absolute", "xIndex":"2", "left":"70px", "top":"80px", "width":"150px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Model" title="Model of Declaration" defaultValue={sad.IDE_TYP_SAD} readOnly style={{"position":"absolute", "xIndex":"3", "left":"20px", "top":"140px", "width":"25px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Regime" title="General Regime" defaultValue={sad.IDE_TYP_PRC} readOnly style={{"position":"absolute", "xIndex":"4", "left":"45px", "top":"140px", "width":"20px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegYear" title="Registration Year" defaultValue={sad.AST_RYR} readOnly style={{"position":"absolute", "xIndex":"5", "left":"100px", "top":"140px", "width":"40px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegSer" title="Registration serial" defaultValue={sad.IDE_REG_SER} readOnly style={{"position":"absolute", "xIndex":"6", "left":"140px", "top":"140px", "width":"15px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegNbr" title="Registration number" defaultValue={sad.IDE_REG_NBR} readOnly style={{"position":"absolute", "xIndex":"7", "left":"160px", "top":"140px", "width":"100px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegDat" title="Registration Date" defaultValue={sad.IDE_REG_DAT} readOnly style={{"position":"absolute", "xIndex":"8", "left":"270px", "top":"140px", "width":"80px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DecYea" title="Declarant reference Year" defaultValue={sad.DEC_REF_YER} readOnly style={{"position":"absolute", "xIndex":"9", "left":"380px", "top":"140px", "width":"30px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DecRef" title="Declarant reference number" defaultValue={sad.DEC_REF_NBR} readOnly style={{"position":"absolute", "xIndex":"10", "left":"420px", "top":"140px", "width":"100px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AssYea" title="Assessment Year" style={{"position":"absolute", "xIndex":"11", "left":"550px", "top":"140px", "width":"30px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AssSer" title="Assessment Serial" style={{"position":"absolute", "xIndex":"12", "left":"590px", "top":"140px", "width":"15px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AssNbr" title="Assessment Number" style={{"position":"absolute", "xIndex":"13", "left":"610px", "top":"140px", "width":"100px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_PstNum" title="Post-entry nb." style={{"position":"absolute", "xIndex":"14", "left":"717px", "top":"140px", "width":"18px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AssDat" title="Assessment Date" style={{"position":"absolute", "xIndex":"15", "left":"739px", "top":"140px", "width":"80px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_NbrItm" title="Number of items" style={{"position":"absolute", "xIndex":"16", "left":"840px", "top":"140px", "width":"30px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fcx_DecCod" title="Declarant Code" defaultValue={sad.DEC_COD} readOnly style={{"position":"absolute", "xIndex":"17", "left":"20px", "top":"200px", "width":"140px", "height":"20px"}} className="input_field" />
        <textarea name="Fcx_DecNam" title="Declarant Name" defaultValue={sad.DEC_NAM} readOnly style={{"position":"absolute", "xIndex":"18", "left":"20px", "top":"220px", "width":"300px", "height":"80px"}} className="input_field" ></textarea>
		<input type="text" name="Fcx_Instanceid" title="Instanceid" defaultValue={sad.INSTANCEID} readOnly style={{"position":"absolute", "xIndex":"17", "left":"20px", "top":"300px", "width":"140px", "height":"20px"}} className="input_field" />

		
	
		{userattdoc.KEY_ITM_NBR>0 && dlwait.show==true && <><div align="center" className="loadPdfFile" ><img src="img/Loading_2.gif" height="36" border="0" /> . . . please wait</div></>}
		{userattdoc.KEY_ITM_NBR>0 && dlwait.show==false && <table align="center" className="loadPdfFile" >
							<tbody>
							<tr><td align="center"><a href="#" className="nodecor" onClick={(e)=>{loadpdffile(e);}} ><img src="img/uploadfile.png" border="0" height="17" />&nbsp;Load Pdf File</a></td></tr>
							<tr><td align="center"><a href="#" className="nodecor" onClick={(e)=>{viewpdffile(e);}} ><img src="img/pdf.gif" border="0" />&nbsp;View Pdf File</a></td></tr>
							</tbody>
							</table>
							}
		
		
		{attachdocs.htm}
		
		{/*
					<input type="text" defaultValue={progress.perct} style={{"position":"absolute", "xIndex":"18", "left":"400px", "top":"240px", "width":"30px", "height":"30px"}}  />
		            <input type="file" onChange={onFileChange}  style={{"position":"absolute", "xIndex":"18", "left":"500px", "top":"240px", "width":"80px", "height":"30px"}} />
					
                    <button onClick={onFileUpload}  style={{"position":"absolute", "xIndex":"18", "left":"600px", "top":"240px", "width":"80px", "height":"30px"}} >
                        Upload!
                    </button>
		
		*/}

      </div>

	   {/*
	   <table align="center" className="customers" >
	   <thead>
	   <tr>
	   <th align="right" >#</th>
	   <th align="center" >Reference</th>
	   <th align="center" >Code</th>
	   <th align="center" >File Name</th>
	   </tr>
	   </thead>
	   <tbody>
	   {attachdocs.htm}
	   </tbody>
	   </table>	   
	   */}

	 
	
       <div id="Containers"  className="tabcontent"  >
        <img src="img/un.broker.asysad.client.VP_Ctn.png" />
        <input type="text" name="Fcx_OffCod" title="Office Code" style={{"position":"absolute", "zIndex":"1", "left":"50px", "top":"80px", "width":"41px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fcx_OffNam" title="Office Name" style={{"position":"absolute", "zIndex":"2", "left":"100px", "top":"80px", "width":"150px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Model" title="Model of Declaration" style={{"position":"absolute", "zIndex":"3", "left":"50px", "top":"140px", "width":"15px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Regime" title="General Regime" style={{"position":"absolute", "zIndex":"4", "left":"75px", "top":"140px", "width":"10px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegYear" title="Registration Year" style={{"position":"absolute", "zIndex":"5", "left":"130px", "top":"140px", "width":"30px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegSer" title="Registration serial" style={{"position":"absolute", "zIndex":"6", "left":"170px", "top":"140px", "width":"15px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegNbr" title="Registration number" style={{"position":"absolute", "zIndex":"7", "left":"190px", "top":"140px", "width":"100px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegDat" title="Registration Date" style={{"position":"absolute", "zIndex":"8", "left":"300px", "top":"140px", "width":"80px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DecYea" title="Declarant reference Year" style={{"position":"absolute", "zIndex":"9", "left":"410px", "top":"140px", "width":"30px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DecRef" title="Declarant reference number" style={{"position":"absolute", "zIndex":"10", "left":"450px", "top":"140px", "width":"100px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AssYea" title="Assessment Year" style={{"position":"absolute", "zIndex":"11", "left":"580px", "top":"140px", "width":"30px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AssSer" title="Assessment Serial" style={{"position":"absolute", "zIndex":"12", "left":"620px", "top":"140px", "width":"15px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AssNbr" title="Assessment Number" style={{"position":"absolute", "zIndex":"13", "left":"640px", "top":"140px", "width":"100px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_PstNum" title="Post-entry nb." style={{"position":"absolute", "zIndex":"14", "left":"747px", "top":"140px", "width":"18px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AssDat" title="Assessment Date" style={{"position":"absolute", "zIndex":"15", "left":"769px", "top":"140px", "width":"80px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_NbrItm" title="Number of items" style={{"position":"absolute", "zIndex":"16", "left":"870px", "top":"140px", "width":"30px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fcx_DecCod" title="Declarant Code" style={{"position":"absolute", "zIndex":"17", "left":"50px", "top":"200px", "width":"140px", "height":"20px"}} className="input_field" />
        <textarea name="Fcx_DecNam" title="Declarant Name" style={{"position":"absolute", "zIndex":"18", "left":"50px", "top":"240px", "width":"300px", "height":"80px"}} className="input_field" ></textarea>
        {/*
		<input type="image" name="Btn_add" src="img/un.broker.asysad.client.VP_Ctn.Btn_add_Btn.gif" alt="Add container" title="Add container" style={{"position":"absolute", "zIndex":"19", "left":"40px", "top":"355px", "width":"35px", "height":"29px"}} />
		*/}
		{containers.htm}
		</div>


      <div id="PreviousDocument"  className="tabcontent"  >
        <img src="img/un.broker.asysad.client.VP_Int.png" />
        <input type="text" name="fld_RegDate" title="Registration - year" style={{"position":"absolute", "zIndex":"1", "left":"130px", "top":"165px", "width":"65px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_RegSer" title="Registration - serial number" style={{"position":"absolute", "zIndex":"2", "left":"200px", "top":"165px", "width":"15px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_RegNbr" title="Registration - number" style={{"position":"absolute", "zIndex":"3", "left":"220px", "top":"165px", "width":"90px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_NumArtPrec" title="Item number" style={{"position":"absolute", "zIndex":"4", "left":"335px", "top":"165px", "width":"30px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_CommCodeNb1" title="Harmonized system commodity code" style={{"position":"absolute", "zIndex":"5", "left":"390px", "top":"165px", "width":"90px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_CommCodeNb2" title="Commodity code (national precision # 2" style={{"position":"absolute", "zIndex":"6", "left":"495px", "top":"165px", "width":"30px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_PckNbr_Ini" title="Number of packages" style={{"position":"absolute", "zIndex":"7", "left":"725px", "top":"165px", "width":"48px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_NetWeight_Ini" title="Net mass" style={{"position":"absolute", "zIndex":"8", "left":"795px", "top":"165px", "width":"100px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_SupQty_Ini" title="Sup. Unit" style={{"position":"absolute", "zIndex":"9", "left":"915px", "top":"165px", "width":"100px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_ValUnit" title="Reference CIF value" style={{"position":"absolute", "zIndex":"10", "left":"1035px", "top":"165px", "width":"150px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_PckNbr_Res" title="Number of packages" style={{"position":"absolute", "zIndex":"11", "left":"725px", "top":"215px", "width":"48px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_NetWeight_Res" title="Net mass" style={{"position":"absolute", "zIndex":"12", "left":"795px", "top":"215px", "width":"100px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_SupQty_Res" title="Sup. Unit" style={{"position":"absolute", "zIndex":"13", "left":"915px", "top":"215px", "width":"100px", "height":"18px"}} className="input_field" />
        <input type="image" name="Btn_add" src="img/un.broker.asysad.client.VP_Int.Btn_add_Btn.gif" alt="Add intrant" title="Add intrant" style={{"position":"absolute", "zIndex":"14", "left":"20px", "top":"298px", "width":"35px", "height":"29px"}} />
        <input type="text" name="fld_NumArtCourant" title="Item Number" style={{"position":"absolute", "zIndex":"15", "left":"335px", "top":"308px", "width":"30px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_CommCodeNb1Courant" title="Harmonized system commodity code" style={{"position":"absolute", "zIndex":"16", "left":"390px", "top":"308px", "width":"90px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_CommCodeNb2Courant" title="Commodity code (national precision # 2" style={{"position":"absolute", "zIndex":"17", "left":"495px", "top":"308px", "width":"30px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_PckNbr" title="Number of packages" style={{"position":"absolute", "zIndex":"18", "left":"725px", "top":"308px", "width":"48px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_NetWeight" title="Net mass" style={{"position":"absolute", "zIndex":"19", "left":"795px", "top":"308px", "width":"100px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_SupQty" title="Sup. Unit" style={{"position":"absolute", "zIndex":"20", "left":"915px", "top":"308px", "width":"100px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_ValCur" title="Value" style={{"position":"absolute", "zIndex":"21", "left":"1035px", "top":"308px", "width":"150px", "height":"18px"}} className="input_field" />
      </div>





	  
      <div id="PreviousDoc" className="tabcontent"  >
        <img src="img/un.broker.asysad.client.VP_ATT.png" />
        <input type="image" name="Btn_add" src="img/un.broker.asysad.client.VP_ATT.Btn_add_Btn.gif" alt="Add intrant" title="Add intrant" style={{"position":"absolute", "zIndex":"1", "left":"10px", "top":"140px", "width":"35px", "height":"29px"}} />
        <input type="text" name="fld_RegDate" title="Registration - year" style={{"position":"absolute", "zIndex":"2", "left":"130px", "top":"165px", "width":"65px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_RegSer" title="Registration - serial number" style={{"position":"absolute", "zIndex":"3", "left":"200px", "top":"165px", "width":"15px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_RegNbr" title="Registration - number" style={{"position":"absolute", "zIndex":"4", "left":"220px", "top":"165px", "width":"90px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_NumArtPrec" title="Numero Article" style={{"position":"absolute", "zIndex":"5", "left":"335px", "top":"165px", "width":"30px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_CommCodeNb1" title="Harmonized system commodity code" style={{"position":"absolute", "zIndex":"6", "left":"390px", "top":"165px", "width":"90px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_CommCodeNb2" title="Commodity code (national precision # 2" style={{"position":"absolute", "zIndex":"7", "left":"495px", "top":"165px", "width":"30px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_PckNbr_Ini" title="Number of packages" style={{"position":"absolute", "zIndex":"8", "left":"725px", "top":"165px", "width":"48px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_NetWeight_Ini" title="Net mass" style={{"position":"absolute", "zIndex":"9", "left":"795px", "top":"165px", "width":"100px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_SupQty_Ini" title="Sup. Unit" style={{"position":"absolute", "zIndex":"10", "left":"915px", "top":"165px", "width":"100px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_ValUnit" title="Reference CIF value" style={{"position":"absolute", "zIndex":"11", "left":"1035px", "top":"165px", "width":"150px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_PckNbr_Res" title="Number of packages" style={{"position":"absolute", "zIndex":"12", "left":"725px", "top":"215px", "width":"48px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_NetWeight_Res" title="Net mass" style={{"position":"absolute", "zIndex":"13", "left":"795px", "top":"215px", "width":"100px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_SupQty_Res" title="Sup. Unit" style={{"position":"absolute", "zIndex":"14", "left":"915px", "top":"215px", "width":"100px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_PckNbr" title="Number of packages" style={{"position":"absolute", "zIndex":"15", "left":"725px", "top":"308px", "width":"48px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_NetWeight" title="Net mass" style={{"position":"absolute", "zIndex":"16", "left":"795px", "top":"308px", "width":"100px", "height":"18px"}} className="input_field" />
        <input type="text" name="fld_SupQty" title="Sup. Unit" style={{"position":"absolute", "zIndex":"17", "left":"915px", "top":"308px", "width":"100px", "height":"18px"}} className="input_field" />
      </div>
	  

      <div id="Bol" className="tabcontent"  >
        <img src="img/un.asyman.Bol.client.VP_Bol.png" />
        <input type="text" name="Fld_KeyVoyNbr" defaultValue={bol.IDE_VOY} readOnly onFocus={handleFocus} title="Voyage number"  style={{"position":"absolute", "xIndex":"1", "left":"30px", "top":"120px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fdt_KeyDepDat" defaultValue={bol.IDE_DAT} readOnly onFocus={handleFocus} title="Date of departure" style={{"position":"absolute", "xIndex":"2", "left":"220px", "top":"120px", "width":"110px", "height":"20px"}} className="input_field" />

        <input type="text" name="Fdt_BOL_TYP_COD" defaultValue={bol.BOL_TYP_COD} readOnly onFocus={handleFocus} title="B/L Type Code" style={{"position":"absolute", "xIndex":"2", "left":"220px", "top":"160px", "width":"50px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fdt_BOL_TYP_NAM" defaultValue={bol.BOL_TYP_NAM} readOnly onFocus={handleFocus} title="B/L Type Code" style={{"position":"absolute", "xIndex":"2", "left":"285px", "top":"160px", "width":"100px", "height":"20px"}} className="input_field" />
		
		
		
        <input type="text" name="Fdt_ArrDat" defaultValue={bol.GEN_ARR_DAT} readOnly onFocus={handleFocus} title="Date of arrival" style={{"position":"absolute", "xIndex":"3", "left":"495px", "top":"120px", "width":"110px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fdt_ArrTim" defaultValue={bol.GEN_ARR_TIM} readOnly onFocus={handleFocus} title="Time of arrival" style={{"position":"absolute", "xIndex":"4", "left":"620px", "top":"120px", "width":"70px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegYea" defaultValue={bol.GEN_REG_YEA} readOnly onFocus={handleFocus} title="Manifest year of registration" style={{"position":"absolute", "xIndex":"5", "left":"730px", "top":"120px", "width":"50px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegNbr" defaultValue={bol.GEN_REG_NBR} readOnly onFocus={handleFocus} title="Manifest serial registration number" style={{"position":"absolute", "xIndex":"6", "left":"800px", "top":"120px", "width":"70px", "height":"20px"}} className="input_field" />

			{
				/*
				<a href="#" onClick={(e)=>{e.preventDefault(); openCity(null,"Sad");}} style={{"position":"absolute", "left":"800px", "top":"50px", "textDecoration":"none"}} ><img src="img/redletterx.png" border="0" />&nbsp;close window</a>
				*/
				
			}
		
		
        <input type="text" name="Fld_KeyBolRef" defaultValue={bol.IDE_REF} readOnly onFocus={handleFocus} title="Bill of lading reference number" style={{"position":"absolute", "xIndex":"7", "left":"30px", "top":"160px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Lst_Dis" title="Last discharge" style={{"position":"absolute", "xIndex":"8", "left":"570px", "top":"160px", "width":"130px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_BolNbr" defaultValue={bol.BOL_LIN} readOnly onFocus={handleFocus} title="Bill of lading line number " style={{"position":"absolute", "xIndex":"9", "left":"730px", "top":"160px", "width":"60px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_BolSlnNbr" title="Bill of lading sub line number" style={{"position":"absolute", "xIndex":"10", "left":"800px", "top":"160px", "width":"60px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_PrvDoc" defaultValue={bol.BOL_PRV} readOnly onFocus={handleFocus} title="Previous document - B/L reference number of Master B/L" style={{"position":"absolute", "xIndex":"11", "left":"30px", "top":"200px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_UCrNbr" title="Unique Carrier Reference number" style={{"position":"absolute", "xIndex":"12", "left":"495px", "top":"200px", "width":"410px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DepCod" title="Place of loading - code" style={{"position":"absolute", "xIndex":"13", "left":"30px", "top":"240px", "width":"50px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DepNam" title="Place of loading - name" style={{"position":"absolute", "xIndex":"14", "left":"90px", "top":"240px", "width":"240px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DesCod" title="Place of unloading - code" style={{"position":"absolute", "xIndex":"15", "left":"495px", "top":"240px", "width":"50px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DesNam" title="Place of unloading - name" style={{"position":"absolute", "xIndex":"16", "left":"555px", "top":"240px", "width":"240px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_CarCod" defaultValue={bol.GEN_CAR_COD} readOnly onFocus={handleFocus} title="Carrier code" style={{"position":"absolute", "xIndex":"17", "left":"30px", "top":"290px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ExpCod" defaultValue={bol.BOL_EXP_COD} readOnly onFocus={handleFocus} title="Exporter code" style={{"position":"absolute", "xIndex":"18", "left":"495px", "top":"290px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_CarNam" defaultValue={bol.GEN_CAR_NAM} readOnly onFocus={handleFocus} title="Carrier name" style={{"position":"absolute", "xIndex":"19", "left":"30px", "top":"320px", "width":"410px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ExpNam" defaultValue={bol.BOL_EXP_NAM} readOnly onFocus={handleFocus} title="Exporter name" style={{"position":"absolute", "xIndex":"20", "left":"495px", "top":"320px", "width":"410px", "height":"20px"}} className="input_field" />
        <textarea name="Ftx_CarAdd" title="Carrier address" style={{"position":"absolute", "xIndex":"21", "left":"30px", "top":"340px", "width":"410px", "height":"69px"}} className="input_field" ></textarea>
        <textarea name="Ftx_ExpAdd" title="Exporter address" style={{"position":"absolute", "xIndex":"22", "left":"495px", "top":"340px", "width":"410px", "height":"80px"}} className="input_field" ></textarea>
        <input type="text" name="Fcx_ShipCod" title="Shipping Agent code" style={{"position":"absolute", "xIndex":"23", "left":"30px", "top":"418px", "width":"130px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ShipNam" title="Shipping Agent name" style={{"position":"absolute", "xIndex":"24", "left":"160px", "top":"418px", "width":"280px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_MotIde" title="Name of the transporter" style={{"position":"absolute", "xIndex":"25", "left":"495px", "top":"475px", "width":"235px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_NotCod" title="Notify code" style={{"position":"absolute", "xIndex":"26", "left":"30px", "top":"560px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ConCod" title="Consignee code" style={{"position":"absolute", "xIndex":"27", "left":"282px", "top":"560px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ConEml" title="Consignee Email Address" style={{"position":"absolute", "xIndex":"28", "left":"680px", "top":"560px", "width":"220px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_NotNam" title="Notify name" style={{"position":"absolute", "xIndex":"29", "left":"30px", "top":"590px", "width":"410px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_ConNam" defaultValue={bol.BOL_CON_NAM} readOnly onFocus={handleFocus} title="Consignee name" style={{"position":"absolute", "xIndex":"30", "left":"495px", "top":"590px", "width":"410px", "height":"20px"}} className="input_field" />
        <textarea name="Ftx_ConAdd" title="Consignee address" style={{"position":"absolute", "xIndex":"31", "left":"495px", "top":"609px", "width":"410px", "height":"80px"}} className="input_field" ></textarea>
        <textarea name="Ftx_NotAdd" title="Notify address" style={{"position":"absolute", "xIndex":"32", "left":"30px", "top":"610px", "width":"410px", "height":"80px"}} className="input_field" ></textarea>
        <input type="text" name="Fld_CtnNbr" defaultValue={bol.BOL_CTN} readOnly onFocus={handleFocus} title="Number of containers" style={{"position":"absolute", "xIndex":"33", "left":"150px", "top":"720px", "width":"70px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_BolSta" title="B/L status" style={{"position":"absolute", "xIndex":"34", "left":"370px", "top":"720px", "width":"100px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_SubNbr" title="Number of sub B/Ls" style={{"position":"absolute", "xIndex":"35", "left":"720px", "top":"720px", "width":"70px", "height":"20px"}} className="input_field" />
        <textarea name="Ftx_ShpMrk" title="Shipping mark" style={{"position":"absolute", "xIndex":"36", "left":"32px", "top":"799px", "width":"875px", "height":"60px"}} className="input_field" ></textarea>
        <input type="text" name="Fld_PckDcl" defaultValue={bol.BOL_PCK_NBR} readOnly onFocus={handleFocus} title="Number of packages" style={{"position":"absolute", "xIndex":"37", "left":"200px", "top":"870px", "width":"80px", "height":"20px", "textAlign":"right"}} className="input_field" />
        <input type="text" name="Fld_WgtDcl" defaultValue={bol.BOL_GRS} readOnly onFocus={handleFocus} title="Gross mass" style={{"position":"absolute", "xIndex":"38", "left":"545px", "top":"870px", "width":"80px", "height":"20px", "textAlign":"right"}} className="input_field" />
        <input type="text" name="Fld_PckRem" defaultValue={bol.BOL_OPE_PKA} readOnly onFocus={handleFocus} title="Remaining Number of packages" style={{"position":"absolute", "xIndex":"39", "left":"200px", "top":"900px", "width":"80px", "height":"20px", "textAlign":"right"}} className="input_field" />
        <input type="text" name="Fld_WgtRem" defaultValue={bol.BOL_OPE_WGA} readOnly onFocus={handleFocus} title="Remaining Gross mass" style={{"position":"absolute", "xIndex":"40", "left":"545px", "top":"900px", "width":"80px", "height":"20px", "textAlign":"right"}} className="input_field" />
        <input type="text" name="Fld_VolCbm" defaultValue={bol.BOL_CBM} readOnly onFocus={handleFocus} title="Volume in Cubic Meter" style={{"position":"absolute", "xIndex":"41", "left":"825px", "top":"900px", "width":"80px", "height":"20px", "textAlign":"right"}} className="input_field" />
        <textarea name="Ftx_GdsDsc" defaultValue={bol.BOL_GDS_DSC} readOnly onFocus={handleFocus} title="Goods description" style={{"position":"absolute", "xIndex":"42", "left":"30px", "top":"950px", "width":"875px", "height":"70px"}} className="input_field" ></textarea>
        <input type="text" name="Fld_LocInf" title="Location info" style={{"position":"absolute", "xIndex":"43", "left":"585px", "top":"1040px", "width":"320px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_FrgInd" title="Freight P/C indicator" style={{"position":"absolute", "xIndex":"44", "left":"110px", "top":"1080px", "width":"51px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_FrgVal" title="Freight value" style={{"position":"absolute", "xIndex":"45", "left":"410px", "top":"1080px", "width":"90px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_CusVal" title="Customs value" style={{"position":"absolute", "xIndex":"46", "left":"110px", "top":"1120px", "width":"90px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_TrpVal" title="Transport value" style={{"position":"absolute", "xIndex":"47", "left":"410px", "top":"1120px", "width":"90px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_InsVal" title="Insurance value" style={{"position":"absolute", "xIndex":"48", "left":"755px", "top":"1120px", "width":"90px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_SeaNbr" title="Seal number" style={{"position":"absolute", "xIndex":"49", "left":"139px", "top":"1160px", "width":"61px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_SeaMrk" title="Marks of seals" style={{"position":"absolute", "xIndex":"50", "left":"290px", "top":"1160px", "width":"270px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_InfDsc" title="Information" style={{"position":"absolute", "xIndex":"51", "left":"30px", "top":"1200px", "width":"876px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_TrsRef" title="Transit document reference" style={{"position":"absolute", "xIndex":"52", "left":"630px", "top":"1240px", "width":"275px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_TrhRef" title="Transhipment document reference" style={{"position":"absolute", "xIndex":"53", "left":"630px", "top":"1270px", "width":"275px", "height":"20px"}} className="input_field" />
      </div>

	  {/*style={{"display":"none"}} */}
	  
      <div id="InspectionAct"  className="tabcontent"  >
        <img src="img/un.broker.inspact.client.VP_InspAct.png" className="inspactimg" />
		
		<a href="#" title='close inspection act window'  onClick={(e) => { e.preventDefault(); openCity(null,"Sad"); }} style={{"position":"absolute", "left":"640px", "top":"50px", "textDecoration":"none"}} ><img src='img/redletterx.png' border="0" /> close inspection act window</a>
		

		<input type="text" name="Fld_CuoCod" defaultValue={inspact.IDE_CUO_COD} readOnly  onFocus={handleFocus} title="Customs Office Code" style={{"position":"absolute", "zIndex":"3", "left":"140px", "top":"55px", "width":"50px", "height":"20px"}} className="input_field" />
		<input type="text" name="Fld_CuoNam" defaultValue={inspact.IDE_CUO_NAM} readOnly  onFocus={handleFocus} title="Customs Office Name" style={{"position":"absolute", "zIndex":"3", "left":"200px", "top":"55px", "width":"240px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DecCod" defaultValue={inspact.SAD_DEC_COD} readOnly  onFocus={handleFocus} title="Declarant code" style={{"position":"absolute", "zIndex":"1", "left":"30px", "top":"120px", "width":"150px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DecNam" defaultValue={inspact.SAD_DEC_NAM} readOnly  onFocus={handleFocus} title="Declarant name" style={{"position":"absolute", "zIndex":"2", "left":"30px", "top":"160px", "width":"300px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_RegSer" defaultValue={inspact.SAD_REG_SER} readOnly  onFocus={handleFocus} title="Customs reference serial letter" style={{"position":"absolute", "zIndex":"3", "left":"580px", "top":"160px", "width":"20px", "height":"20px"}} className="input_field" />
		
        <input type="text" name="Fld_RegNbr" defaultValue={inspact.SAD_REG_NBR} readOnly  onFocus={handleFocus} title="Customs reference number" style={{"position":"absolute", "zIndex":"4", "left":"610px", "top":"160px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fdt_RegDat" defaultValue={inspact.SAD_REG_DAT} readOnly  onFocus={handleFocus} title="Customs reference date" style={{"position":"absolute", "zIndex":"5", "left":"790px", "top":"160px", "width":"110px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DecRefYea" defaultValue={inspact.SAD_DEC_REF_YEA} readOnly  onFocus={handleFocus} title="Declaration reference year" style={{"position":"absolute", "zIndex":"6", "left":"30px", "top":"200px", "width":"50px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DecRefNbr" defaultValue={inspact.SAD_DEC_REF_NBR} readOnly  onFocus={handleFocus} title="Declaration reference number" style={{"position":"absolute", "zIndex":"7", "left":"100px", "top":"200px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Mod" defaultValue={inspact.SAD_MOD} readOnly  onFocus={handleFocus} title="Model" style={{"position":"absolute", "zIndex":"8", "left":"380px", "top":"200px", "width":"40px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Itm" defaultValue={inspact.SAD_ITM} readOnly  onFocus={handleFocus} title="Items" style={{"position":"absolute", "zIndex":"9", "left":"440px", "top":"200px", "width":"30px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AstSer" defaultValue={inspact.SAD_AST_SER} title="Assessment serial letter" style={{"position":"absolute", "zIndex":"10", "left":"580px", "top":"200px", "width":"20px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AstNbr" defaultValue={inspact.SAD_AST_NBR} readOnly  onFocus={handleFocus} readOnly  onFocus={handleFocus} title="Assessment number" style={{"position":"absolute", "zIndex":"11", "left":"610px", "top":"200px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fdt_AstDat" defaultValue={inspact.SAD_AST_DAT} readOnly  onFocus={handleFocus} title="Assessment date" style={{"position":"absolute", "zIndex":"12", "left":"790px", "top":"200px", "width":"110px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_FrdNam1" title="Fraud description 1" style={{"position":"absolute", "zIndex":"13", "left":"110px", "top":"260px", "width":"400px", "height":"20px"}} className="input_field" />
        <input type="checkbox" name="Fld_Cfm" title="Conform flag" style={{"position":"absolute", "zIndex":"14", "left":"700px", "top":"260px", "width":"20px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_FrdNam2" title="Fraud description 2" style={{"position":"absolute", "zIndex":"15", "left":"110px", "top":"290px", "width":"400px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AmtRev" defaultValue={inspact.SAD_AMT_REV} readOnly  onFocus={handleFocus} title="Loss of revenue" style={{"position":"absolute", "zIndex":"16", "left":"700px", "top":"290px", "width":"150px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_FrdNam3" title="Fraud description 3" style={{"position":"absolute", "zIndex":"17", "left":"110px", "top":"320px", "width":"400px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_AmtRfd" defaultValue={inspact.SAD_AMT_RFD} readOnly  onFocus={handleFocus} title="Refund" style={{"position":"absolute", "zIndex":"18", "left":"700px", "top":"320px", "width":"150px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_FrdNam4" title="Fraud description 4" style={{"position":"absolute", "zIndex":"19", "left":"110px", "top":"350px", "width":"400px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_FrdNam5" title="Fraud description 5" style={{"position":"absolute", "zIndex":"20", "left":"110px", "top":"380px", "width":"400px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_FrdNam6" title="Fraud description 6" style={{"position":"absolute", "zIndex":"21", "left":"110px", "top":"410px", "width":"400px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_PenAmt" title="Penalty amount" style={{"position":"absolute", "zIndex":"22", "left":"30px", "top":"470px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_PenRef" title="Penalty reference" style={{"position":"absolute", "zIndex":"23", "left":"230px", "top":"470px", "width":"360px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fdt_PenDat" title="Penalty date" style={{"position":"absolute", "zIndex":"24", "left":"630px", "top":"470px", "width":"110px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_DisRef" title="Disputed claims reference" style={{"position":"absolute", "zIndex":"25", "left":"230px", "top":"510px", "width":"360px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fdt_DisDat" title="Disputed claims date" style={{"position":"absolute", "zIndex":"26", "left":"630px", "top":"510px", "width":"110px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Cri1" title="Criteria 1" style={{"position":"absolute", "zIndex":"27", "left":"30px", "top":"550px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Cri2" title="Criteria 2" style={{"position":"absolute", "zIndex":"28", "left":"230px", "top":"550px", "width":"160px", "height":"20px"}} className="input_field" />
        <input type="text" name="Fld_Cri3" title="Criteria 3" style={{"position":"absolute", "zIndex":"29", "left":"430px", "top":"550px", "width":"160px", "height":"20px"}} className="input_field" />
        <textarea name="INF" defaultValue={inspact.INF} readOnly className="grey" title="Information" style={{"position":"absolute", "zIndex":"30", "left":"30px", "top":"600px", "width":"880px", "height":"70px"}} className="input_field" ></textarea>
	  </div>


      <div id="Details" className="tabcontent"  >
	  <img src="img/un.broker.asysad.client.VP_Details.png" />
		<table align="left" border="0" id="tbldetails" cellSpacing="0" cellPadding="0" >
		<thead>
		<tr>		
		<th>Version #</th>
		<th>Operation</th>
		<th>Status</th>
		<th>User</th>
		<th>Time</th>
		<th>Owner</th>
		</tr>		
		</thead>
		<tbody>
		{tbldetails}
		</tbody>
		</table>
	  

	  
	  </div>


      <div id="Modified" className="tabcontent"  >
	  <img src="img/un.broker.asysad.client.VP_Modified.png" />
		<table align="left" border="0" id="tblchangeditems" cellSpacing="0" cellPadding="0" >
		<thead>
		<tr>		
		<th>#</th>
		<th>Tariff</th>
		<th>Value (US $)</th>
		<th>Freight (US $)</th>
		<th>Gross (Lbs)</th>
		<th>Net (Lbs)</th>
		<th>Suppl.</th>
		<th>CPC</th>
		<th>ICD</th>
		<th>CPF</th>
		</tr>		
		</thead>
		<tbody>
		{tblchangeditems}
		</tbody>
		</table>
	  
	  </div>

     <div id="SadList" className="tabcontent"  >
	  <img src="img/un.broker.asysad.client.VP_Sadlist.png" />
<div align="center" id="divbtnjobq" >
<a href="#" id='btnjobq' className="nodecor" onClick={(e) => { e.preventDefault(); navigate(`/jobqadm`); }} ><img src="img/jobqueue.png" height="28" border="0" /> return to Job Queue</a>
</div>
		<table align="left" border="1" id="tblsadlist" cellSpacing="0" cellPadding="0" >
		{/*
		<thead>
		<tr>
		<th colSpan="11" >
		
		</th>
		</tr>
		</thead>
		
		*/}
		<tbody>
		{tblvouchers.htm}
		<tr>
		<td colSpan="12" >
			<div align='center'  style={{"marginTop":"12px","marginBottom":"16px"}} >
				{
				sessionStorage.getItem("IRD_LOGIN_ID")!="" && sadpg.RQS_TYP=="Request for Voucher" && <>
				<input type='button' className='button' value={"create vouchers as "+sessionStorage.getItem("IRD_LOGIN_ID")} onClick={getprepinsertdoc} />
				<div align="center">Ministry: {sessionStorage.getItem("MINISTRY_DESC")}</div>
				<div align="center">Department: {sessionStorage.getItem("DEPT_DESC")}</div>
				<div align="center">Tax Center: {sessionStorage.getItem("TAX_CENTRE_DESC")}</div>
				<div align="center" style={{marginTop:"9px"}} ><a href='#' className="nodecor" onClick={(e)=>{cancelreqs(e);}} ><img src='img/trash.png' height='20' border='0' /> cancel this request</a></div>
				
				</>
				}
			</div>
		</td>
		</tr>
		</tbody>
		</table>
		{
			/*
	<div align='center'  style={{position:"relative", top:"0px", "marginTop":"12px","marginBottom":"16px"}} >
	<input type='button' className='button' value='create vouchers' onClick={createVouchers} />
	</div>	
			
			*/			
		}
	  
	  </div>

      <div id="TariffExpert" className="tabcontent"  >
	  <img src="img/un.broker.asysad.client.VP_Tariffexpert.png" />
		<div id="divtariffexpert" >
		<table>
		<tbody>
		<tr valign="top" >		
		<td align="right" >Section:</td>
		<td align="left" >
		<select name="tariffexpert_hs1" onChange={(e)=>{e.preventDefault(); fetchTariffexpert('hs1');}} style={{"width":"800px"}}  >
		<option value='' > * * * list of tariff sections * * * </option>
		{tariffexpert.hs1}
		</select>
		</td>
		</tr>		
		<tr valign="top" >		
		<td align="right" >Chapter:</td>
		<td align="left" >
		<select name="tariffexpert_hs2" onChange={(e)=>{e.preventDefault(); fetchTariffexpert('hs2');}}  style={{"width":"800px"}}  >
		<option value='' > * * * list of tariff chapters * * * </option>
		{tariffexpert.hs2}
		</select>
		</td>
		</tr>		
		<tr valign="top" >		
		<td align="right" >Heading:</td>
		<td align="left" >
		<select name="tariffexpert_hs4" onChange={(e)=>{e.preventDefault(); fetchTariffexpert('hs4');}}  style={{"width":"800px"}}   >
		<option value='' > * * * list of tariff headings * * * </option>
		{tariffexpert.hs4}
		</select>
		</td>
		</tr>		
		</tbody>
		</table>
		<table align="left" border="0" id="tariffexpert_hs8" className="customers"  cellSpacing="0" cellPadding="0" >
		<thead>
		<tr>		
		<th>#</th>
		<th>Tariff Code</th>
		<th>Tariff Description</th>
		</tr>		
		</thead>
		<tbody>
		{tariffexpert.hs8}
		</tbody>
		</table>
		</div>
	  </div>
	  

      <div id="Vehicles" className="tabcontent"  >
	  <img src="img/un.broker.asysad.client.VP_Vehicle.png" />
		<table align="left" border="0" id="tblvehicles" cellSpacing="0" cellPadding="0" >
		<thead>
		<tr>		
		<th>#</th>
		<th>Doors</th>
		<th>Year</th>
		<th>Make</th>
		<th>Model</th>
		<th>Colour</th>
		<th>VIN/Chassis#</th>
		<th>Mileage</th>
		<th>Fuel</th>
		<th>Seat Pos.</th>
		<th>Engine Size</th>
		<th>Value</th>
		<th>Freight</th>
		</tr>		
		</thead>
		<tbody>
		{tblvehicles}
		</tbody>
		</table>
	  
	  </div>
	  
</td>
</tr>
</tbody>
</table>




	
	  
<div id="tblverifyerrors" border="0" >
<img src="img/transparent.png" height="207" width="933" useMap="#tblvfyerr-image-map" />

<map name="tblvfyerr-image-map"  >
    <area target="" title="close this window" href="#" onClick={(e)=>{closetblverifyerrors(e);}} coords="927,28,906,3" shape="rect" />
</map>
<table align="center" >
<thead>
	<tr key="tblvfyerr_tr0" >
		<th></th>
		<th>&nbsp;</th>
	</tr>
</thead>
<tbody>
	{verifyerrors.htm}
</tbody>
</table>
</div>





<div id="modalVouchers" className="modal"  >
	<div className='modal-header'>  
	<span className='close' onClick={(e)=>{e.preventDefault();closemodal('modalVouchers',0)}} >&times;</span>  
		<div align='center' style={{"marginLeft":"auto","marginRight":"auto"}} >  
		<h2 style={{"marginTop":"9px","marginBottom":"9px"}} >download vouchers (click pdf icon)</h2>  
		<div id='waitpdf' >waiting for pdf files {doctime}</div>
		</div>  
	</div>  
<table align="center" className="tblvouchers" >
<thead>
	<tr> 
	<th>#</th> 
	<th>Date</th> 
	<th>Voucher #</th> 
	<th>Amount</th> 
	<th title='click to download voucher' >Dl</th> 
	<th align='left' >Tax Name</th> 
	<th align='left' >Entry #s</th> 
	</tr>
</thead>
<tbody>
{tblvoucherstopay.htm}
</tbody>
</table>
</div>	
	

<div id="snackbar" ></div>



{/*
<input type='text'  
id='button1'
type='button'
value="click this button"
style={{"visibility":"hidden"}}
onClick={(e)=>{e.preventDefault(); voucherfileexists();} } /> 
*/}



</div>
  


  
}//end class







export default RenderSad;